const translations = {
  it: {
    // Menu e navigazione
    calculator: "Crea il tuo Liquido",
    baseCalculator: "Laboratorio Liquidi",
    shotMixSeries: "Shot/Mix Series",
    recipes: "Le mie Ricette",
    aromaDilution: "Diluizione Aroma",
    settings: "Impostazioni",
    blogVape: "Blog Vape",
    vapeNewsTitle: "News & Trends dal Mondo dello Svapo",
    aggiorna: "Aggiorna",
    caricamento: "Caricamento...",
    nessunArticolo: "Nessun articolo disponibile",

    calculating: "Calcolo in corso...",
    processingRequest: "Elaborazione richiesta...",

    // Error Messages
    invalidInput: "Input non valido",
    numberRequired: "Inserire un numero valido",
    valueOutOfRange: "Valore fuori range",

    // Success Messages
    calculationComplete: "Calcolo completato",

    // Advanced Mode
    advancedModeWarning:
      "La modalità avanzata fornisce informazioni tecniche aggiuntive",
    powerLimitWarning:
      "Attenzione: Verificare i limiti di potenza della batteria",

    // Tooltips
    targetResistanceTooltip: "Resistenza obiettivo desiderata in ohm",
    wrapsTooltip: "Numero di avvolgimenti completi",
    innerDiameterTooltip: "Diametro interno della spirale",
    legLengthTooltip: "Lunghezza dei terminali della resistenza",

    // Unit Labels

    ohm: "Ω",
    mm: "mm",
    awg: "AWG",
    wraps: "giri",
    watts: "W",
    amps: "A",
    volts: "V",

    ohmCalculator: "Calcolatore Ohm",
    voltage: "Tensione",
    resistance: "Resistenza",
    current: "Corrente",
    power: "Potenza",
    selectPreset: "Seleziona Stile di Svapo",
    mtlBasicPreset: "MTL Base (Principianti)",
    mtlSaltPreset: "MTL Sali di Nicotina",
    rdlMediumPreset: "RDL Medio",
    dlCloudPreset: "DL Cloud Chasing",
    dlFlavorPreset: "DL Flavor Chasing",
    customPreset: "Personalizzato",
    mtlBasicDescription: "Setup classico per iniziare, simile alla sigaretta",
    mtlSaltDescription: "Ottimizzato per liquidi con sali di nicotina",
    rdlMediumDescription: "Bilanciato tra gusto e vapore",
    dlCloudDescription: "Massima produzione di vapore",
    dlFlavorDescription: "Ottimizzato per massimo gusto",
    customDescription: "Inserisci i tuoi valori personalizzati",
    consumptionEstimates: "Stime dei Consumi",
    puffsPerDay: "Tiri al Giorno",
    puffDuration: "Durata del Tiro",
    batteryCapacity: "Capacità Batteria",
    seconds: "sec",
    calculate: "Calcola",
    clear: "Pulisci",
    estimatedLiquidConsumption: "Consumo di Liquido Stimato",
    estimatedBatteryLife: "Durata Stimata Batteria",
    hours: "ore",
    days: "giorni",
    vapingTips: "Consigli per lo Svapo",
    mtlTip:
      "MTL (tiro di guancia): ideale per ex fumatori e liquidi con nicotina",
    rdlTip:
      "RDL (tiro intermedio): perfetto per chi vuole più gusto mantenendo un tiro confortevole",
    dlTip:
      "DL (tiro diretto): massima produzione di vapore e intensità di gusto",
    nicSaltTip: "Per i sali di nicotina, mantieni la potenza sotto i 20W",
    powerTip:
      "Aumenta gradualmente la potenza fino a trovare il tuo sweet spot",
    calculationError: "Inserisci almeno due valori per il calcolo",

    // Calcolatore principale
    quantity: "Quantità",
    finalQuantity: "Quantità finale desiderata",
    finalComposition: "Composizione finale",
    nicotine: "Nicotina",
    desiredNicotine: "Nicotina desiderata",
    availableBaseStrength: "Gradazione basette disponibili",
    nicotineComposition: "Composizione nicotina",
    aromas: "Aromi",
    addAroma: "Aggiungi % Aroma",
    calculate: "Calcola",
    createMixLiquids: "Crea un Mix dei tuoi Liquidi",
    base1: "Base 1",
    base2: "Base 2",
    baseStrength: "Gradazione Base",
    shareRecipe: "Condividi Ricetta",
    recipeShared: "Ricetta condivisa!",
    shareRecipeTitle: "Condividi la tua ricetta e-liquid",
    shareRecipeText: "Ecco la mia ricetta per e-liquid:\n\n{details}",
    shareDialogTitle: "Condividi con",
    noResultToShare:
      "Nessun risultato da condividere. Calcola prima una ricetta.",
    shareError:
      "Si è verificato un errore durante la condivisione della ricetta.",
    shareSuccess: "Ricetta condivisa",
    cookieConsentText:
      "Vape Formula Pro utilizza cookie per migliorare l'esperienza e mostrare pubblicità personalizzate.",
    cookieConsentDetails:
      "L'app è riservata ai maggiori di 18 anni. Cliccando \"Accetto\", acconsenti all'uso dei cookie. Consulta la nostra Politica sulla Privacy per maggiori dettagli.",
    accept: "Accetto",

    // Risultati del calcolo
    resultSummary:
      "Per realizzare {totalAmount}ml {vgPgRatio} a {targetNic}mg di nicotina hai bisogno:",
    baseToUse: "Base totale da utilizzare",
    baseVG: "VG della base",
    basePG: "PG della base",
    nicotineBase: "Basette di Nicotina",
    flaconi: "Flaconi",
    from: "da",
    aroma: "Aroma",
    withAroma: "con {percentage}% di Aroma",

    // Modalità avanzata/semplice
    simpleMode: "Modalità Semplice",
    advancedMode: "Modalità Avanzata",
    saveRecipe: "Salva Ricetta",
    exportToPDF: "Esporta PDF",
    recipeSaved: "Ricetta salvata!",
    neutralBase: "Base neutra",
    toUse: "da utilizzare",
    nicotineBase: "Base Nicotina",
    bottles: "flaconi",
    aromas: "Aroma",
    resultInfo: "Le quantità sono calcolate sia in millilitri che in grammi...",
    liquidComposition: "Composizione del liquido",
    advancedDetails: "Dettagli avanzati",
    baseComposition: "Composizione Base",
    nicotineComposition: "Composizione Nicotina",
    aromaComposition: "Composizione Aroma",
    totals: "Totali",
    totalVG: "VG totale",
    totalPG: "PG totale",
    ofTheBase: "della base",
    ofAroma: "dell'aroma",
    actualFinalComposition: "Composizione finale effettiva",
    nicotineBaseComposition: "Composizione della nicotina",
    nicotineVG: "VG della nicotina",
    nicotinePG: "PG della nicotina",
    totalOverall: "Totale complessivo",
    enterValue: "Inserisci Valore",
    mixBasesResult: "Risultato del mix di basi:",

    coilCalculator: "Calcolatore Coil",
    targetResistanceMode: "Modalità Resistenza Target",
    calculateResistanceMode: "Modalità Calcolo Resistenza",
    wireType: "Tipo di Filo",
    wireConfiguration: "Configurazione Filo",
    coilSetup: "Setup Coil",
    ribbonThickness: "Spessore Ribbon",
    ribbonWidth: "Larghezza Ribbon",
    wireDiameterAWG: "Diametro Filo (AWG)",
    wireDiameterMM: "Diametro Filo (mm)",
    targetResistance: "Resistenza Target",
    numberOfWraps: "Numero di Avvolgimenti",
    innerCoilDiameter: "Diametro Interno Coil",
    legLength: "Lunghezza Terminali",
    batteryVoltage: "Voltaggio Batteria",
    hideAdvancedInfo: "Nascondi Info Avanzate",
    showAdvancedInfo: "Mostra Info Avanzate",
    calculateWraps: "Calcola Avvolgimenti",
    calculateResistance: "Calcola Resistenza",
    wireLength: "Lunghezza Filo",
    calculatedWraps: "Avvolgimenti Calcolati",
    suggestedWraps: "Avvolgimenti Suggeriti",
    halfWrapOption: "Opzione Mezzo Giro",
    actualResistance: "Resistenza Effettiva",
    calculatedResistance: "Resistenza Calcolata",
    legLoss: "Perdita Terminali",
    heatCapacity: "Capacità Termica",
    temperatureFactor: "Fattore Temperatura",
    surfaceArea: "Area Superficie",
    currentDraw: "Assorbimento Corrente",
    power: "Potenza",
    warningHighLegLoss:
      "Attenzione: La perdita dei terminali è molto alta. Considera di ridurre la lunghezza.",
    warningSignificantLegLoss:
      "Nota: La perdita dei terminali è significativa. Potresti voler ottimizzare la lunghezza.",

    totalVolumeD: "Volume totale: {volume}ml ({grams}g)",

    finalCompositionD: "Composizione finale: {ratio} VG/PG",

    finalStrengthD: "Gradazione finale: {strength}mg/ml",

    // Diluizione Aroma
    calculateAromaDilution: "Calcola la Diluizione del tuo Aroma",
    aromaAmount: "Quantità di Aroma",
    dilutionPercentage: "Percentuale di Diluizione",
    dilutionResult:
      "Per avere una concentrazione di aroma al {percentage}% nel tuo liquido hai bisogno di un totale di:",

    // Laboratorio Liquidi
    increaseReduceStrength: "Aumenta o Riduci la tua Gradazione",
    currentBase: "Liquido attuale",
    currentNicotineStrength: "Gradazione di nicotina attuale",
    desiredNicotineStrength: "Gradazione di nicotina desiderata",
    calculateBase: "Calcola Liquido",
    privacyPolicy: "Informativa sulla privacy",
    viewPrivacyPolicy: "Visualizza l'informativa sulla privacy",

    // Shot/Mix Series
    composeShotMixSeries: "Componi il tuo Shot/Mix Series",
    shotMixFrom: "Shot/Mix da:",
    readyEliquidFrom: "Quantità finale del tuo Eliquid:",
    inhalationType: "Tipo di tiro",
    mtl: "Tiro di guancia (MTL)",
    dl: "Tiro polmonare (DL)",
    shotMixResult:
      "Per ottenere {finalVolume}ml di Eliquid pronto all'uso con una concentrazione di nicotina di {desiredNicotine}mg/ml, hai bisogno:",
    yourAroma: "Il tuo aroma",
    neutralBase: "Base neutra",

    // Impostazioni
    language: "Lingua",
    vapingEducativo: "Vaping Educativo",
    usoResponsabile: "Uso Responsabile del Vaping",
    usoResponsabileContent:
      "Il vaping non è un gioco: utilizzarlo in modo responsabile significa conoscere i propri limiti e rispettare le proprie necessità. Assicurati di utilizzare solo dispositivi di qualità e segui le istruzioni di sicurezza. Se sei interessato solo ai gusti, considera l'uso di liquidi senza nicotina per evitare rischi inutili. Il vaping è una scelta molto meno dannosa rispetto al fumo tradizionale e può essere un grande aiuto per chi desidera smettere di fumare gradualmente.",
    usoNicotina: "Uso della Nicotina",
    usoNicotinaContent:
      "La nicotina è una sostanza potente che crea dipendenza, ma può essere gestita in modo intelligente con il vaping. Se stai passando dalle sigarette al vaping, inizia con una concentrazione di nicotina simile a quella che eri solito consumare. Riduci gradualmente il livello per distaccarti lentamente dalla dipendenza. Grazie al vaping, puoi scegliere con precisione il livello di nicotina e abbassarlo progressivamente fino a zero, migliorando il tuo benessere senza lo stress delle sigarette tradizionali.",
    smettereDiscutetere: "Come Smettere di Fumare le Sigarette Tradizionali",
    smettereDiscutetereContent:
      "Smettere di fumare non è facile, ma il vaping può essere un supporto valido e meno traumatico. Utilizzare una e-cigarette con un livello di nicotina inizialmente simile a quello delle sigarette tradizionali può aiutare a soddisfare la dipendenza fisica senza gli effetti nocivi del catrame e delle altre sostanze chimiche presenti nel fumo tradizionale. Una volta stabilizzato, puoi ridurre gradualmente il livello di nicotina fino a raggiungere lo zero. Questo approccio graduale aiuta a ridurre il desiderio di fumare senza affrontare uno shock improvviso, migliorando progressivamente la tua qualità di vita.",
    faq: "Domande Frequenti",
    faqList: [
      {
        q: "Il vaping è sicuro?",
        a: "Il vaping è considerato significativamente meno dannoso rispetto al fumo tradizionale, poiché non produce catrame né altre sostanze chimiche cancerogene presenti nelle sigarette. Utilizzando solo prodotti certificati e seguendo le raccomandazioni degli esperti, il vaping è un'alternativa più sicura per chi desidera smettere di fumare.",
      },
      {
        q: "Il vaping può causare dipendenza?",
        a: "Sì, il vaping può causare dipendenza se si utilizzano liquidi contenenti nicotina. Tuttavia, grazie al vaping, è possibile controllare il livello di nicotina e ridurlo gradualmente fino a eliminarlo del tutto, rendendolo uno strumento efficace per smettere definitivamente di fumare.",
      },
      {
        q: "Il vaping è adatto per smettere di fumare?",
        a: "Molte persone hanno smesso di fumare grazie al vaping. L'importante è usarlo come strumento di transizione, riducendo gradualmente la nicotina fino a eliminarla del tutto. Il vaping permette di avere un controllo preciso sulla quantità di nicotina consumata, rendendo il percorso di cessazione del fumo più gestibile e meno stressante.",
      },
      {
        q: "Quali sono gli effetti a lungo termine del vaping?",
        a: "Gli effetti a lungo termine del vaping sono ancora in fase di studio, ma è ampiamente riconosciuto che è significativamente meno dannoso rispetto al fumo di sigarette tradizionali. Eliminando catrame e altre sostanze tossiche, il vaping rappresenta una scelta più salutare per chi desidera abbandonare il fumo.",
      },
      {
        q: "Il vaping migliora la qualità della vita rispetto al fumo tradizionale?",
        a: "Sì, il vaping migliora notevolmente la qualità della vita rispetto al fumo tradizionale. Non solo riduce l'esposizione a sostanze chimiche nocive, ma permette anche di eliminare gradualmente la dipendenza dalla nicotina, migliorando la salute polmonare e la capacità respiratoria.",
      },
    ],
    beneficiSmettere: "Benefici di Smettere di Fumare nel Tempo",
    beneficiSmettereList: [
      "Dopo 48 ore: Il tuo corpo inizia a eliminare la nicotina e il gusto e l'olfatto iniziano a migliorare.",
      "Dopo 1 settimana: I livelli di monossido di carbonio nel sangue si riducono, migliorando la circolazione e la capacità respiratoria.",
      "Dopo 1 mese: La tua capacità polmonare migliora visibilmente e il rischio di infezioni polmonari diminuisce.",
      "Dopo 3-9 mesi: La tosse e la difficoltà respiratoria diminuiscono, migliorando ulteriormente la tua qualità di vita.",
      "Dopo 1 anno: Il rischio di malattie cardiache è dimezzato rispetto a quando fumavi.",
      "Dopo 5 anni: Il rischio di ictus è simile a quello di una persona che non ha mai fumato.",
      "Dopo 10 anni: Il rischio di cancro ai polmoni si riduce drasticamente, quasi alla metà rispetto a un fumatore.",
    ],
    mitiEFatti: "Miti e Fatti sul Vaping",
    mitiEFattiList: [
      {
        mito: "Il vaping fa male quanto il fumo.",
        fatto:
          "Studi mostrano che il vaping è significativamente meno dannoso rispetto al fumo tradizionale. Il fumo produce oltre 7.000 sostanze chimiche, molte delle quali sono cancerogene, mentre il vaping riduce drasticamente questo numero, offrendo un'alternativa più sicura.",
      },
      {
        mito: "Il vaping causa problemi ai polmoni come il fumo.",
        fatto:
          "Il vaping non produce catrame, uno dei principali responsabili dei danni ai polmoni provocati dalle sigarette. Utilizzando liquidi di qualità e rispettando le linee guida, il vaping è una scelta decisamente meno dannosa per la salute polmonare.",
      },
      {
        mito: "Il vaping non aiuta a smettere di fumare.",
        fatto:
          "Molte persone hanno smesso di fumare grazie al vaping. Con il giusto approccio e riducendo gradualmente la nicotina, il vaping può essere uno strumento efficace per liberarsi dalla dipendenza dalle sigarette tradizionali, migliorando la propria salute e qualità della vita.",
      },
    ],

    // Tooltip
    dilutionTooltip:
      "Calcola la tua quantità di liquido totale per raggiungere la % di concentrazione di aroma da te desiderata",
    nicotineTooltip:
      'Se desideri un liquido a 0mg, oppure hai una base gia nicotizzata, inserisci "0" in questo campo',
    aromaTooltip:
      "Inserisci qui la % di diluizione del tuo aroma e scopri quanti ML inserire nel tuo liquido",
    resultTooltip:
      'Il dato del totale, sarà utile in "QUANTITÀ finale desiderata" nell\'apposito calcolatore',
    mixTooltip:
      "Calcola la gradazione e la composizione finale miscelando due liquidi. Si consiglia di usare liquidi senza aroma per evitare di alterare il sapore.",
    compositionTooltip:
      "La composizione finale potrebbe differire leggermente da quella desiderata. Questo è normale e garantisce il miglior risultato possibile considerando le composizioni e la compensazione di tutti gli ingredienti (base, nicotina e aroma). Il calcolo ottimizza le quantità per avvicinarsi il più possibile alla composizione desiderata.",
    resultInfo:
      "Le quantità sono calcolate sia in millilitri che in grammi. I valori in grammi si basano su dati ufficiali di densità per offrire un'opzione di misurazione alternativa, utile quando non si dispone di un misurino",
    nicotineStrengthInfo:
      "Usa questo campo solo in caso di aumento altrimenti ignoralo",

    // Pulsanti e azioni
    saveRecipe: "Salva Ricetta",
    exportToPDF: "Esporta in PDF",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    adjustNicotine: "Regola Gradazione Nicotina",
    mixYourBases: "Miscela le tue basi",
    strength: "Gradazione (mg/ml)",
    savedRecipes: "Ricette salvate",
    finalNicotineStrength: "Forza finale della Nicotina",

    // Messaggi
    recipeSaved: "Ricetta salvata!",
    noSavedRecipes: "Nessuna ricetta salvata.",
    nameYourRecipe: "Dai un nome alla tua Ricetta",

    // Unità di misura
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // Altri
    vg: "VG",
    pg: "PG",
    createdOn: "Creata il",
    increaseNicotineMessage:
      "Per aumentare il tuo liquido a {strength}mg di nicotina aggiungi:",
    decreaseNicotineMessage:
      "Per ridurre il tuo liquido a {strength}mg di nicotina aggiungi:",
    addNicotineBase:
      "{volume}ml di nicotina {composition} a {strength}mg/ml ({flacons} flaconi da 10ml{extraMl}) ({grams}g) al tuo liquido attuale",
    addNeutralBase:
      "{volume}ml di base neutra {composition} (0mg/ml) ({grams}g) al tuo liquido attuale",
    extraMl: " + {amount}ml",
    finalVolumeN: "Volume finale: {volume}ml ({grams}g)",
    finalVolumeL: "Volume finale: {volume}ml ({grams}g)",

    // Nuove chiavi aggiunte
    mixYourBases: "Mixa le tue Basi",
    adjustNicotineConcentration: "Regola Concentrazione Nicotina",
    base1: "Base 1",
    base2: "Base 2",
    base1Strength: "Gradazione Base 1",
    base2Strength: "Gradazione Base 2",
    base1Composition: "Composizione Base 1",
    base2Composition: "Composizione Base 2",
    calculateMix: "Calcola Mix",
    availableNicotine: "Nicotina disponibile",
    desiredFinalQuantity: "Quantità finale desiderata",
    baseAndPercentage: "%",
    dilutionResultSummary:
      "Per avere una concentrazione di aroma al {percentage}% nel tuo liquido hai bisogno di un totale di {total}ml ({baseToAdd}ml di base + {aroma}ml di aroma)",
    dilutionResultDetails:
      "{total} ml di liquido ({baseToAdd}ml di base + {aroma}ml di aroma)",

    quickGuideTitle: "Guida all'Utilizzo del Calcolatore",
    modesExplained: "Le Due Modalità di Calcolo",
    targetModeTitle: "Modalità Target",
    targetModeExplanation:
      "Usa questa modalità quando sai quale resistenza vuoi ottenere (es. 0.5Ω). Inserisci il valore desiderato e il calcolatore ti dirà: \n- Quanti giri fare \n- Quanto filo utilizzare \n- La resistenza effettiva che otterrai",
    calculateModeTitle: "Modalità Calcolo",
    calculateModeExplanation:
      "Usa questa modalità quando sai quanti giri vuoi fare. Inserisci il numero di avvolgimenti e scopri che resistenza otterrai. Utile quando hai uno spazio limitato o preferisci lavorare con un numero specifico di giri.",

    inputFieldsGuide: "Guida ai Campi di Input",
    innerDiameterTitle: "Diametro Interno della Coil",
    innerDiameterExplanation:
      "Il diametro su cui avvolgerai il filo. Di solito corrisponde al diametro del cacciavite che userai per l'avvolgimento.",
    legLengthTitle: "Lunghezza Terminali",
    legLengthExplanation:
      "I 'piedini' della resistenza che inserirai nei morsetti. Consigliato: 5-6mm per minimizzare le perdite.",

    advancedExplained: "Spiegazione Modalità Avanzata",
    powerCalcsTitle: "Calcoli di Potenza",
    powerCalcsExplanation:
      "- Voltaggio Batteria: tipicamente 4.2V per una batteria carica\n- Assorbimento Corrente: quanto corrente attraverserà la coil\n- Potenza: la potenza effettiva che svilupperà la coil",
    thermalFactorsTitle: "Fattori Termici",
    thermalFactorsExplanation:
      "- Capacità Termica: quanto calore può accumulare la coil\n- Area Superficie: superficie di contatto con il liquido\n- Fattore Temperatura: come il materiale si comporta al calore",

    resultsExplained: "Come Interpretare i Risultati",
    basicResultsTitle: "Risultati Base",
    basicResultsList:
      "Lunghezza Filo: quanto filo totale ti servirà\nAvvolgimenti Calcolati: numero preciso di giri\nAvvolgimenti Suggeriti: numero arrotondato pratico da realizzare\nOpzione Mezzo Giro: alternativa per regolare fine\nResistenza Effettiva: valore finale che misurerai",

    warningsTitle: "Avvisi Importanti",
    warningsList:
      "Perdita Terminali > 30%: terminali troppo lunghi, riduci\nPerdita Terminali > 20%: considera di ottimizzare\nLa resistenza effettiva potrebbe variare leggermente nella pratica",

    practicalTips: "Consigli Pratici",
    practicalTipsList:
      "Inizia con fili Kanthal A1 per la maggiore stabilità\nPer principianti: target tra 0.5Ω e 1.5Ω\nMisura sempre la resistenza con un ohmetro\nIn dual coil, la resistenza totale sarà la metà di quella singola",
  },

  es: {
    // Menú y navegación
    calculator: "Crea tu Líquido",
    baseCalculator: "Laboratorio de Líquidos",
    shotMixSeries: "Serie Shot/Mix",
    recipes: "Mis Recetas",
    aromaDilution: "Dilución de Aroma",
    settings: "Configuración",
    blogVape: "Blog Vape",
    vapeNewsTitle: "Noticias y Tendencias del Mundo del Vapeo",
    aggiorna: "Actualizar",
    caricamento: "Cargando...",
    nessunArticolo: "No hay artículos disponibles",

    calculating: "Calculando...",
    processingRequest: "Procesando solicitud...",

    // Mensajes de Error
    invalidInput: "Entrada no válida",
    numberRequired: "Ingrese un número válido",
    valueOutOfRange: "Valor fuera de rango",

    // Mensajes de Éxito
    calculationComplete: "Cálculo completado",

    // Modo Avanzado
    advancedModeWarning:
      "El modo avanzado proporciona información técnica adicional",
    powerLimitWarning:
      "Atención: Verifique los límites de potencia de la batería",

    // Tooltips
    targetResistanceTooltip: "Resistencia objetivo deseada en ohmios",
    wrapsTooltip: "Número de vueltas completas",
    innerDiameterTooltip: "Diámetro interno de la espiral",
    legLengthTooltip: "Longitud de los terminales de la resistencia",

    // Etiquetas de Unidad
    units: {
      ohm: "Ω",
      mm: "mm",
      awg: "AWG",
      wraps: "vueltas",
      watts: "W",
      amps: "A",
      volts: "V",
    },

    ohmCalculator: "Calculadora de Ohm",
    voltage: "Voltaje",
    resistance: "Resistencia",
    current: "Corriente",
    power: "Potencia",
    selectPreset: "Seleccionar Estilo de Vapeo",
    mtlBasicPreset: "MTL Básico (Principiantes)",
    mtlSaltPreset: "MTL Sales de Nicotina",
    rdlMediumPreset: "RDL Medio",
    dlCloudPreset: "DL Persiguiendo Nubes",
    dlFlavorPreset: "DL Persiguiendo Sabor",
    customPreset: "Personalizado",
    mtlBasicDescription:
      "Configuración clásica para comenzar, similar al cigarrillo",
    mtlSaltDescription: "Optimizado para líquidos con sales de nicotina",
    rdlMediumDescription: "Equilibrado entre sabor y vapor",
    dlCloudDescription: "Máxima producción de vapor",
    dlFlavorDescription: "Optimizado para máximo sabor",
    customDescription: "Ingresa tus valores personalizados",
    consumptionEstimates: "Estimaciones de Consumo",
    puffsPerDay: "Caladas por Día",
    puffDuration: "Duración de la Calada",
    batteryCapacity: "Capacidad de la Batería",
    seconds: "seg",
    calculate: "Calcular",
    clear: "Limpiar",
    estimatedLiquidConsumption: "Consumo Estimado de Líquido",
    estimatedBatteryLife: "Duración Estimada de la Batería",
    hours: "horas",
    days: "días",
    vapingTips: "Consejos para Vapear",
    mtlTip:
      "MTL (calada de boca): ideal para ex fumadores y líquidos con nicotina",
    rdlTip:
      "RDL (calada intermedia): perfecto para quien quiere más sabor manteniendo una calada cómoda",
    dlTip:
      "DL (calada directa): máxima producción de vapor e intensidad de sabor",
    nicSaltTip: "Para sales de nicotina, mantén la potencia por debajo de 20W",
    powerTip:
      "Aumenta gradualmente la potencia hasta encontrar tu punto óptimo",
    calculationError: "Ingresa al menos dos valores para el cálculo",

    // Calculadora principal
    quantity: "Cantidad",
    finalQuantity: "Cantidad final deseada",
    finalComposition: "Composición final",
    nicotine: "Nicotina",
    desiredNicotine: "Nicotina deseada",
    availableBaseStrength: "Concentración de bases disponibles",
    nicotineComposition: "Composición de nicotina",
    aromas: "Aromas",
    addAroma: "Agregar % de Aroma",
    calculate: "Calcular",
    createMixLiquids: "Crear una Mezcla de tus Líquidos",
    base1: "Base 1",
    base2: "Base 2",
    baseStrength: "Concentración Base",
    shareRecipe: "Compartir Receta",
    recipeShared: "¡Receta compartida!",
    shareRecipeTitle: "Comparte tu receta de e-líquido",
    shareRecipeText: "Aquí está mi receta de e-líquido:\n\n{details}",
    shareDialogTitle: "Compartir con",
    noResultToShare:
      "No hay resultados para compartir. Calcula primero una receta.",
    shareError: "Se produjo un error al compartir la receta.",
    shareSuccess: "Receta compartida",
    cookieConsentText:
      "Vape Formula Pro utiliza cookies para mejorar la experiencia y mostrar publicidad personalizada.",
    cookieConsentDetails:
      'La aplicación está reservada para mayores de 18 años. Al hacer clic en "Aceptar", aceptas el uso de cookies. Consulta nuestra Política de Privacidad para más detalles.',
    accept: "Aceptar",

    // Resultados del cálculo
    resultSummary:
      "Para realizar {totalAmount}ml {vgPgRatio} a {targetNic}mg de nicotina necesitas:",
    baseToUse: "Base total a utilizar",
    baseVG: "VG de la base",
    basePG: "PG de la base",
    nicotineBase: "Bases de Nicotina",
    flaconi: "Frascos",
    from: "de",
    aroma: "Aroma",
    withAroma: "con {percentage}% de Aroma",

    // Modo avanzado/simple
    simpleMode: "Modo Simple",
    advancedMode: "Modo Avanzado",
    saveRecipe: "Guardar Receta",
    exportToPDF: "Exportar PDF",
    recipeSaved: "¡Receta guardada!",
    neutralBase: "Base neutra",
    toUse: "para usar",
    nicotineBase: "Base de Nicotina",
    bottles: "frascos",
    aromas: "Aroma",
    resultInfo:
      "Las cantidades se calculan tanto en mililitros como en gramos...",
    liquidComposition: "Composición del líquido",
    advancedDetails: "Detalles avanzados",
    baseComposition: "Composición Base",
    nicotineComposition: "Composición Nicotina",
    aromaComposition: "Composición Aroma",
    totals: "Totales",
    totalVG: "VG total",
    totalPG: "PG total",
    ofTheBase: "de la base",
    ofAroma: "del aroma",
    actualFinalComposition: "Composición final efectiva",
    nicotineBaseComposition: "Composición de la nicotina",
    nicotineVG: "VG de la nicotina",
    nicotinePG: "PG de la nicotina",
    totalOverall: "Total general",
    enterValue: "Ingresar Valor",
    mixBasesResult: "Resultado de la mezcla de bases:",

    coilCalculator: "Calculadora de Resistencias",
    targetResistanceMode: "Modo Resistencia Objetivo",
    calculateResistanceMode: "Modo Cálculo de Resistencia",
    wireType: "Tipo de Alambre",
    wireConfiguration: "Configuración del Alambre",
    coilSetup: "Configuración de la Resistencia",
    ribbonThickness: "Espesor del Ribbon",
    ribbonWidth: "Ancho del Ribbon",
    wireDiameterAWG: "Diámetro del Alambre (AWG)",
    wireDiameterMM: "Diámetro del Alambre (mm)",
    targetResistance: "Resistencia Objetivo",
    numberOfWraps: "Número de Vueltas",
    innerCoilDiameter: "Diámetro Interno de la Resistencia",
    legLength: "Longitud de las Patas",
    batteryVoltage: "Voltaje de la Batería",
    hideAdvancedInfo: "Ocultar Info Avanzada",
    showAdvancedInfo: "Mostrar Info Avanzada",
    calculateWraps: "Calcular Vueltas",
    calculateResistance: "Calcular Resistencia",
    wireLength: "Longitud del Alambre",
    calculatedWraps: "Vueltas Calculadas",
    suggestedWraps: "Vueltas Sugeridas",
    halfWrapOption: "Opción Media Vuelta",
    actualResistance: "Resistencia Real",
    calculatedResistance: "Resistencia Calculada",
    legLoss: "Pérdida en las Patas",
    heatCapacity: "Capacidad Térmica",
    temperatureFactor: "Factor de Temperatura",
    surfaceArea: "Área de Superficie",
    currentDraw: "Consumo de Corriente",
    power: "Potencia",
    warningHighLegLoss:
      "Atención: La pérdida en las patas es muy alta. Considera reducir la longitud.",
    warningSignificantLegLoss:
      "Nota: La pérdida en las patas es significativa. Podrías optimizar la longitud.",

    totalVolumeD: "Volumen total: {volume}ml ({grams}g)",
    finalCompositionD: "Composición final: {ratio} VG/PG",
    finalStrengthD: "Concentración final: {strength}mg/ml",

    // Dilución de Aroma
    calculateAromaDilution: "Calcula la Dilución de tu Aroma",
    aromaAmount: "Cantidad de Aroma",
    dilutionPercentage: "Porcentaje de Dilución",
    dilutionResult:
      "Para tener una concentración de aroma al {percentage}% en tu líquido necesitas un total de:",

    // Laboratorio de Líquidos
    increaseReduceStrength: "Aumenta o Reduce tu Concentración",
    currentBase: "Líquido actual",
    currentNicotineStrength: "Concentración de nicotina actual",
    desiredNicotineStrength: "Concentración de nicotina deseada",
    calculateBase: "Calcular Líquido",
    privacyPolicy: "Política de privacidad",
    viewPrivacyPolicy: "Ver la política de privacidad",

    // Shot/Mix Series
    composeShotMixSeries: "Compón tu Serie Shot/Mix",
    shotMixFrom: "Shot/Mix de:",
    readyEliquidFrom: "Cantidad final de tu E-líquido:",
    inhalationType: "Tipo de calada",
    mtl: "Calada de boca (MTL)",
    dl: "Calada directa (DL)",
    shotMixResult:
      "Para obtener {finalVolume}ml de E-líquido listo para usar con una concentración de nicotina de {desiredNicotine}mg/ml, necesitas:",
    yourAroma: "Tu aroma",
    neutralBase: "Base neutra",

    // Configuración
    language: "Idioma",
    vapingEducativo: "Educación sobre Vapeo",
    usoResponsabile: "Uso Responsable del Vapeo",
    usoResponsabileContent:
      "El vapeo no es un juego: usarlo responsablemente significa conocer tus límites y respetar tus necesidades. Asegúrate de usar solo dispositivos de calidad y sigue las instrucciones de seguridad. Si solo te interesan los sabores, considera usar líquidos sin nicotina para evitar riesgos innecesarios. El vapeo es una opción mucho menos dañina que el tabaco tradicional y puede ser una gran ayuda para quienes desean dejar de fumar gradualmente.",
    usoNicotina: "Uso de la Nicotina",
    usoNicotinaContent:
      "La nicotina es una sustancia potente que crea dependencia, pero puede gestionarse de manera inteligente con el vapeo. Si estás pasando de los cigarrillos al vapeo, comienza con una concentración de nicotina similar a la que solías consumir. Reduce gradualmente el nivel para desengancharte lentamente de la dependencia. Gracias al vapeo, puedes elegir con precisión el nivel de nicotina y bajarlo progresivamente hasta cero, mejorando tu bienestar sin el estrés de los cigarrillos tradicionales.",
    smettereDiscutetere: "Cómo Dejar de Fumar Cigarrillos Tradicionales",
    smettereDiscutetereContent:
      "Dejar de fumar no es fácil, pero el vapeo puede ser un apoyo válido y menos traumático. Usar un cigarrillo electrónico con un nivel de nicotina inicialmente similar al de los cigarrillos tradicionales puede ayudar a satisfacer la dependencia física sin los efectos nocivos del alquitrán y otras sustancias químicas presentes en el humo tradicional. Una vez estabilizado, puedes reducir gradualmente el nivel de nicotina hasta llegar a cero. Este enfoque gradual ayuda a reducir el deseo de fumar sin enfrentar un shock repentino, mejorando progresivamente tu calidad de vida.",

    faq: "Preguntas Frecuentes",
    faqList: [
      {
        q: "¿Es seguro el vapeo?",
        a: "El vapeo se considera significativamente menos dañino que el tabaco tradicional, ya que no produce alquitrán ni otras sustancias químicas cancerígenas presentes en los cigarrillos. Utilizando solo productos certificados y siguiendo las recomendaciones de los expertos, el vapeo es una alternativa más segura para quienes desean dejar de fumar.",
      },
      {
        q: "¿El vapeo puede causar adicción?",
        a: "Sí, el vapeo puede causar adicción si se utilizan líquidos que contienen nicotina. Sin embargo, gracias al vapeo, es posible controlar el nivel de nicotina y reducirlo gradualmente hasta eliminarlo por completo, convirtiéndolo en una herramienta eficaz para dejar de fumar definitivamente.",
      },
      {
        q: "¿El vapeo es adecuado para dejar de fumar?",
        a: "Muchas personas han dejado de fumar gracias al vapeo. Lo importante es usarlo como herramienta de transición, reduciendo gradualmente la nicotina hasta eliminarla por completo. El vapeo permite tener un control preciso sobre la cantidad de nicotina consumida, haciendo que el proceso de dejar de fumar sea más manejable y menos estresante.",
      },
      {
        q: "¿Cuáles son los efectos a largo plazo del vapeo?",
        a: "Los efectos a largo plazo del vapeo aún están en estudio, pero está ampliamente reconocido que es significativamente menos dañino que fumar cigarrillos tradicionales. Al eliminar el alquitrán y otras sustancias tóxicas, el vapeo representa una opción más saludable para quienes desean abandonar el tabaco.",
      },
      {
        q: "¿El vapeo mejora la calidad de vida en comparación con el tabaco tradicional?",
        a: "Sí, el vapeo mejora notablemente la calidad de vida en comparación con el tabaco tradicional. No solo reduce la exposición a sustancias químicas nocivas, sino que también permite eliminar gradualmente la dependencia de la nicotina, mejorando la salud pulmonar y la capacidad respiratoria.",
      },
    ],
    beneficiSmettere: "Beneficios de Dejar de Fumar a lo Largo del Tiempo",
    beneficiSmettereList: [
      "Después de 48 horas: Tu cuerpo comienza a eliminar la nicotina y el gusto y el olfato comienzan a mejorar.",
      "Después de 1 semana: Los niveles de monóxido de carbono en la sangre se reducen, mejorando la circulación y la capacidad respiratoria.",
      "Después de 1 mes: Tu capacidad pulmonar mejora visiblemente y el riesgo de infecciones pulmonares disminuye.",
      "Después de 3-9 meses: La tos y la dificultad respiratoria disminuyen, mejorando aún más tu calidad de vida.",
      "Después de 1 año: El riesgo de enfermedades cardíacas se reduce a la mitad en comparación con cuando fumabas.",
      "Después de 5 años: El riesgo de derrame cerebral es similar al de una persona que nunca ha fumado.",
      "Después de 10 años: El riesgo de cáncer de pulmón se reduce drásticamente, casi a la mitad en comparación con un fumador.",
    ],
    mitiEFatti: "Mitos y Hechos sobre el Vapeo",
    mitiEFattiList: [
      {
        mito: "El vapeo es tan dañino como fumar.",
        fatto:
          "Los estudios muestran que el vapeo es significativamente menos dañino que el tabaco tradicional. El humo produce más de 7.000 sustancias químicas, muchas de las cuales son cancerígenas, mientras que el vapeo reduce drásticamente este número, ofreciendo una alternativa más segura.",
      },
      {
        mito: "El vapeo causa problemas pulmonares como el tabaco.",
        fatto:
          "El vapeo no produce alquitrán, uno de los principales responsables del daño pulmonar causado por los cigarrillos. Utilizando líquidos de calidad y respetando las pautas, el vapeo es una opción definitivamente menos dañina para la salud pulmonar.",
      },
      {
        mito: "El vapeo no ayuda a dejar de fumar.",
        fatto:
          "Muchas personas han dejado de fumar gracias al vapeo. Con el enfoque correcto y reduciendo gradualmente la nicotina, el vapeo puede ser una herramienta eficaz para liberarse de la dependencia de los cigarrillos tradicionales, mejorando la salud y la calidad de vida.",
      },
    ],

    // Tooltips
    dilutionTooltip:
      "Calcula tu cantidad total de líquido para alcanzar el % de concentración de aroma deseado",
    nicotineTooltip:
      'Si deseas un líquido de 0mg, o ya tienes una base con nicotina, ingresa "0" en este campo',
    aromaTooltip:
      "Ingresa aquí el % de dilución de tu aroma y descubre cuántos ML agregar a tu líquido",
    resultTooltip:
      'El dato del total será útil en "CANTIDAD final deseada" en la calculadora correspondiente',
    mixTooltip:
      "Calcula la concentración y composición final mezclando dos líquidos. Se recomienda usar líquidos sin aroma para evitar alterar el sabor.",
    compositionTooltip:
      "La composición final podría diferir ligeramente de la deseada. Esto es normal y garantiza el mejor resultado posible considerando las composiciones y compensación de todos los ingredientes (base, nicotina y aroma). El cálculo optimiza las cantidades para acercarse lo más posible a la composición deseada.",
    resultInfo:
      "Las cantidades se calculan tanto en mililitros como en gramos. Los valores en gramos se basan en datos oficiales de densidad para ofrecer una opción de medición alternativa, útil cuando no se dispone de un vaso medidor",
    nicotineStrengthInfo:
      "Usa este campo solo en caso de aumento, de lo contrario ignóralo",

    // Botones y acciones
    saveRecipe: "Guardar Receta",
    exportToPDF: "Exportar a PDF",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    adjustNicotine: "Ajustar Concentración de Nicotina",
    mixYourBases: "Mezclar tus Bases",
    strength: "Concentración (mg/ml)",
    savedRecipes: "Recetas guardadas",
    finalNicotineStrength: "Concentración final de Nicotina",

    // Mensajes
    recipeSaved: "¡Receta guardada!",
    noSavedRecipes: "No hay recetas guardadas.",
    nameYourRecipe: "Dale un nombre a tu Receta",

    // Unidades de medida
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // Otros
    vg: "VG",
    pg: "PG",
    createdOn: "Creada el",
    increaseNicotineMessage:
      "Para aumentar tu líquido a {strength}mg de nicotina agrega:",
    decreaseNicotineMessage:
      "Para reducir tu líquido a {strength}mg de nicotina agrega:",
    addNicotineBase:
      "{volume}ml de nicotina {composition} a {strength}mg/ml ({flacons} frascos de 10ml{extraMl}) ({grams}g) a tu líquido actual",
    addNeutralBase:
      "{volume}ml de base neutra {composition} (0mg/ml) ({grams}g) a tu líquido actual",
    extraMl: " + {amount}ml",
    finalVolumeN: "Volumen final: {volume}ml ({grams}g)",
    finalVolumeL: "Volumen final: {volume}ml ({grams}g)",

    quickGuideTitle: "Guía de Uso de la Calculadora",
    modesExplained: "Los Dos Modos de Cálculo",
    targetModeTitle: "Modo Objetivo",
    targetModeExplanation:
      "Usa este modo cuando sabes qué resistencia quieres obtener (ej. 0.5Ω). Ingresa el valor deseado y la calculadora te dirá: \n- Cuántas vueltas dar \n- Cuánto alambre usar \n- La resistencia real que obtendrás",
    calculateModeTitle: "Modo Cálculo",
    calculateModeExplanation:
      "Usa este modo cuando sabes cuántas vueltas quieres dar. Ingresa el número de vueltas y descubre qué resistencia obtendrás. Útil cuando tienes espacio limitado o prefieres trabajar con un número específico de vueltas.",

    inputFieldsGuide: "Guía de Campos de Entrada",
    innerDiameterTitle: "Diámetro Interno de la Resistencia",
    innerDiameterExplanation:
      "El diámetro sobre el que enrollarás el alambre. Generalmente corresponde al diámetro del destornillador que usarás para el enrollado.",
    legLengthTitle: "Longitud de las Patas",
    legLengthExplanation:
      "Las 'patas' de la resistencia que insertarás en los bornes. Recomendado: 5-6mm para minimizar las pérdidas.",

    advancedExplained: "Explicación del Modo Avanzado",
    powerCalcsTitle: "Cálculos de Potencia",
    powerCalcsExplanation:
      "- Voltaje de Batería: típicamente 4.2V para una batería cargada\n- Consumo de Corriente: cuánta corriente atravesará la resistencia\n- Potencia: la potencia real que desarrollará la resistencia",
    thermalFactorsTitle: "Factores Térmicos",
    thermalFactorsExplanation:
      "- Capacidad Térmica: cuánto calor puede acumular la resistencia\n- Área de Superficie: superficie de contacto con el líquido\n- Factor de Temperatura: cómo reacciona el material al calor",

    resultsExplained: "Cómo Interpretar los Resultados",
    basicResultsTitle: "Resultados Básicos",
    basicResultsList:
      "Longitud de Alambre: cuánto alambre total necesitarás\nVueltas Calculadas: número preciso de vueltas\nVueltas Sugeridas: número redondeado práctico de realizar\nOpción Media Vuelta: alternativa para ajuste fino\nResistencia Real: valor final que medirás",

    warningsTitle: "Avisos Importantes",
    warningsList:
      "Pérdida en las Patas > 30%: patas demasiado largas, reduce\nPérdida en las Patas > 20%: considera optimizar\nLa resistencia real podría variar ligeramente en la práctica",

    practicalTips: "Consejos Prácticos",
    practicalTipsList:
      "Comienza con alambre Kanthal A1 para mayor estabilidad\nPara principiantes: objetivo entre 0.5Ω y 1.5Ω\nSiempre mide la resistencia con un óhmetro\nEn resistencia dual, la resistencia total será la mitad de la individual",
  },

  pt: {
    // Menu e navegação
    calculator: "Crie seu Líquido",
    baseCalculator: "Laboratório de Líquidos",
    shotMixSeries: "Série Shot/Mix",
    recipes: "Minhas Receitas",
    aromaDilution: "Diluição de Aroma",
    settings: "Configurações",
    blogVape: "Blog Vape",
    vapeNewsTitle: "Notícias e Tendências do Mundo do Vape",
    aggiorna: "Atualizar",
    caricamento: "Carregando...",
    nessunArticolo: "Nenhum artigo disponível",

    calculating: "Calculando...",
    processingRequest: "Processando solicitação...",

    // Mensagens de Erro
    invalidInput: "Entrada inválida",
    numberRequired: "Insira um número válido",
    valueOutOfRange: "Valor fora do intervalo",

    // Mensagens de Sucesso
    calculationComplete: "Cálculo concluído",

    // Modo Avançado
    advancedModeWarning:
      "O modo avançado fornece informações técnicas adicionais",
    powerLimitWarning: "Atenção: Verifique os limites de potência da bateria",

    // Tooltips
    targetResistanceTooltip: "Resistência alvo desejada em ohms",
    wrapsTooltip: "Número de voltas completas",
    innerDiameterTooltip: "Diâmetro interno da espiral",
    legLengthTooltip: "Comprimento dos terminais da resistência",

    // Etiquetas de Unidade

    ohm: "Ω",
    mm: "mm",
    awg: "AWG",
    wraps: "voltas",
    watts: "W",
    amps: "A",
    volts: "V",

    ohmCalculator: "Calculadora de Ohm",
    voltage: "Tensão",
    resistance: "Resistência",
    current: "Corrente",
    power: "Potência",
    selectPreset: "Selecione Estilo de Vape",
    mtlBasicPreset: "MTL Básico (Iniciantes)",
    mtlSaltPreset: "MTL Sais de Nicotina",
    rdlMediumPreset: "RDL Médio",
    dlCloudPreset: "DL Cloud Chasing",
    dlFlavorPreset: "DL Flavor Chasing",
    customPreset: "Personalizado",
    mtlBasicDescription: "Setup clássico para começar, similar ao cigarro",
    mtlSaltDescription: "Otimizado para líquidos com sais de nicotina",
    rdlMediumDescription: "Equilibrado entre sabor e vapor",
    dlCloudDescription: "Máxima produção de vapor",
    dlFlavorDescription: "Otimizado para máximo sabor",
    customDescription: "Insira seus valores personalizados",
    consumptionEstimates: "Estimativas de Consumo",
    puffsPerDay: "Tragadas por Dia",
    puffDuration: "Duração da Tragada",
    batteryCapacity: "Capacidade da Bateria",
    seconds: "seg",
    calculate: "Calcular",
    clear: "Limpar",
    estimatedLiquidConsumption: "Consumo Estimado de Líquido",
    estimatedBatteryLife: "Duração Estimada da Bateria",
    hours: "horas",
    days: "dias",
    vapingTips: "Dicas para Vaping",
    mtlTip:
      "MTL (tragada na bochecha): ideal para ex-fumantes e líquidos com nicotina",
    rdlTip:
      "RDL (tragada intermediária): perfeito para quem quer mais sabor mantendo uma tragada confortável",
    dlTip:
      "DL (tragada direta): máxima produção de vapor e intensidade de sabor",
    nicSaltTip: "Para sais de nicotina, mantenha a potência abaixo de 20W",
    powerTip: "Aumente gradualmente a potência até encontrar seu ponto ideal",
    calculationError: "Insira pelo menos dois valores para o cálculo",

    // Calculadora principal
    quantity: "Quantidade",
    finalQuantity: "Quantidade final desejada",
    finalComposition: "Composição final",
    nicotine: "Nicotina",
    desiredNicotine: "Nicotina desejada",
    availableBaseStrength: "Graduação de bases disponíveis",
    nicotineComposition: "Composição da nicotina",
    aromas: "Aromas",
    addAroma: "Adicionar % de Aroma",
    calculate: "Calcular",
    createMixLiquids: "Crie uma Mistura dos seus Líquidos",
    base1: "Base 1",
    base2: "Base 2",
    baseStrength: "Graduação da Base",
    shareRecipe: "Compartilhar Receita",
    recipeShared: "Receita compartilhada!",
    shareRecipeTitle: "Compartilhe sua receita de e-liquid",
    shareRecipeText: "Aqui está minha receita de e-liquid:\n\n{details}",
    shareDialogTitle: "Compartilhar com",
    noResultToShare:
      "Nenhum resultado para compartilhar. Calcule uma receita primeiro.",
    shareError: "Ocorreu um erro ao compartilhar a receita.",
    shareSuccess: "Receita compartilhada",
    cookieConsentText:
      "Vape Formula Pro usa cookies para melhorar a experiência e mostrar publicidade personalizada.",
    cookieConsentDetails:
      'O app é reservado para maiores de 18 anos. Clicando em "Aceito", você concorda com o uso de cookies. Consulte nossa Política de Privacidade para mais detalhes.',
    accept: "Aceito",

    // Resultados do cálculo
    resultSummary:
      "Para fazer {totalAmount}ml {vgPgRatio} com {targetNic}mg de nicotina você precisa:",
    baseToUse: "Base total a ser usada",
    baseVG: "VG da base",
    basePG: "PG da base",
    nicotineBase: "Bases de Nicotina",
    flaconi: "Frascos",
    from: "de",
    aroma: "Aroma",
    withAroma: "com {percentage}% de Aroma",

    // Modo avançado/simples
    simpleMode: "Modo Simples",
    advancedMode: "Modo Avançado",
    saveRecipe: "Salvar Receita",
    exportToPDF: "Exportar PDF",
    recipeSaved: "Receita salva!",
    neutralBase: "Base neutra",
    toUse: "para usar",
    nicotineBase: "Base de Nicotina",
    bottles: "frascos",
    aromas: "Aroma",
    resultInfo:
      "As quantidades são calculadas tanto em mililitros quanto em gramas...",
    liquidComposition: "Composição do líquido",
    advancedDetails: "Detalhes avançados",
    baseComposition: "Composição da Base",
    nicotineComposition: "Composição da Nicotina",
    aromaComposition: "Composição do Aroma",
    totals: "Totais",
    totalVG: "VG total",
    totalPG: "PG total",
    ofTheBase: "da base",
    ofAroma: "do aroma",
    actualFinalComposition: "Composição final efetiva",
    nicotineBaseComposition: "Composição da nicotina",
    nicotineVG: "VG da nicotina",
    nicotinePG: "PG da nicotina",
    totalOverall: "Total geral",
    enterValue: "Inserir Valor",
    mixBasesResult: "Resultado da mistura de bases:",

    coilCalculator: "Calculadora de Coil",
    targetResistanceMode: "Modo Resistência Alvo",
    calculateResistanceMode: "Modo Cálculo de Resistência",
    wireType: "Tipo de Fio",
    wireConfiguration: "Configuração do Fio",
    coilSetup: "Configuração da Coil",
    ribbonThickness: "Espessura da Fita",
    ribbonWidth: "Largura da Fita",
    wireDiameterAWG: "Diâmetro do Fio (AWG)",
    wireDiameterMM: "Diâmetro do Fio (mm)",
    targetResistance: "Resistência Alvo",
    numberOfWraps: "Número de Voltas",
    innerCoilDiameter: "Diâmetro Interno da Coil",
    legLength: "Comprimento dos Terminais",
    batteryVoltage: "Voltagem da Bateria",
    hideAdvancedInfo: "Ocultar Info Avançada",
    showAdvancedInfo: "Mostrar Info Avançada",
    calculateWraps: "Calcular Voltas",
    calculateResistance: "Calcular Resistência",
    wireLength: "Comprimento do Fio",
    calculatedWraps: "Voltas Calculadas",
    suggestedWraps: "Voltas Sugeridas",
    halfWrapOption: "Opção Meia Volta",
    actualResistance: "Resistência Real",
    calculatedResistance: "Resistência Calculada",
    legLoss: "Perda nos Terminais",
    heatCapacity: "Capacidade Térmica",
    temperatureFactor: "Fator de Temperatura",
    surfaceArea: "Área de Superfície",
    currentDraw: "Consumo de Corrente",
    power: "Potência",
    warningHighLegLoss:
      "Atenção: A perda nos terminais está muito alta. Considere reduzir o comprimento.",
    warningSignificantLegLoss:
      "Nota: A perda nos terminais é significativa. Você pode querer otimizar o comprimento.",

    totalVolumeD: "Volume total: {volume}ml ({grams}g)",
    finalCompositionD: "Composição final: {ratio} VG/PG",
    finalStrengthD: "Graduação final: {strength}mg/ml",

    // Diluição de Aroma
    calculateAromaDilution: "Calcule a Diluição do seu Aroma",
    aromaAmount: "Quantidade de Aroma",
    dilutionPercentage: "Porcentagem de Diluição",
    dilutionResult:
      "Para ter uma concentração de aroma de {percentage}% no seu líquido, você precisa de um total de:",

    // Laboratório de Líquidos
    increaseReduceStrength: "Aumente ou Reduza sua Graduação",
    currentBase: "Líquido atual",
    currentNicotineStrength: "Graduação de nicotina atual",
    desiredNicotineStrength: "Graduação de nicotina desejada",
    calculateBase: "Calcular Líquido",
    privacyPolicy: "Política de privacidade",
    viewPrivacyPolicy: "Visualizar a política de privacidade",

    // Shot/Mix Series
    composeShotMixSeries: "Componha sua Shot/Mix Series",
    shotMixFrom: "Shot/Mix de:",
    readyEliquidFrom: "Quantidade final do seu Eliquid:",
    inhalationType: "Tipo de tragada",
    mtl: "Tragada na bochecha (MTL)",
    dl: "Tragada no pulmão (DL)",
    shotMixResult:
      "Para obter {finalVolume}ml de Eliquid pronto para uso com uma concentração de nicotina de {desiredNicotine}mg/ml, você precisa:",
    yourAroma: "Seu aroma",
    neutralBase: "Base neutra",

    // Configurações
    language: "Idioma",
    vapingEducativo: "Vaping Educativo",
    usoResponsabile: "Uso Responsável do Vaping",
    usoResponsabileContent:
      "O vaping não é um jogo: usá-lo de forma responsável significa conhecer seus limites e respeitar suas necessidades. Certifique-se de usar apenas dispositivos de qualidade e siga as instruções de segurança. Se você está interessado apenas nos sabores, considere usar líquidos sem nicotina para evitar riscos desnecessários. O vaping é uma escolha muito menos prejudicial que o fumo tradicional e pode ser uma grande ajuda para quem deseja parar de fumar gradualmente.",
    usoNicotina: "Uso da Nicotina",
    usoNicotinaContent:
      "A nicotina é uma substância potente que cria dependência, mas pode ser gerenciada de forma inteligente com o vaping. Se você está passando dos cigarros para o vaping, comece com uma concentração de nicotina similar à que você costumava consumir. Reduza gradualmente o nível para se desligar lentamente da dependência. Graças ao vaping, você pode escolher com precisão o nível de nicotina e reduzi-lo progressivamente até zero, melhorando seu bem-estar sem o estresse dos cigarros tradicionais.",
    smettereDiscutetere: "Como Parar de Fumar Cigarros Tradicionais",
    smettereDiscutetereContent:
      "Parar de fumar não é fácil, mas o vaping pode ser um suporte válido e menos traumático. Usar um e-cigarro com um nível de nicotina inicialmente similar ao dos cigarros tradicionais pode ajudar a satisfazer a dependência física sem os efeitos nocivos do alcatrão e outras substâncias químicas presentes no fumo tradicional. Uma vez estabilizado, você pode reduzir gradualmente o nível de nicotina até chegar a zero. Esta abordagem gradual ajuda a reduzir o desejo de fumar sem enfrentar um choque repentino, melhorando progressivamente sua qualidade de vida.",
    faq: "Perguntas Frequentes",
    faqList: [
      {
        q: "O vaping é seguro?",
        a: "O vaping é considerado significativamente menos prejudicial que o fumo tradicional, pois não produz alcatrão nem outras substâncias químicas cancerígenas presentes nos cigarros. Usando apenas produtos certificados e seguindo as recomendações dos especialistas, o vaping é uma alternativa mais segura para quem deseja parar de fumar.",
      },
      {
        q: "O vaping pode causar dependência?",
        a: "Sim, o vaping pode causar dependência se você usar líquidos contendo nicotina. No entanto, graças ao vaping, é possível controlar o nível de nicotina e reduzi-lo gradualmente até eliminá-lo completamente, tornando-o uma ferramenta eficaz para parar definitivamente de fumar.",
      },
      {
        q: "O vaping é adequado para parar de fumar?",
        a: "Muitas pessoas pararam de fumar graças ao vaping. O importante é usá-lo como uma ferramenta de transição, reduzindo gradualmente a nicotina até eliminá-la completamente. O vaping permite ter um controle preciso sobre a quantidade de nicotina consumida, tornando o processo de cessação do tabagismo mais gerenciável e menos estressante.",
      },
      {
        q: "Quais são os efeitos a longo prazo do vaping?",
        a: "Os efeitos a longo prazo do vaping ainda estão em estudo, mas é amplamente reconhecido que é significativamente menos prejudicial que fumar cigarros tradicionais. Eliminando alcatrão e outras substâncias tóxicas, o vaping representa uma escolha mais saudável para quem deseja abandonar o fumo.",
      },
      {
        q: "O vaping melhora a qualidade de vida em comparação ao fumo tradicional?",
        a: "Sim, o vaping melhora notavelmente a qualidade de vida em comparação ao fumo tradicional. Não só reduz a exposição a substâncias químicas nocivas, mas também permite eliminar gradualmente a dependência da nicotina, melhorando a saúde pulmonar e a capacidade respiratória.",
      },
    ],
    beneficiSmettere: "Benefícios de Parar de Fumar ao Longo do Tempo",
    beneficiSmettereList: [
      "Após 48 horas: Seu corpo começa a eliminar a nicotina e o paladar e olfato começam a melhorar.",
      "Após 1 semana: Os níveis de monóxido de carbono no sangue são reduzidos, melhorando a circulação e a capacidade respiratória.",
      "Após 1 mês: Sua capacidade pulmonar melhora visivelmente e o risco de infecções pulmonares diminui.",
      "Após 3-9 meses: A tosse e a dificuldade respiratória diminuem, melhorando ainda mais sua qualidade de vida.",
      "Após 1 ano: O risco de doenças cardíacas é reduzido pela metade em comparação a quando você fumava.",
      "Após 5 anos: O risco de derrame é similar ao de uma pessoa que nunca fumou.",
      "Após 10 anos: O risco de câncer de pulmão é reduzido drasticamente, quase pela metade em comparação a um fumante.",
    ],
    mitiEFatti: "Mitos e Fatos sobre o Vaping",
    mitiEFattiList: [
      {
        mito: "O vaping faz tanto mal quanto fumar.",
        fatto:
          "Estudos mostram que o vaping é significativamente menos prejudicial que o fumo tradicional. O fumo produz mais de 7.000 substâncias químicas, muitas das quais são cancerígenas, enquanto o vaping reduz drasticamente esse número, oferecendo uma alternativa mais segura.",
      },
      {
        mito: "O vaping causa problemas pulmonares como o fumo.",
        fatto:
          "O vaping não produz alcatrão, um dos principais responsáveis pelos danos aos pulmões causados pelos cigarros. Usando líquidos de qualidade e respeitando as diretrizes, o vaping é uma escolha definitivamente menos prejudicial para a saúde pulmonar.",
      },
      {
        mito: "O vaping não ajuda a parar de fumar.",
        fatto:
          "Muitas pessoas pararam de fumar graças ao vaping. Com a abordagem correta e reduzindo gradualmente a nicotina, o vaping pode ser uma ferramenta eficaz para se livrar da dependência dos cigarros tradicionais, melhorando sua saúde e qualidade de vida.",
      },
    ],

    // Tooltips
    dilutionTooltip:
      "Calcule sua quantidade total de líquido para atingir a % de concentração de aroma desejada",
    nicotineTooltip:
      'Se você deseja um líquido 0mg, ou já tem uma base com nicotina, insira "0" neste campo',
    aromaTooltip:
      "Insira aqui a % de diluição do seu aroma e descubra quantos ML inserir em seu líquido",
    resultTooltip:
      'O dado do total será útil em "QUANTIDADE final desejada" no calculador apropriado',
    mixTooltip:
      "Calcule a graduação e composição final misturando dois líquidos. Recomenda-se usar líquidos sem aroma para evitar alterar o sabor.",
    compositionTooltip:
      "A composição final pode diferir ligeiramente da desejada. Isso é normal e garante o melhor resultado possível considerando as composições e compensação de todos os ingredientes (base, nicotina e aroma). O cálculo otimiza as quantidades para chegar o mais próximo possível da composição desejada.",
    resultInfo:
      "As quantidades são calculadas tanto em mililitros quanto em gramas. Os valores em gramas são baseados em dados oficiais de densidade para oferecer uma opção de medição alternativa, útil quando não se tem um medidor",
    nicotineStrengthInfo:
      "Use este campo apenas em caso de aumento, caso contrário ignore-o",

    // Botões e ações
    saveRecipe: "Salvar Receita",
    exportToPDF: "Exportar para PDF",
    cancel: "Cancelar",
    save: "Salvar",
    delete: "Excluir",
    adjustNicotine: "Ajustar Graduação de Nicotina",
    mixYourBases: "Misture suas bases",
    strength: "Graduação (mg/ml)",
    savedRecipes: "Receitas salvas",
    finalNicotineStrength: "Força final da Nicotina",

    // Mensagens
    recipeSaved: "Receita salva!",
    noSavedRecipes: "Nenhuma receita salva.",
    nameYourRecipe: "Dê um nome à sua Receita",

    // Unidades de medida
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // Outros
    vg: "VG",
    pg: "PG",
    createdOn: "Criada em",
    increaseNicotineMessage:
      "Para aumentar seu líquido para {strength}mg de nicotina adicione:",
    decreaseNicotineMessage:
      "Para reduzir seu líquido para {strength}mg de nicotina adicione:",
    addNicotineBase:
      "{volume}ml de nicotina {composition} a {strength}mg/ml ({flacons} frascos de 10ml{extraMl}) ({grams}g) ao seu líquido atual",
    addNeutralBase:
      "{volume}ml de base neutra {composition} (0mg/ml) ({grams}g) ao seu líquido atual",
    extraMl: " + {amount}ml",
    finalVolumeN: "Volume final: {volume}ml ({grams}g)",
    finalVolumeL: "Volume final: {volume}ml ({grams}g)",

    quickGuideTitle: "Guia de Uso da Calculadora",
    modesExplained: "Os Dois Modos de Cálculo",
    targetModeTitle: "Modo Alvo",
    targetModeExplanation:
      "Use este modo quando você sabe qual resistência deseja obter (ex. 0.5Ω). Insira o valor desejado e a calculadora dirá: \n- Quantas voltas fazer \n- Quanto fio usar \n- A resistência efetiva que você obterá",
    calculateModeTitle: "Modo Cálculo",
    calculateModeExplanation:
      "Use este modo quando você sabe quantas voltas quer fazer. Insira o número de voltas e descubra que resistência você obterá. Útil quando você tem um espaço limitado ou prefere trabalhar com um número específico de voltas.",

    inputFieldsGuide: "Guia dos Campos de Entrada",
    innerDiameterTitle: "Diâmetro Interno da Coil",
    innerDiameterExplanation:
      "O diâmetro sobre o qual você enrolará o fio. Geralmente corresponde ao diâmetro da chave de fenda que você usará para o enrolamento.",
    legLengthTitle: "Comprimento dos Terminais",
    legLengthExplanation:
      "As 'pernas' da resistência que você inserirá nos bornes. Recomendado: 5-6mm para minimizar as perdas.",

    advancedExplained: "Explicação do Modo Avançado",
    powerCalcsTitle: "Cálculos de Potência",
    powerCalcsExplanation:
      "- Voltagem da Bateria: tipicamente 4.2V para uma bateria carregada\n- Consumo de Corrente: quanta corrente passará pela coil\n- Potência: a potência efetiva que a coil desenvolverá",
    thermalFactorsTitle: "Fatores Térmicos",
    thermalFactorsExplanation:
      "- Capacidade Térmica: quanto calor a coil pode acumular\n- Área de Superfície: superfície de contato com o líquido\n- Fator de Temperatura: como o material se comporta ao calor",

    resultsExplained: "Como Interpretar os Resultados",
    basicResultsTitle: "Resultados Básicos",
    basicResultsList:
      "Comprimento do Fio: quanto fio total você precisará\nVoltas Calculadas: número preciso de voltas\nVoltas Sugeridas: número arredondado prático de realizar\nOpção Meia Volta: alternativa para ajuste fino\nResistência Efetiva: valor final que você medirá",

    warningsTitle: "Avisos Importantes",
    warningsList:
      "Perda nos Terminais > 30%: terminais muito longos, reduza\nPerda nos Terminais > 20%: considere otimizar\nA resistência efetiva pode variar ligeiramente na prática",

    practicalTips: "Dicas Práticas",
    practicalTipsList:
      "Comece com fios Kanthal A1 para maior estabilidade\nPara iniciantes: alvo entre 0.5Ω e 1.5Ω\nSempre meça a resistência com um ohmímetro\nEm dual coil, a resistência total será a metade da individual",
  },

  en: {
    // Menu and navigation
    calculator: "Create Your E-liquid",
    baseCalculator: "E-liquid Lab",
    shotMixSeries: "Shot/Mix Series",
    recipes: "My Recipes",
    aromaDilution: "Flavour Dilution",
    settings: "Settings",
    mixBasesResult: "Result of base mixing:",
    totalVolumeD: "Total volume: {volume}ml ({grams}g)",
    finalCompositionD: "Final composition: {ratio} VG/PG",
    finalStrengthD: "Final strength: {strength}mg/ml",
    shareRecipe: "Share Recipe",
    recipeShared: "Recipe shared!",
    cookieConsentText:
      "Vape Formula Pro uses cookies to enhance your experience and display personalized advertisements.",
    cookieConsentDetails:
      'The app is restricted to users 18 years of age and older. By clicking "Accept", you consent to the use of cookies. Please refer to our Privacy Policy for more details.',
    accept: "Accept",

    // Main calculator
    quantity: "Quantity",
    finalQuantity: "Desired final quantity",
    finalComposition: "Final composition",
    nicotine: "Nicotine",
    desiredNicotine: "Desired nicotine",
    availableBaseStrength: "Available Nicotine Shot strength",
    nicotineComposition: "Nicotine composition",
    aromas: "Flavours",
    addAroma: "Add % Flavour",
    calculate: "Calculate",
    shareSuccess: "Recipe shared",
    privacyPolicy: "Privacy Policy",
    viewPrivacyPolicy: "View Privacy Policy",

    // Calculation results
    resultSummary:
      "To make {totalAmount}ml of {vgPgRatio} at {targetNic}mg nicotine, you need:",
    baseToUse: "Total base to use",
    baseVG: "VG base",
    basePG: "PG base",
    nicotineBase: "Nicotine Shots",
    flaconi: "Bottles",
    from: "of",
    aroma: "Flavour",
    withAroma: "with {percentage}% of Flavor",
    shareRecipeTitle: "Share your e-liquid recipe",
    shareRecipeText: "Here's my e-liquid recipe:\n\n{details}",
    shareDialogTitle: "Share with",
    noResultToShare: "No result to share. Please calculate a recipe first.",
    shareError: "An error occurred while sharing the recipe.",
    vapeNewsTitle: "Vaping News & Trends",
    aggiorna: "Refresh",
    caricamento: "Loading...",
    nessunArticolo: "No articles available",

    coilCalculator: "Coil Calculator",
    targetResistanceMode: "Target Resistance Mode",
    calculateResistanceMode: "Calculate Resistance Mode",
    wireType: "Wire Type",
    wireConfiguration: "Wire Configuration",
    coilSetup: "Coil Setup",
    ribbonThickness: "Ribbon Thickness",
    ribbonWidth: "Ribbon Width",
    wireDiameterAWG: "Wire Diameter (AWG)",
    wireDiameterMM: "Wire Diameter (mm)",
    targetResistance: "Target Resistance",
    numberOfWraps: "Number of Wraps",
    innerCoilDiameter: "Inner Coil Diameter",
    legLength: "Leg Length",
    batteryVoltage: "Battery Voltage",
    hideAdvancedInfo: "Hide Advanced Info",
    showAdvancedInfo: "Show Advanced Info",
    calculateWraps: "Calculate Wraps",
    calculateResistance: "Calculate Resistance",
    wireLength: "Wire Length",
    calculatedWraps: "Calculated Wraps",
    suggestedWraps: "Suggested Wraps",
    halfWrapOption: "Half Wrap Option",
    actualResistance: "Actual Resistance",
    calculatedResistance: "Calculated Resistance",
    legLoss: "Leg Loss",
    heatCapacity: "Heat Capacity",
    temperatureFactor: "Temperature Factor",
    surfaceArea: "Surface Area",
    currentDraw: "Current Draw",
    power: "Power",
    warningHighLegLoss:
      "Warning: Leg loss is very high. Consider reducing leg length.",
    warningSignificantLegLoss:
      "Note: Leg loss is significant. You may want to optimize leg length.",

    quickGuideTitle: "Coil Calculator User Guide",
    modesExplained: "The Two Calculation Modes",
    targetModeTitle: "Target Mode",
    targetModeExplanation:
      "Use this mode when you know what resistance you want to achieve (e.g. 0.5Ω). Enter the desired value and the calculator will tell you: \n- How many wraps to make \n- How much wire to use \n- The actual resistance you'll get",
    calculateModeTitle: "Calculate Mode",
    calculateModeExplanation:
      "Use this mode when you know how many wraps you want to make. Enter the number of wraps and discover what resistance you'll get. Useful when you have limited space or prefer working with a specific number of wraps.",
    inputFieldsGuide: "Input Fields Guide",
    innerDiameterTitle: "Coil Inner Diameter",
    innerDiameterExplanation:
      "The diameter around which you'll wrap the wire. Usually matches the diameter of the screwdriver you'll use for wrapping.",
    legLengthTitle: "Leg Length",
    legLengthExplanation:
      "The 'legs' of the coil that you'll insert into the posts. Recommended: 5-6mm to minimize losses.",

    advancedExplained: "Advanced Mode Explanation",
    powerCalcsTitle: "Power Calculations",
    powerCalcsExplanation:
      "- Battery Voltage: typically 4.2V for a fully charged battery\n- Current Draw: how much current will flow through the coil\n- Power: the actual power the coil will develop",
    thermalFactorsTitle: "Thermal Factors",
    thermalFactorsExplanation:
      "- Heat Capacity: how much heat the coil can store\n- Surface Area: contact surface with the liquid\n- Temperature Factor: how the material behaves with heat",

    resultsExplained: "How to Interpret Results",
    basicResultsTitle: "Basic Results",
    basicResultsList:
      "Wire Length: total wire needed\nCalculated Wraps: precise number of turns\nSuggested Wraps: practical rounded number\nHalf Wrap Option: fine-tuning alternative\nActual Resistance: final value you'll measure",

    warningsTitle: "Important Warnings",
    warningsList:
      "Leg Loss > 30%: legs too long, reduce\nLeg Loss > 20%: consider optimizing\nActual resistance might vary slightly in practice",

    practicalTips: "Practical Tips",
    practicalTipsList:
      "Start with Kanthal A1 wire for better stability\nFor beginners: target between 0.5Ω and 1.5Ω\nAlways measure resistance with an ohmmeter\nIn dual coil, total resistance will be half of single coil",

    // Advanced/simple mode
    simpleMode: "Simple Mode",
    advancedMode: "Advanced Mode",
    saveRecipe: "Save Recipe",
    exportToPDF: "Export PDF",
    recipeSaved: "Recipe saved!",
    neutralBase: "Neutral Base",
    toUse: "to use",
    nicotineBase: "Nicotine Base",
    bottles: "bottles",
    aromas: "Flavor",
    resultInfo:
      "The quantities are calculated in both milliliters and grams...",
    liquidComposition: "Liquid Composition",
    advancedDetails: "Advanced Details",
    baseComposition: "Base Composition",
    nicotineComposition: "Nicotine Composition",
    aromaComposition: "Flavor Composition",
    totals: "Totals",
    totalVG: "Total VG",
    totalPG: "Total PG",
    ofTheBase: "of the base",
    ofAroma: "of the flavor",
    actualFinalComposition: "Actual final composition",
    nicotineBaseComposition: "Nicotine composition",
    nicotineVG: "Nicotine VG",
    nicotinePG: "Nicotine PG",
    totalOverall: "Total overall",
    enterValue: "Enter Value",
    createMixLiquids: "Create a Mix of Your Liquids",
    base1: "Base 1",
    base2: "Base 2",
    baseStrength: "Base Strength",
    dilutionResultSummary:
      "To have a flavor concentration of {percentage}% in your liquid, you need a total of {total}ml ({baseToAdd}ml of base + {aroma}ml of flavor)",

    // Flavour Dilution
    calculateAromaDilution: "Calculate Your Flavour Dilution",
    aromaAmount: "Flavour amount",
    dilutionPercentage: "Dilution percentage",
    dilutionResult:
      "To have a flavour concentration of {percentage}% in your e-liquid, you need a total of:",

    ohmCalculator: "Ohm Calculator",
    voltage: "Voltage",
    resistance: "Resistance",
    current: "Current",
    power: "Power",
    selectPreset: "Select Vaping Style",
    mtlBasicPreset: "MTL Basic (Beginners)",
    mtlSaltPreset: "MTL Nicotine Salts",
    rdlMediumPreset: "RDL Medium",
    dlCloudPreset: "DL Cloud Chasing",
    dlFlavorPreset: "DL Flavor Chasing",
    customPreset: "Custom",
    mtlBasicDescription:
      "Classic setup for beginners, similar to cigarette draw",
    mtlSaltDescription: "Optimized for nicotine salt liquids",
    rdlMediumDescription: "Balanced between flavor and vapor",
    dlCloudDescription: "Maximum vapor production",
    dlFlavorDescription: "Optimized for maximum flavor",
    customDescription: "Enter your custom values",
    consumptionEstimates: "Consumption Estimates",
    puffsPerDay: "Puffs per Day",
    puffDuration: "Puff Duration",
    batteryCapacity: "Battery Capacity",
    seconds: "sec",
    calculate: "Calculate",
    clear: "Clear",
    estimatedLiquidConsumption: "Estimated Liquid Consumption",
    estimatedBatteryLife: "Estimated Battery Life",
    hours: "hours",
    days: "days",
    vapingTips: "Vaping Tips",
    mtlTip: "MTL (mouth to lung): ideal for ex-smokers and nicotine liquids",
    rdlTip:
      "RDL (restricted direct lung): perfect for more flavor while maintaining comfort",
    dlTip: "DL (direct lung): maximum vapor production and flavor intensity",
    nicSaltTip: "For nicotine salts, keep power below 20W",
    powerTip: "Gradually increase power until you find your sweet spot",
    calculationError: "Please enter at least two values for calculation",

    // E-liquid Lab
    increaseReduceStrength: "Increase or Reduce Your Strength",
    currentBase: "Current e-liquid",
    currentNicotineStrength: "Current nicotine strength",
    desiredNicotineStrength: "Desired nicotine strength",
    calculateBase: "Calculate E-liquid",
    strength: "Strength (mg/ml)",
    savedRecipes: "Saved Recipes",
    dilutionResultDetails:
      "{total} ml of liquid ({baseToAdd}ml of base + {aroma}ml of flavor)",

    calculating: "Calculating...",
    processingRequest: "Processing request...",

    // Error Messages
    invalidInput: "Invalid input",
    numberRequired: "Please enter a valid number",
    valueOutOfRange: "Value out of range",

    // Success Messages
    calculationComplete: "Calculation complete",

    // Advanced Mode
    advancedModeWarning:
      "Advanced mode provides additional technical information",
    powerLimitWarning: "Warning: Please verify battery power limits",

    // Tooltips
    targetResistanceTooltip: "Desired target resistance in ohms",
    wrapsTooltip: "Number of complete wraps",
    innerDiameterTooltip: "Inner diameter of the coil",
    legLengthTooltip: "Length of the coil legs",

    // Unit Labels

    ohm: "Ω",
    mm: "mm",
    awg: "AWG",
    wraps: "wraps",
    watts: "W",
    amps: "A",
    volts: "V",

    // Shot/Mix Series
    composeShotMixSeries: "Compose Your Shot/Mix Series",
    shotMixFrom: "Shot/Mix from:",
    readyEliquidFrom: "Final quantity of your E-liquid:",
    inhalationType: "Inhale type",
    mtl: "Mouth-to-Lung (MTL)",
    dl: "Direct Lung (DL)",
    shotMixResult:
      "To obtain {finalVolume}ml of ready-to-use E-liquid with a nicotine concentration of {desiredNicotine}mg/ml, you need:",
    yourAroma: "Your flavour",
    neutralBase: "Neutral base",

    // Settings
    language: "Language",
    vapingEducativo: "Vaping Education",
    usoResponsabile: "Responsible Vaping Use",
    usoResponsabileContent:
      "Vaping is not a game: using it responsibly means knowing your limits and respecting your needs. Make sure to use only quality devices and follow safety instructions. If you're only interested in flavors, consider using nicotine-free liquids to avoid unnecessary risks. Vaping is a much less harmful choice compared to traditional smoking and can be a great help for those who want to quit smoking gradually.",
    usoNicotina: "Nicotine Use",
    usoNicotinaContent:
      "Nicotine is a powerful substance that creates addiction, but it can be managed intelligently with vaping. If you're switching from cigarettes to vaping, start with a nicotine concentration similar to what you used to consume. Gradually reduce the level to slowly detach from the addiction. Thanks to vaping, you can precisely choose the nicotine level and lower it progressively to zero, improving your well-being without the stress of traditional cigarettes.",
    smettereDiscutetere: "How to Quit Traditional Cigarettes",
    smettereDiscutetereContent:
      "Quitting smoking isn't easy, but vaping can be a valid and less traumatic support. Using an e-cigarette with a nicotine level initially similar to that of traditional cigarettes can help satisfy physical addiction without the harmful effects of tar and other chemicals present in traditional smoke. Once stabilized, you can gradually reduce the nicotine level until you reach zero. This gradual approach helps reduce the desire to smoke without facing a sudden shock, progressively improving your quality of life.",
    faq: "Frequently Asked Questions",
    faqList: [
      {
        q: "Is vaping safe?",
        a: "Vaping is considered significantly less harmful than traditional smoking, as it doesn't produce tar or other carcinogenic chemicals found in cigarettes. By using only certified products and following expert recommendations, vaping is a safer alternative for those who want to quit smoking.",
      },
      {
        q: "Can vaping cause addiction?",
        a: "Yes, vaping can cause addiction if liquids containing nicotine are used. However, thanks to vaping, it's possible to control the nicotine level and gradually reduce it until it's completely eliminated, making it an effective tool to quit smoking for good.",
      },
      {
        q: "Is vaping suitable for quitting smoking?",
        a: "Many people have quit smoking thanks to vaping. The important thing is to use it as a transition tool, gradually reducing nicotine until it's completely eliminated. Vaping allows precise control over the amount of nicotine consumed, making the smoking cessation journey more manageable and less stressful.",
      },
      {
        q: "What are the long-term effects of vaping?",
        a: "The long-term effects of vaping are still being studied, but it is widely recognized as significantly less harmful than smoking traditional cigarettes. By eliminating tar and other toxic substances, vaping represents a healthier choice for those who want to quit smoking.",
      },
      {
        q: "Does vaping improve quality of life compared to traditional smoking?",
        a: "Yes, vaping significantly improves quality of life compared to traditional smoking. Not only does it reduce exposure to harmful chemicals, but it also allows for gradually eliminating nicotine dependence, improving lung health and respiratory capacity.",
      },
    ],
    beneficiSmettere: "Benefits of Quitting Smoking Over Time",
    beneficiSmettereList: [
      "After 48 hours: Your body starts to eliminate nicotine and your sense of taste and smell begin to improve.",
      "After 1 week: Carbon monoxide levels in your blood decrease, improving circulation and respiratory capacity.",
      "After 1 month: Your lung capacity visibly improves and the risk of lung infections decreases.",
      "After 3-9 months: Coughing and breathing difficulties decrease, further improving your quality of life.",
      "After 1 year: The risk of heart disease is halved compared to when you were smoking.",
      "After 5 years: The risk of stroke is similar to that of a person who has never smoked.",
      "After 10 years: The risk of lung cancer is drastically reduced, almost halved compared to a smoker.",
    ],
    mitiEFatti: "Myths and Facts about Vaping",
    mitiEFattiList: [
      {
        mito: "Vaping is as harmful as smoking.",
        fatto:
          "Studies show that vaping is significantly less harmful than traditional smoking. Smoking produces over 7,000 chemicals, many of which are carcinogenic, while vaping drastically reduces this number, offering a safer alternative.",
      },
      {
        mito: "Vaping causes lung problems like smoking.",
        fatto:
          "Vaping doesn't produce tar, one of the main culprits for lung damage caused by cigarettes. By using quality liquids and following guidelines, vaping is a significantly less harmful choice for lung health.",
      },
      {
        mito: "Vaping doesn't help quit smoking.",
        fatto:
          "Many people have quit smoking thanks to vaping. With the right approach and gradually reducing nicotine, vaping can be an effective tool to break free from the addiction to traditional cigarettes, improving one's health and quality of life.",
      },
    ],

    // Tooltips
    dilutionTooltip:
      "Calculate your total liquid quantity to reach the desired % of flavour concentration",
    nicotineTooltip:
      "If you want a 0mg liquid, or if you already have a nicotine-infused base, enter '0' in this field",
    aromaTooltip:
      "Enter the % dilution of your flavour here and find out how many ML to add to your e-liquid",
    resultTooltip:
      'The total data will be useful in "Desired FINAL quantity" in the appropriate calculator',
    mixTooltip:
      "Calculate the final strength and composition by mixing two e-liquids. It's advisable to use unflavoured e-liquids to avoid altering the taste.",
    compositionTooltip:
      "The final composition may differ slightly from the desired one. This is normal and ensures the best possible result considering the compositions and compensation of all ingredients (base, nicotine and flavour). The calculation optimizes the quantities to get as close as possible to the desired composition.",
    resultInfo:
      "The quantities are calculated in both milliliters and grams. The values in grams are based on official density data to provide an alternative measurement option, useful when you don't have a measuring cup.",
    nicotineStrengthInfo:
      "Use this field only in case of an increase, otherwise ignore it.",
    // Buttons and actions
    saveRecipe: "Save Recipe",
    exportToPDF: "Export to PDF",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    finalNicotineStrength: "Final Nicotine Strength",

    // Messages
    recipeSaved: "Recipe saved!",
    noSavedRecipes: "No saved recipes.",
    nameYourRecipe: "Name your Recipe",
    blogVape: "Vape Blog",

    // Units of measure
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // Others
    vg: "VG",
    pg: "PG",
    createdOn: "Created on",

    // New keys added
    mixYourBases: "Mix Your Bases",
    adjustNicotineConcentration: "Adjust Nicotine Concentration",
    base1: "Base 1",
    base2: "Base 2",
    base1Strength: "Base 1 Strength",
    base2Strength: "Base 2 Strength",
    base1Composition: "Base 1 Composition",
    base2Composition: "Base 2 Composition",
    calculateMix: "Calculate Mix",
    availableNicotine: "Available Nicotine",
    desiredFinalQuantity: "Desired Final Quantity",
    baseAndPercentage: "%",
    adjustNicotine: "Adjust Nicotine Strength",
    mixYourBases: "Mix Your Bases",
    increaseNicotineMessage:
      "To increase your liquid to {strength}mg of nicotine, add:",
    decreaseNicotineMessage:
      "To reduce your liquid to {strength}mg of nicotine, add:",
    addNicotineBase:
      "{volume}ml of {composition} nicotine at {strength}mg/ml ({flacons} 10ml bottles{extraMl}) ({grams}g) to your current liquid",
    addNeutralBase:
      "{volume}ml of {composition} neutral base (0mg/ml) ({grams}g) to your current liquid",
    extraMl: " + {amount}ml",
    finalVolumeN: "Final volume: {volume}ml ({grams}g)",
    finalVolumeL: "Final volume: {volume}ml ({grams}g)",
  },

  fr: {
    // Menu et navigation
    calculator: "Créez votre E-liquide",
    baseCalculator: "Labo E-liquides",
    shotMixSeries: "Série Shot/Mix",
    recipes: "Mes Recettes",
    aromaDilution: "Dilution d'Arôme",
    settings: "Paramètres",
    adjustNicotine: "Ajuster la Concentration en Nicotine",
    mixYourBases: "Mélanger vos Bases",
    mixBasesResult: "Résultat du mélange des bases :",
    totalVolumeD: "Volume total : {volume}ml ({grams}g)",
    finalCompositionD: "Composition finale : {ratio} VG/PG",
    finalStrengthD: "Concentration finale : {strength}mg/ml",
    shareRecipe: "Partager la Recette",
    recipeShared: "Recette partagée !",
    shareSuccess: "Recette partagée",
    cookieConsentText:
      "Vape Formula Pro utilise des cookies pour améliorer votre expérience et afficher des publicités personnalisées.",
    cookieConsentDetails:
      "L'application est réservée aux personnes de 18 ans et plus. En cliquant sur \"Accepter\", vous consentez à l'utilisation des cookies. Veuillez consulter notre Politique de confidentialité pour plus de détails.",
    accept: "Accepter",

    // Calculateur principal
    quantity: "Quantité",
    finalQuantity: "Quantité finale souhaitée",
    finalComposition: "Composition finale",
    nicotine: "Nicotine",
    desiredNicotine: "Nicotine souhaitée",
    availableBaseStrength: "Concentration des boosters disponibles",
    nicotineComposition: "Composition de la nicotine",
    aromas: "Arômes",
    addAroma: "Ajouter % d'Arôme",
    calculate: "Calculer",
    dilutionResultDetails:
      "{total} ml de liquide ({baseToAdd}ml de base + {aroma}ml d'arôme)",

    ohmCalculator: "Calculateur Ohm",
    voltage: "Tension",
    resistance: "Résistance",
    current: "Courant",
    power: "Puissance",
    selectPreset: "Sélectionner Style de Vapotage",
    mtlBasicPreset: "MTL Basic (Débutants)",
    mtlSaltPreset: "MTL Sels de Nicotine",
    rdlMediumPreset: "RDL Moyen",
    dlCloudPreset: "DL Cloud Chasing",
    dlFlavorPreset: "DL Flavor Chasing",
    customPreset: "Personnalisé",
    mtlBasicDescription:
      "Configuration classique pour débutants, similaire à la cigarette",
    mtlSaltDescription: "Optimisé pour les sels de nicotine",
    rdlMediumDescription: "Équilibré entre saveur et vapeur",
    dlCloudDescription: "Production maximale de vapeur",
    dlFlavorDescription: "Optimisé pour un maximum de saveur",
    customDescription: "Entrez vos valeurs personnalisées",
    consumptionEstimates: "Estimations de Consommation",
    puffsPerDay: "Bouffées par Jour",
    puffDuration: "Durée de Bouffée",
    batteryCapacity: "Capacité de Batterie",
    seconds: "sec",
    calculate: "Calculer",
    clear: "Effacer",
    estimatedLiquidConsumption: "Consommation de Liquide Estimée",
    estimatedBatteryLife: "Autonomie Estimée de la Batterie",
    hours: "heures",
    days: "jours",
    vapingTips: "Conseils de Vapotage",
    mtlTip:
      "MTL (inhalation indirecte): idéal pour les ex-fumeurs et les liquides nicotinés",
    rdlTip:
      "RDL (inhalation directe restreinte): parfait pour plus de saveur tout en maintenant le confort",
    dlTip:
      "DL (inhalation directe): production maximale de vapeur et intensité des saveurs",
    nicSaltTip: "Pour les sels de nicotine, gardez la puissance sous 20W",
    powerTip:
      "Augmentez progressivement la puissance jusqu'à trouver votre zone de confort",
    calculationError: "Veuillez saisir au moins deux valeurs pour le calcul",

    quickGuideTitle: "Guide d'Utilisation du Calculateur de Résistance",
    modesExplained: "Les Deux Modes de Calcul",
    targetModeTitle: "Mode Cible",
    targetModeExplanation:
      "Utilisez ce mode lorsque vous connaissez la résistance souhaitée (ex. 0.5Ω). Entrez la valeur désirée et le calculateur vous indiquera : \n- Combien de tours faire \n- Quelle longueur de fil utiliser \n- La résistance réelle que vous obtiendrez",
    calculateModeTitle: "Mode Calcul",
    calculateModeExplanation:
      "Utilisez ce mode lorsque vous savez combien de tours vous voulez faire. Entrez le nombre de tours et découvrez quelle résistance vous obtiendrez. Utile lorsque vous avez un espace limité ou préférez travailler avec un nombre spécifique de tours.",
    inputFieldsGuide: "Guide des Champs de Saisie",
    innerDiameterTitle: "Diamètre Intérieur du Coil",
    innerDiameterExplanation:
      "Le diamètre autour duquel vous enroulerez le fil. Correspond généralement au diamètre du tournevis que vous utiliserez pour l'enroulement.",
    legLengthTitle: "Longueur des Pattes",
    legLengthExplanation:
      "Les 'pattes' de la résistance que vous insérerez dans les plots. Recommandé : 5-6mm pour minimiser les pertes.",

    advancedExplained: "Explication du Mode Avancé",
    powerCalcsTitle: "Calculs de Puissance",
    powerCalcsExplanation:
      "- Tension Batterie: typiquement 4.2V pour une batterie pleine\n- Consommation de Courant: intensité traversant la résistance\n- Puissance: puissance réelle développée par la résistance",
    thermalFactorsTitle: "Facteurs Thermiques",
    thermalFactorsExplanation:
      "- Capacité Thermique: quantité de chaleur stockable\n- Surface: surface de contact avec le liquide\n- Facteur de Température: comportement du matériau à la chaleur",

    resultsExplained: "Comment Interpréter les Résultats",
    basicResultsTitle: "Résultats de Base",
    basicResultsList:
      "Longueur de Fil: fil total nécessaire\nTours Calculés: nombre précis de tours\nTours Suggérés: nombre arrondi pratique\nOption Demi-Tour: alternative de réglage fin\nRésistance Réelle: valeur finale mesurable",

    warningsTitle: "Avertissements Importants",
    warningsList:
      "Perte aux Pattes > 30%: pattes trop longues, réduire\nPerte aux Pattes > 20%: considérer l'optimisation\nLa résistance réelle peut légèrement varier en pratique",

    practicalTips: "Conseils Pratiques",
    practicalTipsList:
      "Commencez avec du fil Kanthal A1 pour plus de stabilité\nPour débutants: visez entre 0.5Ω et 1.5Ω\nMesurez toujours la résistance avec un ohmmètre\nEn double résistance, la résistance totale sera la moitié",

    // Résultats du calcul
    resultSummary:
      "Pour réaliser {totalAmount}ml de {vgPgRatio} à {targetNic}mg de nicotine, vous avez besoin de :",
    baseToUse: "Base totale à utiliser",
    baseVG: "Base VG",
    basePG: "Base PG",
    nicotineBase: "Boosters de Nicotine",
    flaconi: "Flacons",
    from: "de",
    aroma: "Arôme",
    strength: "Concentration (mg/ml)",
    savedRecipes: "Recettes Sauvegardées",
    privacyPolicy: "Politique de confidentialité",
    viewPrivacyPolicy: "Voir la politique de confidentialité",
    vapeNewsTitle: "Actualités et Tendances Vape",
    aggiorna: "Actualiser",
    caricamento: "Chargement...",
    nessunArticolo: "Aucun article disponible",

    coilCalculator: "Calculateur de Résistance",
    targetResistanceMode: "Mode Résistance Cible",
    calculateResistanceMode: "Mode Calcul de Résistance",
    wireType: "Type de Fil",
    wireConfiguration: "Configuration du Fil",
    coilSetup: "Configuration Résistance",
    ribbonThickness: "Épaisseur du Ruban",
    ribbonWidth: "Largeur du Ruban",
    wireDiameterAWG: "Diamètre du Fil (AWG)",
    wireDiameterMM: "Diamètre du Fil (mm)",
    targetResistance: "Résistance Cible",
    numberOfWraps: "Nombre de Spires",
    innerCoilDiameter: "Diamètre Interne",
    legLength: "Longueur des Pattes",
    batteryVoltage: "Tension Batterie",
    hideAdvancedInfo: "Masquer Options Avancées",
    showAdvancedInfo: "Afficher Options Avancées",
    calculateWraps: "Calculer les Spires",
    calculateResistance: "Calculer la Résistance",
    wireLength: "Longueur du Fil",
    calculatedWraps: "Spires Calculées",
    suggestedWraps: "Spires Suggérées",
    halfWrapOption: "Option Demi-Tour",
    actualResistance: "Résistance Réelle",
    calculatedResistance: "Résistance Calculée",
    legLoss: "Perte aux Pattes",
    heatCapacity: "Capacité Thermique",
    temperatureFactor: "Facteur de Température",
    surfaceArea: "Surface",
    currentDraw: "Consommation de Courant",
    power: "Puissance",
    warningHighLegLoss:
      "Attention: La perte aux pattes est très élevée. Envisagez de réduire la longueur.",
    warningSignificantLegLoss:
      "Note: La perte aux pattes est significative. Vous pourriez optimiser la longueur.",

    calculating: "Calcul en cours...",
    processingRequest: "Traitement de la demande...",

    // Error Messages
    invalidInput: "Entrée invalide",
    numberRequired: "Veuillez entrer un nombre valide",
    valueOutOfRange: "Valeur hors limites",

    // Success Messages
    calculationComplete: "Calcul terminé",

    // Advanced Mode
    advancedModeWarning:
      "Le mode avancé fournit des informations techniques supplémentaires",
    powerLimitWarning:
      "Attention: Vérifiez les limites de puissance de la batterie",

    // Tooltips
    targetResistanceTooltip: "Résistance cible souhaitée en ohms",
    wrapsTooltip: "Nombre de tours complets",
    innerDiameterTooltip: "Diamètre intérieur de la résistance",
    legLengthTooltip: "Longueur des pattes de la résistance",

    // Unit Labels

    ohm: "Ω",
    mm: "mm",
    awg: "AWG",
    wraps: "tours",
    watts: "W",
    amps: "A",
    volts: "V",

    // Mode avancé/simple

    simpleMode: "Mode Simple",
    advancedMode: "Mode Avancé",
    saveRecipe: "Sauvegarder la Recette",
    exportToPDF: "Exporter PDF",
    recipeSaved: "Recette sauvegardée !",
    neutralBase: "Base Neutre",
    toUse: "à utiliser",
    nicotineBase: "Base de Nicotine",
    bottles: "flacons",
    aromas: "Arôme",
    resultInfo:
      "Les quantités sont calculées à la fois en millilitres et en grammes...",
    liquidComposition: "Composition du Liquide",
    advancedDetails: "Détails Avancés",
    baseComposition: "Composition de la Base",
    nicotineComposition: "Composition de la Nicotine",
    aromaComposition: "Composition de l'Arôme",
    totals: "Totaux",
    totalVG: "VG totale",
    totalPG: "PG totale",
    ofTheBase: "de la base",
    ofAroma: "de l'arôme",
    actualFinalComposition: "Composition finale réelle",
    nicotineBaseComposition: "Composition de la nicotine",
    nicotineVG: "VG de la nicotine",
    nicotinePG: "PG de la nicotine",
    totalOverall: "Total général",
    createMixLiquids: "Créer un Mélange de vos Liquides",
    base1: "Base 1",
    base2: "Base 2",
    baseStrength: "Concentration de la Base",
    dilutionResultSummary:
      "Pour avoir une concentration d'arôme de {percentage}% dans votre liquide, vous avez besoin d'un total de {total}ml ({baseToAdd}ml de base + {aroma}ml d'arôme)",

    // Dilution d'Arôme
    calculateAromaDilution: "Calculer la Dilution de votre Arôme",
    aromaAmount: "Quantité d'arôme",
    dilutionPercentage: "Pourcentage de dilution",
    dilutionResult:
      "Pour avoir une concentration d'arôme de {percentage}% dans votre e-liquide, vous avez besoin d'un total de :",

    // Labo E-liquides
    increaseReduceStrength: "Augmenter ou Réduire votre Dosage",
    currentBase: "E-liquide actuel",
    currentNicotineStrength: "Dosage actuel de nicotine",
    desiredNicotineStrength: "Dosage de nicotine souhaité",
    calculateBase: "Calculer l'E-liquide",
    increaseNicotineMessage:
      "Pour augmenter votre liquide à {strength}mg de nicotine, ajoutez :",
    decreaseNicotineMessage:
      "Pour réduire votre liquide à {strength}mg de nicotine, ajoutez :",
    addNicotineBase:
      "{volume}ml de nicotine {composition} à {strength}mg/ml ({flacons} flacons de 10ml{extraMl}) ({grams}g) à votre liquide actuel",
    addNeutralBase:
      "{volume}ml de base neutre {composition} (0mg/ml) ({grams}g) à votre liquide actuel",
    extraMl: " + {amount}ml",
    finalVolumeN: "Volume final : {volume}ml ({grams}g)",
    finalVolumeL: "Volume final : {volume}ml ({grams}g)",
    shareRecipeTitle: "Partagez votre recette e-liquide",
    shareRecipeText: "Voici ma recette pour e-liquide:\n\n{details}",
    shareDialogTitle: "Partager avec",
    noResultToShare:
      "Aucun résultat à partager. Veuillez d'abord calculer une recette.",
    shareError: "Une erreur s'est produite lors du partage de la recette.",

    // Série Shot/Mix
    composeShotMixSeries: "Composez votre Série Shot/Mix",
    shotMixFrom: "Shot/Mix de :",
    readyEliquidFrom: "Quantité finale de votre E-liquide :",
    inhalationType: "Type d'inhalation",
    mtl: "Inhalation indirecte (MTL)",
    dl: "Inhalation directe (DL)",
    shotMixResult:
      "Pour obtenir {finalVolume}ml d'E-liquide prêt à l'emploi avec une concentration de nicotine de {desiredNicotine}mg/ml, vous avez besoin de :",
    yourAroma: "Votre arôme",
    neutralBase: "Base neutre",
    withAroma: "avec {percentage}% d'Arôme",
    enterValue: "Entrez la Valeur",

    // Paramètres
    language: "Langue",
    vapingEducativo: "Éducation au Vapotage",
    usoResponsabile: "Utilisation Responsable du Vapotage",
    usoResponsabileContent:
      "Le vapotage n'est pas un jeu : l'utiliser de manière responsable signifie connaître ses limites et respecter ses besoins. Assurez-vous d'utiliser uniquement des appareils de qualité et suivez les instructions de sécurité. Si vous êtes uniquement intéressé par les saveurs, envisagez d'utiliser des liquides sans nicotine pour éviter les risques inutiles. Le vapotage est un choix beaucoup moins nocif que le tabagisme traditionnel et peut être d'une grande aide pour ceux qui souhaitent arrêter de fumer progressivement.",
    usoNicotina: "Utilisation de la Nicotine",
    usoNicotinaContent:
      "La nicotine est une substance puissante qui crée une dépendance, mais elle peut être gérée intelligemment avec le vapotage. Si vous passez des cigarettes au vapotage, commencez par une concentration de nicotine similaire à celle que vous consommiez habituellement. Réduisez progressivement le niveau pour vous détacher lentement de la dépendance. Grâce au vapotage, vous pouvez choisir précisément le niveau de nicotine et le baisser progressivement jusqu'à zéro, améliorant votre bien-être sans le stress des cigarettes traditionnelles.",
    smettereDiscutetere: "Comment Arrêter les Cigarettes Traditionnelles",
    smettereDiscutetereContent:
      "Arrêter de fumer n'est pas facile, mais le vapotage peut être un soutien valable et moins traumatisant. L'utilisation d'une e-cigarette avec un niveau de nicotine initialement similaire à celui des cigarettes traditionnelles peut aider à satisfaire la dépendance physique sans les effets nocifs du goudron et des autres substances chimiques présentes dans la fumée traditionnelle. Une fois stabilisé, vous pouvez réduire progressivement le niveau de nicotine jusqu'à atteindre zéro. Cette approche progressive aide à réduire l'envie de fumer sans faire face à un choc soudain, améliorant progressivement votre qualité de vie.",
    faq: "Questions Fréquemment Posées",
    faqList: [
      {
        q: "Le vapotage est-il sûr ?",
        a: "Le vapotage est considéré comme nettement moins nocif que le tabagisme traditionnel, car il ne produit pas de goudron ni d'autres substances chimiques cancérigènes présentes dans les cigarettes. En utilisant uniquement des produits certifiés et en suivant les recommandations des experts, le vapotage est une alternative plus sûre pour ceux qui souhaitent arrêter de fumer.",
      },
      {
        q: "Le vapotage peut-il créer une dépendance ?",
        a: "Oui, le vapotage peut créer une dépendance si on utilise des liquides contenant de la nicotine. Cependant, grâce au vapotage, il est possible de contrôler le niveau de nicotine et de le réduire progressivement jusqu'à l'éliminer complètement, ce qui en fait un outil efficace pour arrêter définitivement de fumer.",
      },
      {
        q: "Le vapotage est-il adapté pour arrêter de fumer ?",
        a: "Beaucoup de gens ont arrêté de fumer grâce au vapotage. L'important est de l'utiliser comme un outil de transition, en réduisant progressivement la nicotine jusqu'à l'éliminer complètement. Le vapotage permet un contrôle précis de la quantité de nicotine consommée, rendant le parcours d'arrêt du tabac plus gérable et moins stressant.",
      },
      {
        q: "Quels sont les effets à long terme du vapotage ?",
        a: "Les effets à long terme du vapotage sont encore à l'étude, mais il est largement reconnu comme étant significativement moins nocif que le tabagisme traditionnel. En éliminant le goudron et d'autres substances toxiques, le vapotage représente un choix plus sain pour ceux qui souhaitent arrêter de fumer.",
      },
      {
        q: "Le vapotage améliore-t-il la qualité de vie par rapport au tabagisme traditionnel ?",
        a: "Oui, le vapotage améliore considérablement la qualité de vie par rapport au tabagisme traditionnel. Non seulement il réduit l'exposition aux substances chimiques nocives, mais il permet également d'éliminer progressivement la dépendance à la nicotine, améliorant la santé pulmonaire et la capacité respiratoire.",
      },
    ],
    beneficiSmettere: "Bénéfices de l'Arrêt du Tabac au Fil du Temps",
    beneficiSmettereList: [
      "Après 48 heures : Votre corps commence à éliminer la nicotine et votre goût et votre odorat commencent à s'améliorer.",
      "Après 1 semaine : Les niveaux de monoxyde de carbone dans votre sang diminuent, améliorant la circulation et la capacité respiratoire.",
      "Après 1 mois : Votre capacité pulmonaire s'améliore visiblement et le risque d'infections pulmonaires diminue.",
      "Après 3-9 mois : La toux et les difficultés respiratoires diminuent, améliorant encore votre qualité de vie.",
      "Après 1 an : Le risque de maladies cardiaques est réduit de moitié par rapport à quand vous fumiez.",
      "Après 5 ans : Le risque d'AVC est similaire à celui d'une personne qui n'a jamais fumé.",
      "Après 10 ans : Le risque de cancer du poumon est considérablement réduit, presque de moitié par rapport à un fumeur.",
    ],
    mitiEFatti: "Mythes et Faits sur le Vapotage",
    mitiEFattiList: [
      {
        mito: "Le vapotage est aussi nocif que le tabagisme.",
        fatto:
          "Les études montrent que le vapotage est significativement moins nocif que le tabagisme traditionnel. Le tabagisme produit plus de 7 000 substances chimiques, dont beaucoup sont cancérigènes, tandis que le vapotage réduit considérablement ce nombre, offrant une alternative plus sûre.",
      },
      {
        mito: "Le vapotage cause des problèmes pulmonaires comme le tabagisme.",
        fatto:
          "Le vapotage ne produit pas de goudron, l'un des principaux responsables des dommages pulmonaires causés par les cigarettes. En utilisant des liquides de qualité et en respectant les directives, le vapotage est un choix nettement moins nocif pour la santé pulmonaire.",
      },
      {
        mito: "Le vapotage n'aide pas à arrêter de fumer.",
        fatto:
          "De nombreuses personnes ont arrêté de fumer grâce au vapotage. Avec la bonne approche et en réduisant progressivement la nicotine, le vapotage peut être un outil efficace pour se libérer de la dépendance aux cigarettes traditionnelles, améliorant sa santé et sa qualité de vie.",
      },
    ],

    // Infobulles
    dilutionTooltip:
      "Calculez la quantité totale de liquide nécessaire pour atteindre le % de concentration d'arôme souhaité",
    nicotineTooltip:
      "Si vous souhaitez un liquide à 0mg, ou si vous avez déjà une base nicotinée, saisissez '0' dans ce champ",
    aromaTooltip:
      "Saisissez ici le % de dilution de votre arôme et découvrez combien de ML ajouter à votre e-liquide",
    resultTooltip:
      'La donnée totale sera utile dans "Quantité FINALE souhaitée" dans le calculateur approprié',
    mixTooltip:
      "Calculez le dosage et la composition finale en mélangeant deux e-liquides. Il est conseillé d'utiliser des e-liquides sans arôme pour éviter d'altérer le goût.",
    compositionTooltip:
      "La composition finale peut légèrement différer de celle souhaitée. Ceci est normal et garantit le meilleur résultat possible en tenant compte des compositions et de la compensation de tous les ingrédients (base, nicotine et arôme). Le calcul optimise les quantités pour se rapprocher le plus possible de la composition souhaitée.",
    resultInfo:
      "Les quantités sont calculées à la fois en millilitres et en grammes. Les valeurs en grammes sont basées sur des données officielles de densité pour offrir une option de mesure alternative, utile lorsque vous ne disposez pas d'un verre doseur.",
    nicotineStrengthInfo:
      "Utilisez ce champ uniquement en cas d'augmentation, sinon ignorez-le.",
    // Boutons et actions
    saveRecipe: "Enregistrer la Recette",
    exportToPDF: "Exporter en PDF",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",

    // Messages
    recipeSaved: "Recette enregistrée !",
    noSavedRecipes: "Aucune recette enregistrée.",
    nameYourRecipe: "Nommez votre Recette",
    finalNicotineStrength: "Concentration, Finale en Nicotine",
    blogVape: "Blog Vape",

    // Unités de mesure
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // Autres
    vg: "VG",
    pg: "PG",
    createdOn: "Créé le",

    // Nouvelles clés ajoutées
    mixYourBases: "Mélangez vos Bases",
    adjustNicotineConcentration: "Ajuster la Concentration de Nicotine",
    base1: "Base 1",
    base2: "Base 2",
    base1Strength: "Dosage Base 1",
    base2Strength: "Dosage Base 2",
    base1Composition: "Composition Base 1",
    base2Composition: "Composition Base 2",
    calculateMix: "Calculer le Mélange",
    availableNicotine: "Nicotine Disponible",
    desiredFinalQuantity: "Quantité Finale Souhaitée",
    baseAndPercentage: "%",
  },
  de: {
    // Menü und Navigation
    calculator: "Liquid selbst mischen",
    baseCalculator: "Liquid-Labor",
    shotMixSeries: "Shot/Mix-Serie",
    recipes: "Meine Rezepte",
    aromaDilution: "Aroma-Verdünnung",
    settings: "Einstellungen",
    dilutionResultDetails:
      "{total} ml Flüssigkeit ({baseToAdd}ml Basis + {aroma}ml Aroma)",
    shareSuccess: "Rezept geteilt",
    cookieConsentText:
      "Vape Formula Pro verwendet Cookies, um Ihr Erlebnis zu verbessern und personalisierte Werbung anzuzeigen.",
    cookieConsentDetails:
      'Die App ist nur für Personen ab 18 Jahren bestimmt. Durch Klicken auf "Akzeptieren" stimmen Sie der Verwendung von Cookies zu. Bitte lesen Sie unsere Datenschutzrichtlinie für weitere Details.',
    accept: "Akzeptieren",
    privacyPolicy: "Datenschutzerklärung",
    viewPrivacyPolicy: "Datenschutzerklärung anzeigen",
    vapeNewsTitle: "Vaping News & Trends",
    aggiorna: "Aktualisieren",
    caricamento: "Laden...",
    nessunArticolo: "Keine Artikel verfügbar",

    // Hauptrechner
    quantity: "Menge",
    finalQuantity: "Gewünschte Endmenge",
    finalComposition: "Endzusammensetzung",
    nicotine: "Nikotin",
    desiredNicotine: "Gewünschter Nikotingehalt",
    availableBaseStrength: "Verfügbare Nikotinshot-Stärke",
    nicotineComposition: "NIKOTIN-Zusammensetzung",
    aromas: "Aromen",
    addAroma: "% Aroma hinzufügen",
    calculate: "Berechnen",
    createMixLiquids: "Erstellen Sie einen Mix Ihrer Liquids",
    base1: "Basis 1",
    base2: "Basis 2",
    baseStrength: "Basisstärke",
    // Berechnungsergebnisse
    resultSummary:
      "Um {totalAmount}ml {vgPgRatio} mit {targetNic}mg Nikotin herzustellen, benötigen Sie:",
    baseToUse: "Gesamte zu verwendende Base",
    baseVG: "VG-Base",
    basePG: "PG-Base",
    nicotineBase: "Nikotin-Shots",
    flaconi: "Flaschen",
    from: "von",
    aroma: "Aroma",
    withAroma: "mit {percentage}% Aroma",
    enterValue: "Wert Eingeben",
    mixBasesResult: "Ergebnis der Basenmischung:",
    totalVolumeD: "Gesamtvolumen: {volume}ml ({grams}g)",
    finalCompositionD: "Endzusammensetzung: {ratio} VG/PG",
    finalStrengthD: "Endstärke: {strength}mg/ml",
    increaseNicotineMessage:
      "Um Ihre Flüssigkeit auf {strength}mg Nikotin zu erhöhen, fügen Sie hinzu:",
    decreaseNicotineMessage:
      "Um Ihre Flüssigkeit auf {strength}mg Nikotin zu reduzieren, fügen Sie hinzu:",
    addNicotineBase:
      "{volume}ml {composition} Nikotin mit {strength}mg/ml ({flacons} 10ml Flaschen{extraMl}) ({grams}g) zu Ihrer aktuellen Flüssigkeit",
    addNeutralBase:
      "{volume}ml {composition} neutrale Base (0mg/ml) ({grams}g) zu Ihrer aktuellen Flüssigkeit",
    extraMl: " + {amount}ml",
    finalVolumeN: "Endvolumen: {volume}ml ({grams}g)",
    finalVolumeL: "Endvolumen: {volume}ml ({grams}g)",
    shareRecipe: "Rezept teilen",
    recipeShared: "Rezept geteilt!",
    shareRecipeTitle: "Teilen Sie Ihr E-Liquid-Rezept",
    shareRecipeText: "Hier ist mein E-Liquid-Rezept:\n\n{details}",
    shareDialogTitle: "Teilen mit",
    noResultToShare:
      "Kein Ergebnis zum Teilen. Bitte berechnen Sie zuerst ein Rezept.",
    shareError: "Beim Teilen des Rezepts ist ein Fehler aufgetreten.",

    coilCalculator: "Coil-Rechner",
    targetResistanceMode: "Zielwiderstand-Modus",
    calculateResistanceMode: "Widerstandsberechnungs-Modus",
    wireType: "Drahttyp",
    wireConfiguration: "Drahtkonfiguration",
    coilSetup: "Coil-Setup",
    ribbonThickness: "Banddicke",
    ribbonWidth: "Bandbreite",
    wireDiameterAWG: "Drahtdurchmesser (AWG)",
    wireDiameterMM: "Drahtdurchmesser (mm)",
    targetResistance: "Zielwiderstand",
    numberOfWraps: "Anzahl der Wicklungen",
    innerCoilDiameter: "Innerer Wicklungsdurchmesser",
    legLength: "Beinlänge",
    batteryVoltage: "Batteriespannung",
    hideAdvancedInfo: "Erweiterte Info ausblenden",
    showAdvancedInfo: "Erweiterte Info anzeigen",
    calculateWraps: "Wicklungen berechnen",
    calculateResistance: "Widerstand berechnen",
    wireLength: "Drahtlänge",
    calculatedWraps: "Berechnete Wicklungen",
    suggestedWraps: "Empfohlene Wicklungen",
    halfWrapOption: "Halbe-Wicklung Option",
    actualResistance: "Tatsächlicher Widerstand",
    calculatedResistance: "Berechneter Widerstand",
    legLoss: "Beinverlust",
    heatCapacity: "Wärmekapazität",
    temperatureFactor: "Temperaturfaktor",
    surfaceArea: "Oberfläche",
    currentDraw: "Stromaufnahme",
    power: "Leistung",
    warningHighLegLoss:
      "Achtung: Der Beinverlust ist sehr hoch. Erwägen Sie eine Reduzierung der Länge.",
    warningSignificantLegLoss:
      "Hinweis: Der Beinverlust ist signifikant. Sie könnten die Länge optimieren.",

    // Erweiterter/Einfacher Modus
    simpleMode: "Einfacher Modus",
    advancedMode: "Erweiterter Modus",
    saveRecipe: "Rezept speichern",
    exportToPDF: "PDF exportieren",
    recipeSaved: "Rezept gespeichert!",
    neutralBase: "Neutrale Basis",
    toUse: "zu verwenden",
    nicotineBase: "Nikotinbasis",
    bottles: "Flaschen",
    aromas: "Aroma",
    resultInfo:
      "Die Mengen werden sowohl in Millilitern als auch in Gramm berechnet...",
    liquidComposition: "Liquid-Zusammensetzung",
    advancedDetails: "Erweiterte Details",
    baseComposition: "Basis-Zusammensetzung",
    nicotineComposition: "Nikotin-Zusammensetzung",
    aromaComposition: "Aroma-Zusammensetzung",
    totals: "Gesamtwerte",
    totalVG: "Gesamt-VG",
    totalPG: "Gesamt-PG",
    ofTheBase: "der Basis",
    ofAroma: "des Aromas",
    actualFinalComposition: "Tatsächliche Endzusammensetzung",
    nicotineBaseComposition: "Nikotin-Zusammensetzung",
    nicotineVG: "Nikotin-VG",
    nicotinePG: "Nikotin-PG",
    totalOverall: "Gesamtsumme",
    adjustNicotine: "Nikotinstärke Anpassen",
    mixYourBases: "Mischen Sie Ihre Basen",
    dilutionResultSummary:
      "Um eine Aromakonzentration von {percentage}% in Ihrem Liquid zu erhalten, benötigen Sie insgesamt {total}ml ({baseToAdd}ml Basis + {aroma}ml Aroma)",

    quickGuideTitle: "Coil-Rechner Bedienungsanleitung",
    modesExplained: "Die Zwei Berechnungsmodi",
    targetModeTitle: "Zielmodus",
    targetModeExplanation:
      "Verwenden Sie diesen Modus, wenn Sie wissen, welchen Widerstand Sie erreichen möchten (z.B. 0.5Ω). Geben Sie den gewünschten Wert ein und der Rechner zeigt Ihnen: \n- Wie viele Wicklungen Sie machen müssen \n- Wie viel Draht Sie benötigen \n- Den tatsächlichen Widerstand, den Sie erhalten werden",
    calculateModeTitle: "Berechnungsmodus",
    calculateModeExplanation:
      "Verwenden Sie diesen Modus, wenn Sie wissen, wie viele Wicklungen Sie machen möchten. Geben Sie die Anzahl der Wicklungen ein und erfahren Sie, welchen Widerstand Sie erhalten. Nützlich bei begrenztem Platz oder wenn Sie mit einer bestimmten Anzahl von Wicklungen arbeiten möchten.",
    inputFieldsGuide: "Eingabefelder-Anleitung",
    innerDiameterTitle: "Innendurchmesser der Wicklung",
    innerDiameterExplanation:
      "Der Durchmesser, um den Sie den Draht wickeln werden. Entspricht normalerweise dem Durchmesser des Schraubendrehers, den Sie zum Wickeln verwenden.",
    legLengthTitle: "Beinlänge",
    legLengthExplanation:
      "Die 'Beine' der Wicklung, die Sie in die Pfosten einführen. Empfohlen: 5-6mm zur Minimierung der Verluste.",

    advancedExplained: "Erklärung des erweiterten Modus",
    powerCalcsTitle: "Leistungsberechnungen",
    powerCalcsExplanation:
      "- Batteriespannung: typischerweise 4.2V bei voller Ladung\n- Stromaufnahme: Stromstärke durch die Wicklung\n- Leistung: tatsächliche Leistung der Wicklung",
    thermalFactorsTitle: "Thermische Faktoren",
    thermalFactorsExplanation:
      "- Wärmekapazität: speicherbare Wärmemenge\n- Oberfläche: Kontaktfläche mit der Flüssigkeit\n- Temperaturfaktor: Materialverhalten bei Wärme",

    resultsExplained: "Interpretation der Ergebnisse",
    basicResultsTitle: "Grundlegende Ergebnisse",
    basicResultsList:
      "Drahtlänge: benötigte Gesamtlänge\nBerechnete Wicklungen: genaue Anzahl\nEmpfohlene Wicklungen: praktisch gerundete Zahl\nHalbe-Wicklung Option: Feinabstimmung\nTatsächlicher Widerstand: endgültiger Messwert",

    warningsTitle: "Wichtige Warnungen",
    warningsList:
      "Beinverlust > 30%: Beine zu lang, reduzieren\nBeinverlust > 20%: Optimierung erwägen\nTatsächlicher Widerstand kann in der Praxis leicht abweichen",

    practicalTips: "Praktische Tipps",
    practicalTipsList:
      "Beginnen Sie mit Kanthal A1 Draht für bessere Stabilität\nFür Anfänger: Zielbereich zwischen 0.5Ω und 1.5Ω\nMessen Sie den Widerstand immer mit einem Ohmmeter\nBei Dual Coil halbiert sich der Gesamtwiderstand",

    calculating: "Berechnung läuft...",
    processingRequest: "Anfrage wird verarbeitet...",

    // Error Messages
    invalidInput: "Ungültige Eingabe",
    numberRequired: "Bitte geben Sie eine gültige Zahl ein",
    valueOutOfRange: "Wert außerhalb des gültigen Bereichs",

    // Success Messages
    calculationComplete: "Berechnung abgeschlossen",

    // Advanced Mode
    advancedModeWarning:
      "Der erweiterte Modus bietet zusätzliche technische Informationen",
    powerLimitWarning:
      "Achtung: Bitte überprüfen Sie die Leistungsgrenzen der Batterie",

    // Tooltips
    targetResistanceTooltip: "Gewünschter Zielwiderstand in Ohm",
    wrapsTooltip: "Anzahl der vollständigen Wicklungen",
    innerDiameterTooltip: "Innendurchmesser der Wicklung",
    legLengthTooltip: "Länge der Wicklungsbeine",

    // Unit Labels

    ohm: "Ω",
    mm: "mm",
    awg: "AWG",
    wraps: "Windungen",
    watts: "W",
    amps: "A",
    volts: "V",

    ohmCalculator: "Ohm Rechner",
    voltage: "Spannung",
    resistance: "Widerstand",
    current: "Stromstärke",
    power: "Leistung",
    selectPreset: "Dampfstil Auswählen",
    mtlBasicPreset: "MTL Basic (Anfänger)",
    mtlSaltPreset: "MTL Nikotinsalze",
    rdlMediumPreset: "RDL Mittel",
    dlCloudPreset: "DL Cloud Chasing",
    dlFlavorPreset: "DL Flavor Chasing",
    customPreset: "Benutzerdefiniert",
    mtlBasicDescription:
      "Klassisches Setup für Anfänger, ähnlich wie Zigarettenzug",
    mtlSaltDescription: "Optimiert für Nikotinsalz-Liquids",
    rdlMediumDescription: "Ausgewogen zwischen Geschmack und Dampf",
    dlCloudDescription: "Maximale Dampfproduktion",
    dlFlavorDescription: "Optimiert für maximalen Geschmack",
    customDescription: "Geben Sie Ihre benutzerdefinierten Werte ein",
    consumptionEstimates: "Verbrauchsschätzungen",
    puffsPerDay: "Züge pro Tag",
    puffDuration: "Zugdauer",
    batteryCapacity: "Akkukapazität",
    seconds: "Sek",
    calculate: "Berechnen",
    clear: "Löschen",
    estimatedLiquidConsumption: "Geschätzter Liquid-Verbrauch",
    estimatedBatteryLife: "Geschätzte Akkulaufzeit",
    hours: "Stunden",
    days: "Tage",
    vapingTips: "Dampf-Tipps",
    mtlTip:
      "MTL (Mund-zu-Lunge): ideal für ehemalige Raucher und Nikotin-Liquids",
    rdlTip:
      "RDL (eingeschränkter direkter Lungenzug): perfekt für mehr Geschmack bei komfortablem Zug",
    dlTip:
      "DL (direkter Lungenzug): maximale Dampfproduktion und Geschmacksintensität",
    nicSaltTip: "Für Nikotinsalze die Leistung unter 20W halten",
    powerTip: "Erhöhen Sie die Leistung schrittweise bis zum optimalen Punkt",
    calculationError:
      "Bitte geben Sie mindestens zwei Werte für die Berechnung ein",

    // Aroma-Verdünnung
    calculateAromaDilution: "Aroma-Verdünnung berechnen",
    aromaAmount: "Aroma-Menge",
    dilutionPercentage: "Verdünnungsprozentsatz",
    dilutionResult:
      "Für eine Aroma-Konzentration von {percentage}% in Ihrem Liquid benötigen Sie insgesamt:",

    // Liquid-Labor
    increaseReduceStrength: "Stärke erhöhen oder verringern",
    currentBase: "Aktuelles Liquid",
    currentNicotineStrength: "Aktuelle Nikotinstärke",
    desiredNicotineStrength: "Gewünschte Nikotinstärke",
    calculateBase: "Liquid berechnen",
    finalNicotineStrength: "Endgültige Nikotinstärke",

    // Shot/Mix-Serie
    composeShotMixSeries: "Shot/Mix-Serie zusammenstellen",
    shotMixFrom: "Shot/Mix von:",
    readyEliquidFrom: "Endmenge Ihres Liquids:",
    inhalationType: "Zugtyp",
    mtl: "Mouth-to-Lung (MTL)",
    dl: "Direct-Lung (DL)",
    shotMixResult:
      "Um {finalVolume}ml gebrauchsfertiges Liquid mit einer Nikotinkonzentration von {desiredNicotine}mg/ml zu erhalten, benötigen Sie:",
    yourAroma: "Ihr Aroma",
    neutralBase: "Neutrale Base",
    strength: "Stärke (mg/ml)",
    savedRecipes: "Gespeicherte Rezepte",

    // Einstellungen
    language: "Sprache",
    vapingEducativo: "Vaping-Aufklärung",
    usoResponsabile: "Verantwortungsvoller Gebrauch von E-Zigaretten",
    usoResponsabileContent:
      "Vaping ist kein Spiel: Es verantwortungsvoll zu nutzen bedeutet, seine Grenzen zu kennen und seine Bedürfnisse zu respektieren. Stellen Sie sicher, dass Sie nur Qualitätsgeräte verwenden und befolgen Sie die Sicherheitshinweise. Wenn Sie nur an Aromen interessiert sind, erwägen Sie die Verwendung nikotinfreier Flüssigkeiten, um unnötige Risiken zu vermeiden. Vaping ist eine viel weniger schädliche Wahl im Vergleich zum traditionellen Rauchen und kann eine große Hilfe für diejenigen sein, die schrittweise mit dem Rauchen aufhören möchten.",
    usoNicotina: "Nikotinkonsum",
    usoNicotinaContent:
      "Nikotin ist eine starke Substanz, die abhängig macht, aber sie kann mit Vaping intelligent gemanagt werden. Wenn Sie von Zigaretten auf Vaping umsteigen, beginnen Sie mit einer Nikotinkonzentration, die der ähnelt, die Sie gewöhnlich konsumiert haben. Reduzieren Sie den Gehalt schrittweise, um sich langsam von der Abhängigkeit zu lösen. Dank Vaping können Sie den Nikotingehalt präzise wählen und ihn schrittweise bis auf Null senken, was Ihr Wohlbefinden verbessert, ohne den Stress herkömmlicher Zigaretten.",
    smettereDiscutetere: "Wie man mit traditionellen Zigaretten aufhört",
    smettereDiscutetereContent:
      "Mit dem Rauchen aufzuhören ist nicht einfach, aber Vaping kann eine gültige und weniger traumatische Unterstützung sein. Die Verwendung einer E-Zigarette mit einem Nikotingehalt, der anfänglich dem traditioneller Zigaretten ähnelt, kann helfen, die körperliche Abhängigkeit zu befriedigen, ohne die schädlichen Auswirkungen von Teer und anderen Chemikalien im traditionellen Rauch. Sobald Sie sich stabilisiert haben, können Sie den Nikotingehalt schrittweise reduzieren, bis Sie Null erreichen. Dieser schrittweise Ansatz hilft, das Verlangen nach Rauchen zu reduzieren, ohne einen plötzlichen Schock zu erleben, und verbessert nach und nach Ihre Lebensqualität.",
    faq: "Häufig gestellte Fragen",
    faqList: [
      {
        q: "Ist Dampfen sicher?",
        a: "Dampfen gilt als deutlich weniger schädlich als traditionelles Rauchen, da es weder Teer noch andere krebserregende Chemikalien produziert, die in Zigaretten enthalten sind. Durch die Verwendung von ausschließlich zertifizierten Produkten und die Befolgung von Expertenempfehlungen ist Dampfen eine sicherere Alternative für diejenigen, die mit dem Rauchen aufhören möchten.",
      },
      {
        q: "Kann Dampfen süchtig machen?",
        a: "Ja, Dampfen kann süchtig machen, wenn Flüssigkeiten mit Nikotin verwendet werden. Dank des Dampfens ist es jedoch möglich, den Nikotinspiegel zu kontrollieren und schrittweise zu reduzieren, bis er vollständig eliminiert ist, was es zu einem effektiven Werkzeug macht, um endgültig mit dem Rauchen aufzuhören.",
      },
      {
        q: "Ist Dampfen geeignet, um mit dem Rauchen aufzuhören?",
        a: "Viele Menschen haben dank des Dampfens mit dem Rauchen aufgehört. Wichtig ist, es als Übergangswerkzeug zu nutzen und das Nikotin schrittweise zu reduzieren, bis es vollständig eliminiert ist. Dampfen ermöglicht eine präzise Kontrolle über die konsumierte Nikotinmenge, was den Weg zur Rauchentwöhnung handhabbarer und weniger stressig macht.",
      },
      {
        q: "Was sind die Langzeiteffekte des Dampfens?",
        a: "Die Langzeiteffekte des Dampfens werden noch untersucht, aber es ist weithin anerkannt, dass es deutlich weniger schädlich ist als das Rauchen traditioneller Zigaretten. Durch die Eliminierung von Teer und anderen giftigen Substanzen stellt Dampfen eine gesündere Wahl für diejenigen dar, die mit dem Rauchen aufhören möchten.",
      },
      {
        q: "Verbessert Dampfen die Lebensqualität im Vergleich zum traditionellen Rauchen?",
        a: "Ja, Dampfen verbessert die Lebensqualität im Vergleich zum traditionellen Rauchen erheblich. Es reduziert nicht nur die Exposition gegenüber schädlichen Chemikalien, sondern ermöglicht auch die schrittweise Eliminierung der Nikotinabhängigkeit, verbessert die Lungengesundheit und die Atemkapazität.",
      },
    ],
    beneficiSmettere: "Vorteile des Rauchstopps im Laufe der Zeit",
    beneficiSmettereList: [
      "Nach 48 Stunden: Ihr Körper beginnt, Nikotin abzubauen, und Ihr Geschmacks- und Geruchssinn beginnen sich zu verbessern.",
      "Nach 1 Woche: Der Kohlenmonoxidspiegel in Ihrem Blut sinkt, was die Durchblutung und die Atemkapazität verbessert.",
      "Nach 1 Monat: Ihre Lungenkapazität verbessert sich sichtbar und das Risiko von Lungeninfektionen sinkt.",
      "Nach 3-9 Monaten: Husten und Atembeschwerden nehmen ab, was Ihre Lebensqualität weiter verbessert.",
      "Nach 1 Jahr: Das Risiko von Herzkrankheiten halbiert sich im Vergleich zu der Zeit, als Sie noch geraucht haben.",
      "Nach 5 Jahren: Das Schlaganfallrisiko ist ähnlich dem einer Person, die nie geraucht hat.",
      "Nach 10 Jahren: Das Risiko von Lungenkrebs wird drastisch reduziert, fast halbiert im Vergleich zu einem Raucher.",
    ],
    mitiEFatti: "Mythen und Fakten über das Dampfen",
    mitiEFattiList: [
      {
        mito: "Dampfen ist genauso schädlich wie Rauchen.",
        fatto:
          "Studien zeigen, dass Dampfen deutlich weniger schädlich ist als traditionelles Rauchen. Rauchen produziert über 7.000 Chemikalien, von denen viele krebserregend sind, während Dampfen diese Zahl drastisch reduziert und eine sicherere Alternative bietet.",
      },
      {
        mito: "Dampfen verursacht Lungenprobleme wie Rauchen.",
        fatto:
          "Dampfen produziert keinen Teer, einen der Hauptverursacher von Lungenschäden durch Zigaretten. Durch die Verwendung von Qualitätsflüssigkeiten und die Einhaltung von Richtlinien ist Dampfen eine deutlich weniger schädliche Wahl für die Lungengesundheit.",
      },
      {
        mito: "Dampfen hilft nicht beim Aufhören mit dem Rauchen.",
        fatto:
          "Viele Menschen haben dank des Dampfens mit dem Rauchen aufgehört. Mit dem richtigen Ansatz und der schrittweisen Reduzierung von Nikotin kann Dampfen ein effektives Werkzeug sein, um sich von der Abhängigkeit von traditionellen Zigaretten zu befreien und die eigene Gesundheit und Lebensqualität zu verbessern.",
      },
    ],

    // Tooltips
    dilutionTooltip:
      "Berechnen Sie die Gesamtflüssigkeitsmenge, um den gewünschten Prozentsatz der Aroma-Konzentration zu erreichen",
    nicotineTooltip:
      "Wenn Sie ein 0mg-Liquid wünschen oder bereits eine nikotinhaltige Basis haben, geben Sie '0' in dieses Feld ein",
    aromaTooltip:
      "Geben Sie hier den Verdünnungsprozentsatz Ihres Aromas ein und erfahren Sie, wie viele ML Sie Ihrem Liquid hinzufügen müssen",
    resultTooltip:
      'Die Gesamtdaten werden in der "Gewünschten ENDMENGE" im entsprechenden Rechner nützlich sein',
    mixTooltip:
      "Berechnen Sie die endgültige Stärke und Zusammensetzung durch Mischen zweier Liquids. Es wird empfohlen, Liquids ohne Aroma zu verwenden, um den Geschmack nicht zu verändern.",
    compositionTooltip:
      "Die endgültige Zusammensetzung kann leicht von der gewünschten abweichen. Dies ist normal und gewährleistet das bestmögliche Ergebnis unter Berücksichtigung der Zusammensetzungen und des Ausgleichs aller Zutaten (Base, Nikotin und Aroma). Die Berechnung optimiert die Mengen, um der gewünschten Zusammensetzung so nahe wie möglich zu kommen.",
    resultInfo:
      "Die Mengen werden sowohl in Millilitern als auch in Gramm berechnet. Die Werte in Gramm basieren auf offiziellen Dichtedaten, um eine alternative Messoption zu bieten, die nützlich ist, wenn kein Messbecher zur Verfügung steht.",
    nicotineStrengthInfo:
      "Verwenden Sie dieses Feld nur im Falle einer Erhöhung, ansonsten ignorieren Sie es.",
    // Buttons und Aktionen
    saveRecipe: "Rezept speichern",
    exportToPDF: "Als PDF exportieren",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",

    // Nachrichten
    recipeSaved: "Rezept gespeichert!",
    noSavedRecipes: "Keine gespeicherten Rezepte.",
    nameYourRecipe: "Benennen Sie Ihr Rezept",

    // Maßeinheiten
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // Sonstiges
    vg: "VG",
    pg: "PG",
    createdOn: "Erstellt am",
    blogVape: "Vape Blog",

    // Neu hinzugefügte Schlüssel
    mixYourBases: "Mischen Sie Ihre Basen",
    adjustNicotineConcentration: "Nikotinkonzentration anpassen",
    base1: "Base 1",
    base2: "Base 2",
    base1Strength: "Stärke Base 1",
    base2Strength: "Stärke Base 2",
    base1Composition: "Zusammensetzung Base 1",
    base2Composition: "Zusammensetzung Base 2",
    calculateMix: "Mischung berechnen",
    availableNicotine: "Verfügbares Nikotin",
    desiredFinalQuantity: "Gewünschte Endmenge",
    baseAndPercentage: "%",
  },

  zh: {
    // 菜单和导航
    calculator: "制作电子烟油",
    baseCalculator: "电子烟油实验室",
    shotMixSeries: "Shot/Mix系列",
    recipes: "我的配方",
    aromaDilution: "香精稀释",
    settings: "设置",
    blogVape: "电子烟博客",
    vapeNewsTitle: "电子烟界新闻与趋势",
    aggiorna: "更新",
    caricamento: "加载中...",
    nessunArticolo: "暂无文章",

    calculating: "计算中...",
    processingRequest: "处理请求中...",

    // 错误信息
    invalidInput: "无效输入",
    numberRequired: "请输入有效数字",
    valueOutOfRange: "数值超出范围",

    // 成功信息
    calculationComplete: "计算完成",

    // 高级模式
    advancedModeWarning: "高级模式提供额外的技术信息",
    powerLimitWarning: "注意：请检查电池功率限制",

    // 工具提示
    targetResistanceTooltip: "目标电阻值（欧姆）",
    wrapsTooltip: "线圈圈数",
    innerDiameterTooltip: "线圈内径",
    legLengthTooltip: "引脚长度",

    // 单位标签
    units: {
      ohm: "Ω",
      mm: "毫米",
      awg: "AWG",
      wraps: "圈",
      watts: "瓦",
      amps: "安",
      volts: "伏",
    },

    ohmCalculator: "欧姆计算器",
    voltage: "电压",
    resistance: "电阻",
    current: "电流",
    power: "功率",
    selectPreset: "选择吸烟方式",
    mtlBasicPreset: "MTL基础（新手）",
    mtlSaltPreset: "MTL尼古丁盐",
    rdlMediumPreset: "RDL中等",
    dlCloudPreset: "DL云雾追逐",
    dlFlavorPreset: "DL口感追求",
    customPreset: "自定义",
    mtlBasicDescription: "类似传统香烟的基础设置",
    mtlSaltDescription: "针对尼古丁盐优化",
    rdlMediumDescription: "口感和烟雾的平衡",
    dlCloudDescription: "最大烟雾产量",
    dlFlavorDescription: "优化最佳口感",
    customDescription: "输入您的自定义值",
    consumptionEstimates: "消耗估算",
    puffsPerDay: "每日吸入次数",
    puffDuration: "每次吸入时长",
    batteryCapacity: "电池容量",
    seconds: "秒",
    calculate: "计算",
    clear: "清除",
    estimatedLiquidConsumption: "预计烟油消耗",
    estimatedBatteryLife: "预计电池寿命",
    hours: "小时",
    days: "天",
    vapingTips: "电子烟使用技巧",
    mtlTip: "MTL（口吸）：适合戒烟者和含尼古丁的烟油",
    rdlTip: "RDL（中度吸入）：适合想要更好口感同时保持舒适吸入的用户",
    dlTip: "DL（肺吸）：最大烟雾产量和味道强度",
    nicSaltTip: "使用尼古丁盐时，功率应保持在20W以下",
    powerTip: "逐渐增加功率直到找到最佳点",
    calculationError: "请至少输入两个值进行计算",

    // 主计算器
    // 主计算器
    quantity: "数量",
    finalQuantity: "目标最终数量",
    finalComposition: "最终成分",
    nicotine: "尼古丁",
    desiredNicotine: "目标尼古丁含量",
    availableBaseStrength: "可用基底浓度",
    nicotineComposition: "尼古丁成分",
    aromas: "香精",
    addAroma: "添加香精百分比",
    calculate: "计算",
    createMixLiquids: "混合您的烟油",
    base1: "基底1",
    base2: "基底2",
    baseStrength: "基底浓度",
    shareRecipe: "分享配方",
    recipeShared: "配方已分享！",
    shareRecipeTitle: "分享您的电子烟油配方",
    shareRecipeText: "这是我的电子烟油配方：\n\n{details}",
    shareDialogTitle: "分享至",
    noResultToShare: "暂无可分享的结果。请先计算配方。",
    shareError: "分享配方时出错。",
    shareSuccess: "配方分享成功",
    cookieConsentText: "Vape Formula Pro使用cookie以改善体验并显示个性化广告。",
    cookieConsentDetails:
      '本应用仅供18岁以上人士使用。点击"接受"即表示您同意使用cookie。详情请查看我们的隐私政策。',
    accept: "接受",

    // 计算结果
    resultSummary:
      "要制作{totalAmount}ml {vgPgRatio}，尼古丁含量{targetNic}mg，您需要：",
    baseToUse: "需要使用的总基底",
    baseVG: "基底VG",
    basePG: "基底PG",
    nicotineBase: "尼古丁基底",
    flaconi: "瓶",
    from: "来自",
    aroma: "香精",
    withAroma: "含{percentage}%香精",

    // 简单/高级模式
    simpleMode: "简单模式",
    advancedMode: "高级模式",
    saveRecipe: "保存配方",
    exportToPDF: "导出PDF",
    recipeSaved: "配方已保存！",
    neutralBase: "中性基底",
    toUse: "使用",
    nicotineBase: "尼古丁基底",
    bottles: "瓶",
    aromas: "香精",
    resultInfo: "数量以毫升和克计算...",
    liquidComposition: "烟油成分",
    advancedDetails: "高级详情",
    baseComposition: "基底成分",
    nicotineComposition: "尼古丁成分",
    aromaComposition: "香精成分",
    totals: "总计",
    totalVG: "VG总量",
    totalPG: "PG总量",
    ofTheBase: "基底的",
    ofAroma: "香精的",
    actualFinalComposition: "实际最终成分",
    nicotineBaseComposition: "尼古丁基底成分",
    nicotineVG: "尼古丁VG",
    nicotinePG: "尼古丁PG",
    totalOverall: "总体合计",
    enterValue: "输入数值",
    mixBasesResult: "基底混合结果：",

    coilCalculator: "发热丝计算器",
    targetResistanceMode: "目标电阻模式",
    calculateResistanceMode: "电阻计算模式",
    wireType: "线材类型",
    wireConfiguration: "线材配置",
    coilSetup: "线圈设置",
    ribbonThickness: "扁线厚度",
    ribbonWidth: "扁线宽度",
    wireDiameterAWG: "线径（AWG）",
    wireDiameterMM: "线径（毫米）",
    targetResistance: "目标电阻",
    numberOfWraps: "圈数",
    innerCoilDiameter: "线圈内径",
    legLength: "引脚长度",
    batteryVoltage: "电池电压",
    hideAdvancedInfo: "隐藏高级信息",
    showAdvancedInfo: "显示高级信息",
    calculateWraps: "计算圈数",
    calculateResistance: "计算电阻",
    wireLength: "线材长度",
    calculatedWraps: "计算出的圈数",
    suggestedWraps: "建议圈数",
    halfWrapOption: "半圈选项",
    actualResistance: "实际电阻",
    calculatedResistance: "计算出的电阻",
    legLoss: "引脚损耗",
    heatCapacity: "热容量",
    temperatureFactor: "温度系数",
    surfaceArea: "表面积",
    currentDraw: "电流消耗",
    power: "功率",
    warningHighLegLoss: "警告：引脚损耗过高。请考虑减少长度。",
    warningSignificantLegLoss: "注意：引脚损耗显著。您可能需要优化长度。",

    totalVolumeD: "总体积：{volume}ml（{grams}g）",
    finalCompositionD: "最终成分：{ratio} VG/PG",
    finalStrengthD: "最终浓度：{strength}mg/ml",

    // 香精稀释
    calculateAromaDilution: "计算香精稀释",
    aromaAmount: "香精数量",
    dilutionPercentage: "稀释百分比",
    dilutionResult: "要在您的烟油中获得{percentage}%的香精浓度，您需要总共：",

    // 烟油实验室
    increaseReduceStrength: "增加或减少您的浓度",
    currentBase: "当前烟油",
    currentNicotineStrength: "当前尼古丁浓度",
    desiredNicotineStrength: "目标尼古丁浓度",
    calculateBase: "计算烟油",
    privacyPolicy: "隐私政策",
    viewPrivacyPolicy: "查看隐私政策",

    // Shot/Mix系列
    composeShotMixSeries: "配制您的Shot/Mix系列",
    shotMixFrom: "Shot/Mix来自：",
    readyEliquidFrom: "最终电子烟油数量：",
    inhalationType: "吸入类型",
    mtl: "口吸（MTL）",
    dl: "肺吸（DL）",
    shotMixResult:
      "要获得{finalVolume}ml即用型电子烟油，尼古丁浓度为{desiredNicotine}mg/ml，您需要：",
    yourAroma: "您的香精",
    neutralBase: "中性基底",

    // 设置
    language: "语言",
    vapingEducativo: "电子烟教育",
    usoResponsabile: "负责任使用电子烟",
    usoResponsabileContent:
      "电子烟不是游戏：负责任地使用意味着了解自己的限制并尊重自己的需求。确保只使用优质设备并遵循安全说明。如果您只对口味感兴趣，可以考虑使用不含尼古丁的烟油以避免不必要的风险。电子烟比传统吸烟危害小得多，可以帮助那些想要逐渐戒烟的人。",
    usoNicotina: "尼古丁使用",
    usoNicotinaContent:
      "尼古丁是一种会上瘾的强效物质，但可以通过电子烟智能管理。如果您正在从香烟转向电子烟，开始时使用与您通常使用相似的尼古丁浓度。通过逐步降低浓度来慢慢摆脱依赖。感谢电子烟，您可以精确选择尼古丁水平并逐渐降低至零，在没有传统香烟压力的情况下改善您的健康。",
    smettereDiscutetere: "如何戒掉传统香烟",
    smettereDiscutetereContent:
      "戒烟并不容易，但电子烟可以是一个有效且不那么痛苦的支持。使用初始尼古丁水平与传统香烟相似的电子烟可以帮助满足身体依赖，而不会受到传统烟草中焦油和其他化学物质的有害影响。一旦稳定下来，您可以逐步降低尼古丁水平直至达到零。这种渐进式方法有助于减少吸烟欲望，而无需面对突然的冲击，逐步改善您的生活质量。",

    faq: "常见问题",
    faqList: [
      {
        q: "电子烟安全吗？",
        a: "电子烟被认为比传统吸烟危害小得多，因为它不产生焦油和香烟中存在的其他致癌化学物质。通过仅使用认证产品并遵循专家建议，电子烟是想要戒烟人士的更安全选择。",
      },
      {
        q: "电子烟会上瘾吗？",
        a: "是的，如果使用含有尼古丁的烟油，电子烟会上瘾。但是，通过电子烟，可以控制尼古丁水平并逐渐降低直至完全消除，使其成为完全戒烟的有效工具。",
      },
      {
        q: "电子烟适合戒烟吗？",
        a: "许多人通过电子烟成功戒烟。重要的是将其作为过渡工具使用，逐步减少尼古丁直至完全消除。电子烟 允许您精确控制所消耗的尼古丁量，使戒烟过程更容易管理且压力更小。",
      },
      {
        q: "电子烟的长期影响是什么？",
        a: "电子烟的长期影响仍在研究中，但普遍认为比传统香烟危害小得多。通过消除焦油和其他有毒物质，电子烟对想要戒烟的人来说是一个更健康的选择。",
      },
      {
        q: "与传统吸烟相比，电子烟能改善生活质量吗？",
        a: "是的，电子烟显著改善了与传统吸烟相比的生活质量。它不仅减少了对有害化学物质的暴露，还允许逐步消除尼古丁依赖，改善肺部健康和呼吸能力。",
      },
    ],
    beneficiSmettere: "戒烟的时间收益",
    beneficiSmettereList: [
      "48小时后：您的身体开始清除尼古丁，味觉和嗅觉开始改善。",
      "1周后：血液中的一氧化碳水平降低，改善循环和呼吸能力。",
      "1个月后：您的肺活量明显改善，肺部感染风险降低。",
      "3-9个月后：咳嗽和呼吸困难减少，进一步改善生活质量。",
      "1年后：心脏病风险比吸烟时降低一半。",
      "5年后：中风风险与从未吸烟的人相似。",
      "10年后：肺癌风险大大降低，几乎降低到吸烟者的一半。",
    ],
    mitiEFatti: "电子烟的谣言与事实",
    mitiEFattiList: [
      {
        mito: "电子烟和吸烟一样有害。",
        fatto:
          "研究表明，电子烟比传统吸烟危害小得多。吸烟产生超过7,000种化学物质，其中许多是致癌的，而电子烟大大减少了这个数量，提供了一个更安全的替代选择。",
      },
      {
        mito: "电子烟像吸烟一样会导致肺部问题。",
        fatto:
          "电子烟不产生焦油，焦油是香烟导致肺部损害的主要原因之一。通过使用优质烟油并遵守指导原则，电子烟对肺部健康的危害明显更小。",
      },
      {
        mito: "电子烟不能帮助戒烟。",
        fatto:
          "许多人已经通过电子烟成功戒烟。通过正确的方法和逐步减少尼古丁，电子烟可以成为摆脱传统香烟依赖的有效工具，改善健康和生活质量。",
      },
    ],

    // 工具提示
    dilutionTooltip: "计算达到您想要的香精浓度百分比所需的总烟油量",
    nicotineTooltip:
      '如果您想要0mg的烟油，或已有含尼古丁的基底，在此字段输入"0"',
    aromaTooltip: "在此输入您的香精稀释百分比，了解在烟油中需要添加多少毫升",
    resultTooltip: '总量数据将在相应计算器的"目标最终数量"中有用',
    mixTooltip:
      "通过混合两种烟油计算最终浓度和成分。建议使用不含香精的烟油以避免改变口味。",
    compositionTooltip:
      "最终成分可能与所需的略有不同。这是正常的，考虑到所有成分（基底、尼古丁和香精）的成分和补偿，可确保最佳可能的结果。计算会优化数量以尽可能接近所需的成分。",
    resultInfo:
      "数量以毫升和克计算。克的值基于官方密度数据，在没有量杯时提供替代测量选项",
    nicotineStrengthInfo: "仅在需要增加浓度时使用此字段，否则忽略",

    // 按钮和操作
    saveRecipe: "保存配方",
    exportToPDF: "导出为PDF",
    cancel: "取消",
    save: "保存",
    delete: "删除",
    adjustNicotine: "调整尼古丁浓度",
    mixYourBases: "混合您的基底",
    strength: "浓度 (mg/ml)",
    savedRecipes: "已保存的配方",
    finalNicotineStrength: "最终尼古丁强度",

    // 信息
    recipeSaved: "配方已保存！",
    noSavedRecipes: "没有保存的配方。",
    nameYourRecipe: "为您的配方命名",

    // 测量单位
    ml: "毫升",
    mg: "毫克",
    percentage: "%",

    // 其他
    vg: "VG",
    pg: "PG",
    createdOn: "创建于",
    increaseNicotineMessage: "要将您的烟油增加到{strength}mg尼古丁，添加：",
    decreaseNicotineMessage: "要将您的烟油减少到{strength}mg尼古丁，添加：",
    addNicotineBase:
      "向您当前的烟油中添加{volume}ml {composition}尼古丁基底，浓度{strength}mg/ml（{flacons}个10ml瓶{extraMl}）（{grams}g）",
    addNeutralBase:
      "向您当前的烟油中添加{volume}ml {composition}中性基底（0mg/ml）（{grams}g）",
    extraMl: " + {amount}ml",
    finalVolumeN: "最终体积：{volume}ml（{grams}g）",
    finalVolumeL: "最终体积：{volume}ml（{grams}g）",

    quickGuideTitle: "计算器使用指南",
    modesExplained: "两种计算模式",
    targetModeTitle: "目标模式",
    targetModeExplanation:
      "当您知道想要获得的电阻值时使用此模式（例如0.5Ω）。输入所需值，计算器会告诉您：\n- 需要缠绕多少圈\n- 需要使用多少线材\n- 您将获得的实际电阻",
    calculateModeTitle: "计算模式",
    calculateModeExplanation:
      "当您知道想要缠绕多少圈时使用此模式。输入圈数并发现您将获得的电阻值。在空间有限或偏好使用特定圈数时很有用。",

    inputFieldsGuide: "输入字段指南",
    innerDiameterTitle: "线圈内径",
    innerDiameterExplanation:
      "您将在其上缠绕线材的直径。通常对应于您将用于缠绕的螺丝刀的直径。",
    legLengthTitle: "引脚长度",
    legLengthExplanation: "将插入端子的电阻'腿'。建议：5-6mm以最小化损耗。",

    advancedExplained: "高级模式说明",
    powerCalcsTitle: "功率计算",
    powerCalcsExplanation:
      "- 电池电压：充满电的电池通常为4.2V\n- 电流消耗：将通过线圈的电流量\n- 功率：线圈将产生的实际功率",
    thermalFactorsTitle: "热因素",
    thermalFactorsExplanation:
      "- 热容量：线圈可以积累多少热量\n- 表面积：与烟油的接触面积\n- 温度系数：材料对热量的反应方式",

    resultsExplained: "如何解读结果",
    basicResultsTitle: "基本结果",
    basicResultsList:
      "线材长度：您需要的总线材长度\n计算的圈数：精确的圈数\n建议的圈数：实际可行的圆整圈数\n半圈选项：微调的替代选择\n实际电阻：您将测量到的最终值",

    warningsTitle: "重要警告",
    warningsList:
      "引脚损耗 > 30%：引脚太长，请减少\n引脚损耗 > 20%：考虑优化\n实际电阻在实践中可能略有变化",

    practicalTips: "实用技巧",
    practicalTipsList:
      "从Kanthal A1线材开始以获得更好的稳定性\n新手建议：目标在0.5Ω到1.5Ω之间\n始终使用欧姆表测量电阻\n双线圈时，总电阻将是单个线圈的一半",
  },

  "zh-TW": {
    // 選單和導航
    calculator: "製作電子煙油",
    baseCalculator: "電子煙油實驗室",
    shotMixSeries: "Shot/Mix系列",
    recipes: "我的配方",
    aromaDilution: "香精稀釋",
    settings: "設定",
    blogVape: "電子煙部落格",
    vapeNewsTitle: "電子煙界新聞與趨勢",
    aggiorna: "更新",
    caricamento: "載入中...",
    nessunArticolo: "暫無文章",

    calculating: "計算中...",
    processingRequest: "處理請求中...",

    // 錯誤訊息
    invalidInput: "無效輸入",
    numberRequired: "請輸入有效數字",
    valueOutOfRange: "數值超出範圍",

    // 成功訊息
    calculationComplete: "計算完成",

    // 進階模式
    advancedModeWarning: "進階模式提供額外的技術資訊",
    powerLimitWarning: "注意：請檢查電池功率限制",

    // 工具提示
    targetResistanceTooltip: "目標電阻值（歐姆）",
    wrapsTooltip: "線圈圈數",
    innerDiameterTooltip: "線圈內徑",
    legLengthTooltip: "引腳長度",

    // 單位標籤
    units: {
      ohm: "Ω",
      mm: "毫米",
      awg: "AWG",
      wraps: "圈",
      watts: "瓦",
      amps: "安",
      volts: "伏",
    },

    ohmCalculator: "歐姆計算器",
    voltage: "電壓",
    resistance: "電阻",
    current: "電流",
    power: "功率",
    selectPreset: "選擇吸煙方式",
    mtlBasicPreset: "MTL基礎（新手）",
    mtlSaltPreset: "MTL尼古丁鹽",
    rdlMediumPreset: "RDL中等",
    dlCloudPreset: "DL雲霧追逐",
    dlFlavorPreset: "DL口感追求",
    customPreset: "自訂",
    mtlBasicDescription: "類似傳統香菸的基礎設定",
    mtlSaltDescription: "針對尼古丁鹽最佳化",
    rdlMediumDescription: "口感和煙霧的平衡",
    dlCloudDescription: "最大煙霧產量",
    dlFlavorDescription: "最佳化口感",
    customDescription: "輸入您的自訂值",
    consumptionEstimates: "消耗估算",
    puffsPerDay: "每日吸入次數",
    puffDuration: "每次吸入時長",
    batteryCapacity: "電池容量",
    seconds: "秒",
    calculate: "計算",
    clear: "清除",
    estimatedLiquidConsumption: "預計煙油消耗",
    estimatedBatteryLife: "預計電池壽命",
    hours: "小時",
    days: "天",
    vapingTips: "電子煙使用技巧",
    mtlTip: "MTL（口吸）：適合戒煙者和含尼古丁的煙油",
    rdlTip: "RDL（中度吸入）：適合想要更好口感同時保持舒適吸入的使用者",
    dlTip: "DL（肺吸）：最大煙霧產量和味道強度",
    nicSaltTip: "使用尼古丁鹽時，功率應保持在20W以下",
    powerTip: "逐漸增加功率直到找到最佳點",
    calculationError: "請至少輸入兩個值進行計算",

    // 主計算器
    quantity: "數量",
    finalQuantity: "目標最終數量",
    finalComposition: "最終成分",
    nicotine: "尼古丁",
    desiredNicotine: "目標尼古丁含量",
    availableBaseStrength: "可用基底濃度",
    nicotineComposition: "尼古丁成分",
    aromas: "香精",
    addAroma: "添加香精百分比",
    calculate: "計算",
    createMixLiquids: "混合您的煙油",
    base1: "基底1",
    base2: "基底2",
    baseStrength: "基底濃度",
    shareRecipe: "分享配方",
    recipeShared: "配方已分享！",
    shareRecipeTitle: "分享您的電子煙油配方",
    shareRecipeText: "這是我的電子煙油配方：\n\n{details}",
    shareDialogTitle: "分享至",
    noResultToShare: "暫無可分享的結果。請先計算配方。",
    shareError: "分享配方時出錯。",
    shareSuccess: "配方分享成功",
    cookieConsentText: "Vape Formula Pro使用cookie以改善體驗並顯示個人化廣告。",
    cookieConsentDetails:
      "本應用程式僅供18歲以上人士使用。點擊「接受」即表示您同意使用cookie。詳情請查看我們的隱私政策。",
    accept: "接受",

    // 計算結果
    resultSummary:
      "要製作{totalAmount}ml {vgPgRatio}，尼古丁含量{targetNic}mg，您需要：",
    baseToUse: "需要使用的總基底",
    baseVG: "基底VG",
    basePG: "基底PG",
    nicotineBase: "尼古丁基底",
    flaconi: "瓶",
    from: "來自",
    aroma: "香精",
    withAroma: "含{percentage}%香精",

    // 簡單/進階模式
    simpleMode: "簡單模式",
    advancedMode: "進階模式",
    saveRecipe: "儲存配方",
    exportToPDF: "匯出PDF",
    recipeSaved: "配方已儲存！",
    neutralBase: "中性基底",
    toUse: "使用",
    nicotineBase: "尼古丁基底",
    bottles: "瓶",
    aromas: "香精",
    resultInfo: "數量以毫升和克計算...",
    liquidComposition: "煙油成分",
    advancedDetails: "進階詳情",
    baseComposition: "基底成分",
    nicotineComposition: "尼古丁成分",
    aromaComposition: "香精成分",
    totals: "總計",
    totalVG: "VG總量",
    totalPG: "PG總量",
    ofTheBase: "基底的",
    ofAroma: "香精的",
    actualFinalComposition: "實際最終成分",
    nicotineBaseComposition: "尼古丁基底成分",
    nicotineVG: "尼古丁VG",
    nicotinePG: "尼古丁PG",
    totalOverall: "總體合計",
    enterValue: "輸入數值",
    mixBasesResult: "基底混合結果：",

    coilCalculator: "發熱絲計算器",
    targetResistanceMode: "目標電阻模式",
    calculateResistanceMode: "電阻計算模式",
    wireType: "線材類型",
    wireConfiguration: "線材配置",
    coilSetup: "線圈設定",
    ribbonThickness: "扁線厚度",
    ribbonWidth: "扁線寬度",
    wireDiameterAWG: "線徑（AWG）",
    wireDiameterMM: "線徑（毫米）",
    targetResistance: "目標電阻",
    numberOfWraps: "圈數",
    innerCoilDiameter: "線圈內徑",
    legLength: "引腳長度",
    batteryVoltage: "電池電壓",
    hideAdvancedInfo: "隱藏進階資訊",
    showAdvancedInfo: "顯示進階資訊",
    calculateWraps: "計算圈數",
    calculateResistance: "計算電阻",
    wireLength: "線材長度",
    calculatedWraps: "計算出的圈數",
    suggestedWraps: "建議圈數",
    halfWrapOption: "半圈選項",
    actualResistance: "實際電阻",
    calculatedResistance: "計算出的電阻",
    legLoss: "引腳損耗",
    heatCapacity: "熱容量",
    temperatureFactor: "溫度係數",
    surfaceArea: "表面積",
    currentDraw: "電流消耗",
    power: "功率",
    warningHighLegLoss: "警告：引腳損耗過高。請考慮減少長度。",
    warningSignificantLegLoss: "注意：引腳損耗顯著。您可能需要最佳化長度。",

    totalVolumeD: "總體積：{volume}ml（{grams}g）",
    finalCompositionD: "最終成分：{ratio} VG/PG",
    finalStrengthD: "最終濃度：{strength}mg/ml",

    // 香精稀釋
    calculateAromaDilution: "計算香精稀釋",
    aromaAmount: "香精數量",
    dilutionPercentage: "稀釋百分比",
    dilutionResult: "要在您的煙油中獲得{percentage}%的香精濃度，您需要總共：",

    // 煙油實驗室
    increaseReduceStrength: "增加或減少您的濃度",
    currentBase: "當前煙油",
    currentNicotineStrength: "當前尼古丁濃度",
    desiredNicotineStrength: "目標尼古丁濃度",
    calculateBase: "計算煙油",
    privacyPolicy: "隱私政策",
    viewPrivacyPolicy: "查看隱私政策",

    // Shot/Mix系列
    composeShotMixSeries: "配製您的Shot/Mix系列",
    shotMixFrom: "Shot/Mix來自：",
    readyEliquidFrom: "最終電子煙油數量：",
    inhalationType: "吸入類型",
    mtl: "口吸（MTL）",
    dl: "肺吸（DL）",
    shotMixResult:
      "要獲得{finalVolume}ml即用型電子煙油，尼古丁濃度為{desiredNicotine}mg/ml，您需要：",
    yourAroma: "您的香精",
    neutralBase: "中性基底",

    // 設定
    language: "語言",
    vapingEducativo: "電子煙教育",
    usoResponsabile: "負責任使用電子煙",
    usoResponsabileContent:
      "電子煙不是遊戲：負責任地使用意味著了解自己的限制並尊重自己的需求。確保只使用優質設備並遵循安全說明。如果您只對口味感興趣，可以考慮使用不含尼古丁的煙油以避免不必要的風險。電子煙比傳統吸煙危害小得多，可以幫助那些想要逐漸戒煙的人。",
    usoNicotina: "尼古丁使用",
    usoNicotinaContent:
      "尼古丁是一種會上癮的強效物質，但可以通過電子煙智能管理。如果您正在從香菸轉向電子煙，開始時使用與您通常使用相似的尼古丁濃度。通過逐步降低濃度來慢慢擺脫依賴。感謝電子煙，您可以精確選擇尼古丁水平並逐漸降低至零，在沒有傳統香菸壓力的情況下改善您的健康。",
    smettereDiscutetere: "如何戒掉傳統香菸",
    smettereDiscutetereContent:
      "戒煙並不容易，但電子煙可以是一個有效且不那麼痛苦的支持。使用初始尼古丁水平與傳統香菸相似的電子煙可以幫助滿足身體依賴，而不會受到傳統煙草中焦油和其他化學物質的有害影響。一旦穩定下來，您可以逐步降低尼古丁水平直至達到零。這種漸進式方法有助於減少吸煙慾望，而無需面對突然的衝擊，逐步改善您的生活品質。",

    // FAQ部分
    faq: "常見問題",
    faqList: [
      {
        q: "電子煙安全嗎？",
        a: "電子煙被認為比傳統吸煙危害小得多，因為它不產生焦油和香菸中存在的其他致癌化學物質。通過僅使用認證產品並遵循專家建議，電子煙是想要戒煙人士的更安全選擇。",
      },
      {
        q: "電子煙會上癮嗎？",
        a: "是的，如果使用含有尼古丁的煙油，電子煙會上癮。但是，通過電子煙，可以控制尼古丁水平並逐漸降低直至完全消除，使其成為完全戒煙的有效工具。",
      },
      {
        q: "電子煙適合戒煙嗎？",
        a: "許多人通過電子煙成功戒煙。重要的是將其作為過渡工具使用，逐步減少尼古丁直至完全消除。電子煙允許您精確控制所消耗的尼古丁量，使戒煙過程更容易管理且壓力更小。",
      },
      {
        q: "電子煙的長期影響是什麼？",
        a: "電子煙的長期影響仍在研究中，但普遍認為比傳統香菸危害小得多。通過消除焦油和其他有毒物質，電子煙對想要戒煙的人來說是一個更健康的選擇。",
      },
      {
        q: "與傳統吸煙相比，電子煙能改善生活品質嗎？",
        a: "是的，電子煙顯著改善了與傳統吸煙相比的生活品質。它不僅減少了對有害化學物質的暴露，還允許逐步消除尼古丁依賴，改善肺部健康和呼吸能力。",
      },
    ],
    beneficiSmettere: "戒煙的時間收益",
    beneficiSmettereList: [
      "48小時後：您的身體開始清除尼古丁，味覺和嗅覺開始改善。",
      "1週後：血液中的一氧化碳水平降低，改善循環和呼吸能力。",
      "1個月後：您的肺活量明顯改善，肺部感染風險降低。",
      "3-9個月後：咳嗽和呼吸困難減少，進一步改善生活品質。",
      "1年後：心臟病風險比吸煙時降低一半。",
      "5年後：中風風險與從未吸煙的人相似。",
      "10年後：肺癌風險大大降低，幾乎降低到吸煙者的一半。",
    ],
    mitiEFatti: "電子煙的謠言與事實",
    mitiEFattiList: [
      {
        mito: "電子煙和吸煙一樣有害。",
        fatto:
          "研究表明，電子煙比傳統吸煙危害小得多。吸煙產生超過7,000種化學物質，其中許多是致癌的，而電子煙大大減少了這個數量，提供了一個更安全的替代選擇。",
      },
      {
        mito: "電子煙像吸煙一樣會導致肺部問題。",
        fatto:
          "電子煙不產生焦油，焦油是香菸導致肺部損害的主要原因之一。通過使用優質煙油並遵守指導原則，電子煙對肺部健康的危害明顯更小。",
      },
      {
        mito: "電子煙不能幫助戒煙。",
        fatto:
          "許多人已經通過電子煙成功戒煙。通過正確的方法和逐步減少尼古丁，電子煙可以成為擺脫傳統香菸依賴的有效工具，改善健康和生活品質。",
      },
    ],

    // 工具提示
    dilutionTooltip: "計算達到您想要的香精濃度百分比所需的總煙油量",
    nicotineTooltip:
      '如果您想要0mg的煙油，或已有含尼古丁的基底，在此欄位輸入"0"',
    aromaTooltip: "在此輸入您的香精稀釋百分比，了解在煙油中需要添加多少毫升",
    resultTooltip: '總量數據將在相應計算器的"目標最終數量"中有用',
    mixTooltip:
      "通過混合兩種煙油計算最終濃度和成分。建議使用不含香精的煙油以避免改變口味。",
    compositionTooltip:
      "最終成分可能與所需的略有不同。這是正常的，考慮到所有成分（基底、尼古丁和香精）的成分和補償，可確保最佳可能的結果。計算會最佳化數量以儘可能接近所需的成分。",
    resultInfo:
      "數量以毫升和克計算。克的值基於官方密度數據，在沒有量杯時提供替代測量選項",
    nicotineStrengthInfo: "僅在需要增加濃度時使用此欄位，否則忽略",

    // 按鈕和操作
    saveRecipe: "儲存配方",
    exportToPDF: "匯出為PDF",
    cancel: "取消",
    save: "儲存",
    delete: "刪除",
    adjustNicotine: "調整尼古丁濃度",
    mixYourBases: "混合您的基底",
    strength: "濃度 (mg/ml)",
    savedRecipes: "已儲存的配方",
    finalNicotineStrength: "最終尼古丁強度",

    // 訊息
    recipeSaved: "配方已儲存！",
    noSavedRecipes: "沒有儲存的配方。",
    nameYourRecipe: "為您的配方命名",

    // 測量單位
    ml: "毫升",
    mg: "毫克",
    percentage: "%",

    // 其他
    vg: "VG",
    pg: "PG",
    createdOn: "創建於",
    increaseNicotineMessage: "要將您的煙油增加到{strength}mg尼古丁，添加：",
    decreaseNicotineMessage: "要將您的煙油減少到{strength}mg尼古丁，添加：",
    addNicotineBase:
      "向您當前的煙油中添加{volume}ml {composition}尼古丁基底，濃度{strength}mg/ml（{flacons}個10ml瓶{extraMl}）（{grams}g）",
    addNeutralBase:
      "向您當前的煙油中添加{volume}ml {composition}中性基底（0mg/ml）（{grams}g）",
    extraMl: " + {amount}ml",
    finalVolumeN: "最終體積：{volume}ml（{grams}g）",
    finalVolumeL: "最終體積：{volume}ml（{grams}g）",

    quickGuideTitle: "計算器使用指南",
    modesExplained: "兩種計算模式",
    targetModeTitle: "目標模式",
    targetModeExplanation:
      "當您知道想要獲得的電阻值時使用此模式（例如0.5Ω）。輸入所需值，計算器會告訴您：\n- 需要纏繞多少圈\n- 需要使用多少線材\n- 您將獲得的實際電阻",
    calculateModeTitle: "計算模式",
    calculateModeExplanation:
      "當您知道想要纏繞多少圈時使用此模式。輸入圈數並發現您將獲得的電阻值。在空間有限或偏好使用特定圈數時很有用。",

    inputFieldsGuide: "輸入欄位指南",
    innerDiameterTitle: "線圈內徑",
    innerDiameterExplanation:
      "您將在其上纏繞線材的直徑。通常對應於您將用於纏繞的螺絲起子的直徑。",
    legLengthTitle: "引腳長度",
    legLengthExplanation: "將插入端子的電阻'腳'。建議：5-6mm以最小化損耗。",

    advancedExplained: "進階模式說明",
    powerCalcsTitle: "功率計算",
    powerCalcsExplanation:
      "- 電池電壓：充滿電的電池通常為4.2V\n- 電流消耗：將通過線圈的電流量\n- 功率：線圈將產生的實際功率",
    thermalFactorsTitle: "熱因素",
    thermalFactorsExplanation:
      "- 熱容量：線圈可以積累多少熱量\n- 表面積：與煙油的接觸面積\n- 溫度係數：材料對熱量的反應方式",

    resultsExplained: "如何解讀結果",
    basicResultsTitle: "基本結果",
    basicResultsList:
      "線材長度：您需要的總線材長度\n計算的圈數：精確的圈數\n建議的圈數：實際可行的圓整圈數\n半圈選項：微調的替代選擇\n實際電阻：您將測量到的最終值",

    warningsTitle: "重要警告",
    warningsList:
      "引腳損耗 > 30%：引腳太長，請減少\n引腳損耗 > 20%：考慮最佳化\n實際電阻在實踐中可能略有變化",

    practicalTips: "實用技巧",
    practicalTipsList:
      "從Kanthal A1線材開始以獲得更好的穩定性\n新手建議：目標在0.5Ω到1.5Ω之間\n始終使用歐姆表測量電阻\n雙線圈時，總電阻將是單個線圈的一半",
  },

  ru: {
    // Меню и навигация
    calculator: "Создать жидкость",
    baseCalculator: "Лаборатория жидкостей",
    shotMixSeries: "Серия Shot/Mix",
    recipes: "Мои рецепты",
    aromaDilution: "Разбавление аромы",
    settings: "Настройки",
    blogVape: "Блог о вейпинге",
    vapeNewsTitle: "Новости и тренды вейпинга",
    aggiorna: "Обновить",
    caricamento: "Загрузка...",
    nessunArticolo: "Нет доступных статей",

    calculating: "Идёт расчёт...",
    processingRequest: "Обработка запроса...",

    // Сообщения об ошибках
    invalidInput: "Неверный ввод",
    numberRequired: "Введите корректное число",
    valueOutOfRange: "Значение вне диапазона",

    // Сообщения об успехе
    calculationComplete: "Расчёт завершён",

    // Расширенный режим
    advancedModeWarning:
      "Расширенный режим предоставляет дополнительную техническую информацию",
    powerLimitWarning:
      "Внимание: Проверьте ограничения по мощности аккумулятора",

    // Подсказки
    targetResistanceTooltip: "Желаемое целевое сопротивление в омах",
    wrapsTooltip: "Количество полных витков",
    innerDiameterTooltip: "Внутренний диаметр спирали",
    legLengthTooltip: "Длина ножек спирали",

    // Единицы измерения
    units: {
      ohm: "Ω",
      mm: "мм",
      awg: "AWG",
      wraps: "витков",
      watts: "Вт",
      amps: "А",
      volts: "В",
    },

    ohmCalculator: "Калькулятор омов",
    voltage: "Напряжение",
    resistance: "Сопротивление",
    current: "Сила тока",
    power: "Мощность",
    selectPreset: "Выберите стиль парения",
    mtlBasicPreset: "MTL базовый (для начинающих)",
    mtlSaltPreset: "MTL солевой никотин",
    rdlMediumPreset: "RDL средний",
    dlCloudPreset: "DL для облаков",
    dlFlavorPreset: "DL для вкуса",
    customPreset: "Свой вариант",
    mtlBasicDescription:
      "Классическая настройка для начала, похожа на сигарету",
    mtlSaltDescription: "Оптимизировано для жидкостей с солевым никотином",
    rdlMediumDescription: "Баланс между вкусом и паром",
    dlCloudDescription: "Максимальное производство пара",
    dlFlavorDescription: "Оптимизировано для максимального вкуса",
    customDescription: "Введите свои значения",
    consumptionEstimates: "Оценка расхода",
    puffsPerDay: "Затяжек в день",
    puffDuration: "Длительность затяжки",
    batteryCapacity: "Ёмкость аккумулятора",
    seconds: "сек",
    calculate: "Рассчитать",
    clear: "Очистить",
    estimatedLiquidConsumption: "Ожидаемый расход жидкости",
    estimatedBatteryLife: "Ожидаемое время работы аккумулятора",
    hours: "часов",
    days: "дней",
    vapingTips: "Советы по вейпингу",
    mtlTip:
      "MTL (затяжка в рот): идеально для бывших курильщиков и жидкостей с никотином",
    rdlTip:
      "RDL (средняя затяжка): отлично подходит для тех, кто хочет больше вкуса при комфортной затяжке",
    dlTip:
      "DL (прямая затяжка в лёгкие): максимальное производство пара и интенсивность вкуса",
    nicSaltTip: "Для солевого никотина держите мощность ниже 20Вт",
    powerTip:
      "Постепенно увеличивайте мощность до поиска своей идеальной настройки",
    calculationError: "Введите как минимум два значения для расчёта",

    // Основной калькулятор
    quantity: "Количество",
    finalQuantity: "Желаемый конечный объём",
    finalComposition: "Конечный состав",
    nicotine: "Никотин",
    desiredNicotine: "Желаемая крепость никотина",
    availableBaseStrength: "Доступная крепость основы",
    nicotineComposition: "Состав никотина",
    aromas: "Ароматизаторы",
    addAroma: "Добавить % ароматизатора",
    calculate: "Рассчитать",
    createMixLiquids: "Создать микс жидкостей",
    base1: "Основа 1",
    base2: "Основа 2",
    baseStrength: "Крепость основы",
    shareRecipe: "Поделиться рецептом",
    recipeShared: "Рецепт опубликован!",
    shareRecipeTitle: "Поделиться рецептом жидкости",
    shareRecipeText: "Вот мой рецепт жидкости:\n\n{details}",
    shareDialogTitle: "Поделиться с",
    noResultToShare:
      "Нет результатов для публикации. Сначала рассчитайте рецепт.",
    shareError: "Произошла ошибка при публикации рецепта.",
    shareSuccess: "Рецепт опубликован",
    cookieConsentText:
      "Vape Formula Pro использует cookies для улучшения опыта и показа персонализированной рекламы.",
    cookieConsentDetails:
      "Приложение предназначено для лиц старше 18 лет. Нажимая «Принять», вы соглашаетесь с использованием cookies. Подробности в нашей Политике конфиденциальности.",
    accept: "Принять",

    // Результаты расчёта
    resultSummary:
      "Для создания {totalAmount}мл {vgPgRatio} с {targetNic}мг никотина вам нужно:",
    baseToUse: "Общая основа для использования",
    baseVG: "VG основы",
    basePG: "PG основы",
    nicotineBase: "Никотиновая основа",
    flaconi: "флаконов",
    from: "из",
    aroma: "Ароматизатор",
    withAroma: "с {percentage}% ароматизатора",

    // Простой/расширенный режим
    simpleMode: "Простой режим",
    advancedMode: "Расширенный режим",
    saveRecipe: "Сохранить рецепт",
    exportToPDF: "Экспорт в PDF",
    recipeSaved: "Рецепт сохранён!",
    neutralBase: "Нейтральная основа",
    toUse: "использовать",
    nicotineBase: "Никотиновая основа",
    bottles: "флаконов",
    aromas: "Ароматизатор",
    resultInfo: "Количества рассчитаны в миллилитрах и граммах...",
    liquidComposition: "Состав жидкости",
    advancedDetails: "Расширенные детали",
    baseComposition: "Состав основы",
    nicotineComposition: "Состав никотина",
    aromaComposition: "Состав ароматизатора",
    totals: "Итого",
    totalVG: "Всего VG",
    totalPG: "Всего PG",
    ofTheBase: "основы",
    ofAroma: "ароматизатора",
    actualFinalComposition: "Фактический конечный состав",
    nicotineBaseComposition: "Состав никотиновой основы",
    nicotineVG: "VG никотина",
    nicotinePG: "PG никотина",
    totalOverall: "Общий итог",
    enterValue: "Введите значение",
    mixBasesResult: "Результат смешивания основ:",

    coilCalculator: "Калькулятор спиралей",
    targetResistanceMode: "Режим целевого сопротивления",
    calculateResistanceMode: "Режим расчёта сопротивления",
    wireType: "Тип проволоки",
    wireConfiguration: "Конфигурация проволоки",
    coilSetup: "Настройка спирали",
    ribbonThickness: "Толщина ленты",
    ribbonWidth: "Ширина ленты",
    wireDiameterAWG: "Диаметр проволоки (AWG)",
    wireDiameterMM: "Диаметр проволоки (мм)",
    targetResistance: "Целевое сопротивление",
    numberOfWraps: "Количество витков",
    innerCoilDiameter: "Внутренний диаметр спирали",
    legLength: "Длина ножек",
    batteryVoltage: "Напряжение аккумулятора",
    hideAdvancedInfo: "Скрыть расширенную информацию",
    showAdvancedInfo: "Показать расширенную информацию",
    calculateWraps: "Рассчитать витки",
    calculateResistance: "Рассчитать сопротивление",
    wireLength: "Длина проволоки",
    calculatedWraps: "Рассчитанные витки",
    suggestedWraps: "Рекомендуемые витки",
    halfWrapOption: "Вариант половины витка",
    actualResistance: "Фактическое сопротивление",
    calculatedResistance: "Расчётное сопротивление",
    legLoss: "Потери в ножках",
    heatCapacity: "Теплоёмкость",
    temperatureFactor: "Температурный коэффициент",
    surfaceArea: "Площадь поверхности",
    currentDraw: "Потребление тока",
    power: "Мощность",
    warningHighLegLoss:
      "Внимание: Потери в ножках слишком высокие. Рассмотрите уменьшение длины.",
    warningSignificantLegLoss:
      "Примечание: Потери в ножках значительны. Возможно, стоит оптимизировать длину.",

    totalVolumeD: "Общий объём: {volume}мл ({grams}г)",
    finalCompositionD: "Конечный состав: {ratio} VG/PG",
    finalStrengthD: "Конечная крепость: {strength}мг/мл",

    // Разбавление ароматизатора
    calculateAromaDilution: "Рассчитать разбавление ароматизатора",
    aromaAmount: "Количество ароматизатора",
    dilutionPercentage: "Процент разбавления",
    dilutionResult:
      "Для получения концентрации ароматизатора {percentage}% в вашей жидкости нужно всего:",

    // Лаборатория жидкостей
    increaseReduceStrength: "Увеличить или уменьшить крепость",
    currentBase: "Текущая жидкость",
    currentNicotineStrength: "Текущая крепость никотина",
    desiredNicotineStrength: "Желаемая крепость никотина",
    calculateBase: "Рассчитать жидкость",
    privacyPolicy: "Политика конфиденциальности",
    viewPrivacyPolicy: "Посмотреть политику конфиденциальности",

    // Shot/Mix серия
    composeShotMixSeries: "Создать серию Shot/Mix",
    shotMixFrom: "Shot/Mix из:",
    readyEliquidFrom: "Конечное количество жидкости:",
    inhalationType: "Тип затяжки",
    mtl: "Затяжка в рот (MTL)",
    dl: "Прямая затяжка (DL)",
    shotMixResult:
      "Для получения {finalVolume}мл готовой жидкости с концентрацией никотина {desiredNicotine}мг/мл вам нужно:",
    yourAroma: "Ваш ароматизатор",
    neutralBase: "Нейтральная основа",

    // Настройки
    language: "Язык",
    vapingEducativo: "Обучение вейпингу",
    usoResponsabile: "Ответственное использование вейпинга",
    usoResponsabileContent:
      "Вейпинг – это не игра: ответственное использование означает знание своих границ и уважение к своим потребностям. Убедитесь, что вы используете только качественные устройства и следуете инструкциям по безопасности. Если вас интересуют только вкусы, рассмотрите использование жидкостей без никотина, чтобы избежать ненужных рисков. Вейпинг значительно менее вреден, чем традиционное курение, и может быть отличным помощником для тех, кто хочет постепенно бросить курить.",
    usoNicotina: "Использование никотина",
    usoNicotinaContent:
      "Никотин – это мощное вещество, вызывающее зависимость, но его можно разумно контролировать с помощью вейпинга. Если вы переходите с сигарет на вейпинг, начните с концентрации никотина, похожей на ту, к которой вы привыкли. Постепенно снижайте уровень, чтобы медленно избавиться от зависимости. Благодаря вейпингу вы можете точно выбрать уровень никотина и постепенно снизить его до нуля, улучшая своё здоровье без стресса от традиционных сигарет.",
    smettereDiscutetere: "Как бросить курить традиционные сигареты",
    smettereDiscutetereContent:
      "Бросить курить нелегко, но вейпинг может стать действенной и менее травматичной поддержкой. Использование электронной сигареты с уровнем никотина, изначально похожим на уровень в традиционных сигаретах, может помочь удовлетворить физическую зависимость без вредного воздействия смол и других химических веществ, присутствующих в традиционном дыме. После стабилизации вы можете постепенно снижать уровень никотина до нуля. Этот постепенный подход помогает уменьшить желание курить без резкого шока, постепенно улучшая качество вашей жизни.",

    faq: "Часто задаваемые вопросы",
    faqList: [
      {
        q: "Безопасен ли вейпинг?",
        a: "Вейпинг считается значительно менее вредным, чем традиционное курение, поскольку не производит смол и других канцерогенных химических веществ, присутствующих в сигаретах. При использовании только сертифицированных продуктов и следовании рекомендациям экспертов вейпинг является более безопасной альтернативой для тех, кто хочет бросить курить.",
      },
      {
        q: "Вызывает ли вейпинг зависимость?",
        a: "Да, вейпинг может вызвать зависимость при использовании жидкостей, содержащих никотин. Однако благодаря вейпингу можно контролировать уровень никотина и постепенно снижать его до полного отказа, делая его эффективным инструментом для окончательного отказа от курения.",
      },
      {
        q: "Подходит ли вейпинг для отказа от курения?",
        a: "Многие люди бросили курить благодаря вейпингу. Важно использовать его как переходный инструмент, постепенно снижая никотин до полного отказа. Вейпинг позволяет иметь точный контроль над количеством потребляемого никотина, делая процесс отказа от курения более управляемым и менее стрессовым.",
      },
      {
        q: "Каковы долгосрочные эффекты вейпинга?",
        a: "Долгосрочные эффекты вейпинга всё ещё изучаются, но широко признано, что он значительно менее вреден, чем курение традиционных сигарет. Устраняя смолы и другие токсичные вещества, вейпинг представляет собой более здоровый выбор для тех, кто хочет отказаться от курения.",
      },
      {
        q: "Улучшает ли вейпинг качество жизни по сравнению с традиционным курением?",
        a: "Да, вейпинг значительно улучшает качество жизни по сравнению с традиционным курением. Он не только уменьшает воздействие вредных химических веществ, но и позволяет постепенно избавиться от никотиновой зависимости, улучшая здоровье лёгких и дыхательную способность.",
      },
    ],
    beneficiSmettere: "Преимущества отказа от курения во времени",
    beneficiSmettereList: [
      "После 48 часов: Ваш организм начинает выводить никотин, вкус и обоняние начинают улучшаться.",
      "После 1 недели: Уровень угарного газа в крови снижается, улучшается кровообращение и дыхательная способность.",
      "После 1 месяца: Ваша лёгочная функция заметно улучшается, и риск лёгочных инфекций снижается.",
      "После 3-9 месяцев: Кашель и затруднённое дыхание уменьшаются, дальше улучшая качество жизни.",
      "После 1 года: Риск сердечных заболеваний снижается вдвое по сравнению с периодом курения.",
      "После 5 лет: Риск инсульта становится сравним с риском у человека, который никогда не курил.",
      "После 10 лет: Риск рака лёгких резко снижается, почти до половины по сравнению с курильщиком.",
    ],
    mitiEFatti: "Мифы и факты о вейпинге",
    mitiEFattiList: [
      {
        mito: "Вейпинг так же вреден, как курение.",
        fatto:
          "Исследования показывают, что вейпинг значительно менее вреден, чем традиционное курение. Курение производит более 7000 химических веществ, многие из которых канцерогенны, в то время как вейпинг резко сокращает это число, предлагая более безопасную альтернативу.",
      },
      {
        mito: "Вейпинг вызывает проблемы с лёгкими, как и курение.",
        fatto:
          "Вейпинг не производит смол, одной из основных причин повреждения лёгких от сигарет. При использовании качественных жидкостей и соблюдении рекомендаций, вейпинг является значительно менее вредным для здоровья лёгких.",
      },
      {
        mito: "Вейпинг не помогает бросить курить.",
        fatto:
          "Многие люди успешно бросили курить благодаря вейпингу. С правильным подходом и постепенным снижением никотина, вейпинг может быть эффективным инструментом для избавления от зависимости от традиционных сигарет, улучшая здоровье и качество жизни.",
      },
    ],

    // Подсказки
    dilutionTooltip:
      "Рассчитайте общее количество жидкости для достижения желаемого процента концентрации ароматизатора",
    nicotineTooltip:
      'Если вы хотите жидкость с 0мг или у вас уже есть никотиновая база, введите "0" в это поле',
    aromaTooltip:
      "Введите здесь процент разбавления вашего ароматизатора и узнайте, сколько МЛ добавить в вашу жидкость",
    resultTooltip:
      'Данные об общем количестве будут полезны в "Желаемом конечном количестве" в соответствующем калькуляторе',
    mixTooltip:
      "Рассчитайте конечную крепость и состав, смешивая две жидкости. Рекомендуется использовать жидкости без ароматизатора, чтобы избежать изменения вкуса.",
    compositionTooltip:
      "Конечный состав может немного отличаться от желаемого. Это нормально и обеспечивает наилучший возможный результат с учётом составов и компенсации всех ингредиентов (основа, никотин и ароматизатор). Расчёт оптимизирует количества для максимального приближения к желаемому составу.",
    resultInfo:
      "Количества рассчитаны как в миллилитрах, так и в граммах. Значения в граммах основаны на официальных данных плотности для предоставления альтернативного варианта измерения, полезного при отсутствии мерного стакана",
    nicotineStrengthInfo:
      "Используйте это поле только в случае увеличения, в противном случае игнорируйте",

    // Кнопки и действия
    saveRecipe: "Сохранить рецепт",
    exportToPDF: "Экспорт в PDF",
    cancel: "Отмена",
    save: "Сохранить",
    delete: "Удалить",
    adjustNicotine: "Настроить крепость никотина",
    mixYourBases: "Смешать основы",
    strength: "Крепость (мг/мл)",
    savedRecipes: "Сохранённые рецепты",
    finalNicotineStrength: "Конечная крепость никотина",

    // Сообщения
    recipeSaved: "Рецепт сохранён!",
    noSavedRecipes: "Нет сохранённых рецептов.",
    nameYourRecipe: "Назовите свой рецепт",

    // Единицы измерения
    ml: "мл",
    mg: "мг",
    percentage: "%",

    // Прочее
    vg: "VG",
    pg: "PG",
    createdOn: "Создано",
    increaseNicotineMessage:
      "Чтобы увеличить крепость вашей жидкости до {strength}мг никотина, добавьте:",
    decreaseNicotineMessage:
      "Чтобы уменьшить крепость вашей жидкости до {strength}мг никотина, добавьте:",
    addNicotineBase:
      "{volume}мл никотиновой основы {composition} крепостью {strength}мг/мл ({flacons} флаконов по 10мл{extraMl}) ({grams}г) к вашей текущей жидкости",
    addNeutralBase:
      "{volume}мл нейтральной основы {composition} (0мг/мл) ({grams}г) к вашей текущей жидкости",
    extraMl: " + {amount}мл",
    finalVolumeN: "Конечный объём: {volume}мл ({grams}г)",
    finalVolumeL: "Конечный объём: {volume}мл ({grams}г)",

    quickGuideTitle: "Руководство по использованию калькулятора",
    modesExplained: "Два режима расчёта",
    targetModeTitle: "Целевой режим",
    targetModeExplanation:
      "Используйте этот режим, когда знаете, какое сопротивление хотите получить (например, 0.5Ω). Введите желаемое значение, и калькулятор скажет вам:\n- Сколько витков сделать\n- Сколько проволоки использовать\n- Какое фактическое сопротивление вы получите",
    calculateModeTitle: "Режим расчёта",
    calculateModeExplanation:
      "Используйте этот режим, когда знаете, сколько витков хотите сделать. Введите количество витков и узнайте, какое сопротивление получите. Полезно при ограниченном пространстве или когда предпочитаете работать с определённым количеством витков.",

    inputFieldsGuide: "Руководство по полям ввода",
    innerDiameterTitle: "Внутренний диаметр спирали",
    innerDiameterExplanation:
      "Диаметр, на котором вы будете наматывать проволоку. Обычно соответствует диаметру отвёртки, которую вы будете использовать для намотки.",
    legLengthTitle: "Длина ножек",
    legLengthExplanation:
      "'Ножки' сопротивления, которые вы вставите в клеммы. Рекомендуется: 5-6мм для минимизации потерь.",

    advancedExplained: "Объяснение расширенного режима",
    powerCalcsTitle: "Расчёты мощности",
    powerCalcsExplanation:
      "- Напряжение аккумулятора: обычно 4.2В для полностью заряженного\n- Потребление тока: сколько тока пройдёт через спираль\n- Мощность: фактическая мощность, которую разовьёт спираль",
    thermalFactorsTitle: "Тепловые факторы",
    thermalFactorsExplanation:
      "- Теплоёмкость: сколько тепла может накопить спираль\n- Площадь поверхности: площадь контакта с жидкостью\n- Температурный коэффициент: как материал реагирует на нагрев",

    resultsExplained: "Как интерпретировать результаты",
    basicResultsTitle: "Основные результаты",
    basicResultsList:
      "Длина проволоки: сколько проволоки вам понадобится\nРассчитанные витки: точное число витков\nРекомендуемые витки: практичное округлённое число\nВариант половины витка: альтернатива для точной настройки\nФактическое сопротивление: конечное значение, которое вы измерите",

    warningsTitle: "Важные предупреждения",
    warningsList:
      "Потери в ножках > 30%: ножки слишком длинные, уменьшите\nПотери в ножках > 20%: рассмотрите оптимизацию\nФактическое сопротивление может немного отличаться на практике",

    practicalTips: "Практические советы",
    practicalTipsList:
      "Начните с проволоки Kanthal A1 для лучшей стабильности\nДля начинающих: цель между 0.5Ω и 1.5Ω\nВсегда измеряйте сопротивление омметром\nВ двойной спирали общее сопротивление будет половиной от одиночной",
  },

  ko: {
    // 메뉴 및 네비게이션
    calculator: "액상 제조하기",
    baseCalculator: "액상 연구소",
    shotMixSeries: "샷/믹스 시리즈",
    recipes: "내 레시피",
    aromaDilution: "향료 희석",
    settings: "설정",
    blogVape: "베이핑 블로그",
    vapeNewsTitle: "베이핑 뉴스 & 트렌드",
    aggiorna: "업데이트",
    caricamento: "로딩 중...",
    nessunArticolo: "사용 가능한 기사 없음",

    calculating: "계산 중...",
    processingRequest: "요청 처리 중...",

    // 오류 메시지
    invalidInput: "잘못된 입력",
    numberRequired: "유효한 숫자를 입력하세요",
    valueOutOfRange: "범위를 벗어난 값",

    // 성공 메시지
    calculationComplete: "계산 완료",

    // 고급 모드
    advancedModeWarning: "고급 모드에서는 추가 기술 정보를 제공합니다",
    powerLimitWarning: "주의: 배터리 전력 제한을 확인하세요",

    // 툴팁
    targetResistanceTooltip: "목표 저항값 (옴)",
    wrapsTooltip: "코일 감기 횟수",
    innerDiameterTooltip: "코일 내경",
    legLengthTooltip: "다리 길이",

    // 단위 라벨
    units: {
      ohm: "Ω",
      mm: "mm",
      awg: "AWG",
      wraps: "회",
      watts: "W",
      amps: "A",
      volts: "V",
    },

    ohmCalculator: "옴 계산기",
    voltage: "전압",
    resistance: "저항",
    current: "전류",
    power: "전력",
    selectPreset: "베이핑 스타일 선택",
    mtlBasicPreset: "MTL 기본 (초보자용)",
    mtlSaltPreset: "MTL 니코틴 솔트",
    rdlMediumPreset: "RDL 중간",
    dlCloudPreset: "DL 클라우드 체이싱",
    dlFlavorPreset: "DL 맛 추구",
    customPreset: "사용자 정의",
    mtlBasicDescription: "담배와 비슷한 기본 설정",
    mtlSaltDescription: "니코틴 솔트용으로 최적화",
    rdlMediumDescription: "맛과 증기량의 균형",
    dlCloudDescription: "최대 증기 생산",
    dlFlavorDescription: "최대 맛 최적화",
    customDescription: "사용자 정의 값 입력",
    consumptionEstimates: "소비량 추정",
    puffsPerDay: "하루 흡입 횟수",
    puffDuration: "흡입 시간",
    batteryCapacity: "배터리 용량",
    seconds: "초",
    calculate: "계산",
    clear: "초기화",
    estimatedLiquidConsumption: "예상 액상 소비량",
    estimatedBatteryLife: "예상 배터리 수명",
    hours: "시간",
    days: "일",
    vapingTips: "베이핑 팁",
    mtlTip: "MTL (입폐): 금연자와 니코틴 액상에 이상적",
    rdlTip:
      "RDL (중간 흡입): 편안한 흡입으로 더 많은 맛을 원하는 분들에게 적합",
    dlTip: "DL (폐폐): 최대 증기량과 맛의 강도",
    nicSaltTip: "니코틴 솔트는 20W 이하로 유지",
    powerTip: "최적의 지점을 찾을 때까지 전력을 서서히 높이세요",
    calculationError: "계산을 위해 최소 두 개의 값을 입력하세요",

    // 주요 계산기
    quantity: "양",
    finalQuantity: "원하는 최종 양",
    finalComposition: "최종 구성",
    nicotine: "니코틴",
    desiredNicotine: "원하는 니코틴 함량",
    availableBaseStrength: "사용 가능한 베이스 농도",
    nicotineComposition: "니코틴 구성",
    aromas: "향료",
    addAroma: "향료 % 추가",
    calculate: "계산",
    createMixLiquids: "액상 믹스 만들기",
    base1: "베이스 1",
    base2: "베이스 2",
    baseStrength: "베이스 농도",
    shareRecipe: "레시피 공유",
    recipeShared: "레시피가 공유되었습니다!",
    shareRecipeTitle: "액상 레시피 공유",
    shareRecipeText: "내 액상 레시피입니다:\n\n{details}",
    shareDialogTitle: "공유하기",
    noResultToShare: "공유할 결과가 없습니다. 먼저 레시피를 계산하세요.",
    shareError: "레시피 공유 중 오류가 발생했습니다.",
    shareSuccess: "레시피 공유됨",
    cookieConsentText:
      "Vape Formula Pro는 경험 향상과 맞춤형 광고를 위해 쿠키를 사용합니다.",
    cookieConsentDetails:
      "이 앱은 18세 이상만 사용할 수 있습니다. '동의'를 클릭하면 쿠키 사용에 동의하는 것입니다. 자세한 내용은 개인정보 처리방침을 참조하세요.",
    accept: "동의",

    // 계산 결과
    resultSummary:
      "{totalAmount}ml의 {vgPgRatio}를 만들기 위해 니코틴 {targetNic}mg이 필요합니다:",
    baseToUse: "사용할 총 베이스",
    baseVG: "베이스 VG",
    basePG: "베이스 PG",
    nicotineBase: "니코틴 베이스",
    flaconi: "병",
    from: "에서",
    aroma: "향료",
    withAroma: "{percentage}% 향료 포함",

    // 단순/고급 모드
    simpleMode: "단순 모드",
    advancedMode: "고급 모드",
    saveRecipe: "레시피 저장",
    exportToPDF: "PDF로 내보내기",
    recipeSaved: "레시피가 저장되었습니다!",
    neutralBase: "중성 베이스",
    toUse: "사용할",
    nicotineBase: "니코틴 베이스",
    bottles: "병",
    aromas: "향료",
    resultInfo: "양은 밀리리터와 그램으로 계산됩니다...",
    liquidComposition: "액상 구성",
    advancedDetails: "고급 세부사항",
    baseComposition: "베이스 구성",
    nicotineComposition: "니코틴 구성",
    aromaComposition: "향료 구성",
    totals: "합계",
    totalVG: "총 VG",
    totalPG: "총 PG",
    ofTheBase: "베이스의",
    ofAroma: "향료의",
    actualFinalComposition: "실제 최종 구성",
    nicotineBaseComposition: "니코틴 베이스 구성",
    nicotineVG: "니코틴 VG",
    nicotinePG: "니코틴 PG",
    totalOverall: "전체 합계",
    enterValue: "값 입력",
    mixBasesResult: "베이스 혼합 결과:",

    coilCalculator: "코일 계산기",
    targetResistanceMode: "목표 저항 모드",
    calculateResistanceMode: "저항 계산 모드",
    wireType: "와이어 종류",
    wireConfiguration: "와이어 구성",
    coilSetup: "코일 설정",
    ribbonThickness: "리본 두께",
    ribbonWidth: "리본 너비",
    wireDiameterAWG: "와이어 직경 (AWG)",
    wireDiameterMM: "와이어 직경 (mm)",
    targetResistance: "목표 저항",
    numberOfWraps: "감기 횟수",
    innerCoilDiameter: "코일 내경",
    legLength: "다리 길이",
    batteryVoltage: "배터리 전압",
    hideAdvancedInfo: "고급 정보 숨기기",
    showAdvancedInfo: "고급 정보 표시",
    calculateWraps: "감기 횟수 계산",
    calculateResistance: "저항 계산",
    wireLength: "와이어 길이",
    calculatedWraps: "계산된 감기 횟수",
    suggestedWraps: "제안된 감기 횟수",
    halfWrapOption: "반 감기 옵션",
    actualResistance: "실제 저항",
    calculatedResistance: "계산된 저항",
    legLoss: "다리 손실",
    heatCapacity: "열용량",
    temperatureFactor: "온도 계수",
    surfaceArea: "표면적",
    currentDraw: "전류 소비",
    power: "전력",
    warningHighLegLoss:
      "경고: 다리 손실이 너무 높습니다. 길이를 줄이는 것을 고려하세요.",
    warningSignificantLegLoss:
      "주의: 다리 손실이 상당합니다. 길이 최적화를 고려하세요.",

    totalVolumeD: "총 부피: {volume}ml ({grams}g)",
    finalCompositionD: "최종 구성: {ratio} VG/PG",
    finalStrengthD: "최종 농도: {strength}mg/ml",

    // 향료 희석
    calculateAromaDilution: "향료 희석 계산",
    aromaAmount: "향료 양",
    dilutionPercentage: "희석 비율",
    dilutionResult: "액상에서 {percentage}% 향료 농도를 얻으려면 총:",

    // 액상 실험실
    increaseReduceStrength: "농도 증가 또는 감소",
    currentBase: "현재 액상",
    currentNicotineStrength: "현재 니코틴 농도",
    desiredNicotineStrength: "원하는 니코틴 농도",
    calculateBase: "액상 계산",
    privacyPolicy: "개인정보 처리방침",
    viewPrivacyPolicy: "개인정보 처리방침 보기",

    // Shot/Mix 시리즈
    composeShotMixSeries: "Shot/Mix 시리즈 구성",
    shotMixFrom: "Shot/Mix 출처:",
    readyEliquidFrom: "최종 액상 양:",
    inhalationType: "흡입 방식",
    mtl: "입폐 (MTL)",
    dl: "폐폐 (DL)",
    shotMixResult:
      "{finalVolume}ml의 니코틴 농도 {desiredNicotine}mg/ml 완성 액상을 얻으려면:",
    yourAroma: "내 향료",
    neutralBase: "중성 베이스",

    // 설정
    language: "언어",
    vapingEducativo: "베이핑 교육",
    usoResponsabile: "책임감 있는 베이핑 사용",
    usoResponsabileContent:
      "베이핑은 장난이 아닙니다: 책임감 있게 사용한다는 것은 자신의 한계를 알고 필요를 존중하는 것을 의미합니다. 품질 좋은 기기만 사용하고 안전 지침을 따르세요. 맛에만 관심이 있다면 불필요한 위험을 피하기 위해 니코틴이 없는 액상 사용을 고려하세요. 베이핑은 전통적인 흡연보다 훨씬 덜 해롭고 점진적으로 금연하고자 하는 사람들에게 큰 도움이 될 수 있습니다.",
    usoNicotina: "니코틴 사용",
    usoNicotinaContent:
      "니코틴은 중독성이 있는 강력한 물질이지만 베이핑을 통해 현명하게 관리할 수 있습니다. 담배에서 베이핑으로 전환하는 경우, 평소 사용하던 것과 비슷한 니코틴 농도로 시작하세요. 점진적으로 수준을 낮춰 천천히 의존도를 줄이세요. 베이핑 덕분에 니코틴 수준을 정확하게 선택하고 점진적으로 제로까지 낮출 수 있어 전통적인 담배의 스트레스 없이 건강을 개선할 수 있습니다.",
    smettereDiscutetere: "전통적인 담배를 끊는 방법",
    smettereDiscutetereContent:
      "금연은 쉽지 않지만 베이핑은 효과적이고 덜 힘든 지원이 될 수 있습니다. 처음에는 전통적인 담배와 비슷한 니코틴 수준의 전자담배를 사용하면 전통적인 담배의 타르와 다른 유해 화학물질 없이 신체적 의존성을 충족시킬 수 있습니다. 안정화되면 니코틴 수준을 점진적으로 낮춰 제로까지 도달할 수 있습니다. 이러한 점진적 접근은 갑작스러운 충격 없이 흡연 욕구를 줄이고 점진적으로 삶의 질을 개선하는 데 도움이 됩니다.",

    faq: "자주 묻는 질문",
    faqList: [
      {
        q: "베이핑은 안전한가요?",
        a: "베이핑은 담배에 있는 타르와 다른 발암 화학물질을 생성하지 않기 때문에 전통적인 흡연보다 훨씬 덜 해롭다고 여겨집니다. 인증된 제품만 사용하고 전문가의 권장사항을 따르면, 베이핑은 금연을 원하는 사람들에게 더 안전한 대안이 될 수 있습니다.",
      },
      {
        q: "베이핑은 중독성이 있나요?",
        a: "네, 니코틴이 포함된 액상을 사용하면 베이핑도 중독될 수 있습니다. 하지만 베이핑을 통해 니코틴 수준을 조절하고 점진적으로 줄여 완전히 제거할 수 있어 완전한 금연을 위한 효과적인 도구가 될 수 있습니다.",
      },
      {
        q: "베이핑은 금연에 적합한가요?",
        a: "많은 사람들이 베이핑을 통해 성공적으로 금연했습니다. 중요한 것은 이를 전환 도구로 사용하여 니코틴을 점진적으로 줄여 완전히 제거하는 것입니다. 베이핑을 통해 섭취하는 니코틴량을 정확히 조절할 수 있어 금연 과정을 더 관리하기 쉽고 스트레스를 덜 받게 됩니다.",
      },
      {
        q: "베이핑의 장기적 영향은 무엇인가요?",
        a: "베이핑의 장기적 영향은 아직 연구 중이지만, 전통적인 담배 흡연보다 훨씬 덜 해롭다는 것이 널리 인정되고 있습니다. 타르와 다른 유독 물질을 제거함으로써 베이핑은 금연을 원하는 사람들에게 더 건강한 선택이 됩니다.",
      },
      {
        q: "베이핑이 전통적인 흡연에 비해 삶의 질을 개선하나요?",
        a: "네, 베이핑은 전통적인 흡연에 비해 삶의 질을 크게 개선합니다. 유해 화학물질에 대한 노출을 줄일 뿐만 아니라 니코틴 의존도를 점진적으로 제거하여 폐 건강과 호흡 능력을 개선할 수 있습니다.",
      },
    ],
    beneficiSmettere: "시간에 따른 금연의 이점",
    beneficiSmettereList: [
      "48시간 후: 체내의 니코틴이 제거되기 시작하고 미각과 후각이 개선되기 시작합니다.",
      "1주일 후: 혈중 일산화탄소 수치가 감소하여 혈액 순환과 호흡 능력이 개선됩니다.",
      "1개월 후: 폐 기능이 눈에 띄게 개선되고 폐 감염 위험이 감소합니다.",
      "3-9개월 후: 기침과 호흡 곤란이 감소하여 삶의 질이 더욱 개선됩니다.",
      "1년 후: 심장병 위험이 흡연 시보다 절반으로 감소합니다.",
      "5년 후: 뇌졸중 위험이 비흡연자와 비슷해집니다.",
      "10년 후: 폐암 위험이 크게 감소하여 흡연자의 절반 수준으로 낮아집니다.",
    ],
    mitiEFatti: "베이핑에 대한 미신과 사실",
    mitiEFattiList: [
      {
        mito: "베이핑은 흡연만큼 해롭다.",
        fatto:
          "연구에 따르면 베이핑은 전통적인 흡연보다 훨씬 덜 해롭습니다. 흡연은 7,000가지 이상의 화학물질을 생성하며 그 중 많은 것이 발암물질인 반면, 베이핑은 이 수를 크게 줄여 더 안전한 대안을 제공합니다.",
      },
      {
        mito: "베이핑은 흡연처럼 폐 문제를 일으킨다.",
        fatto:
          "베이핑은 담배의 폐 손상의 주요 원인인 타르를 생성하지 않습니다. 품질 좋은 액상을 사용하고 지침을 따르면 베이핑은 폐 건강에 훨씬 덜 해롭습니다.",
      },
      {
        mito: "베이핑은 금연에 도움이 되지 않는다.",
        fatto:
          "많은 사람들이 베이핑을 통해 성공적으로 금연했습니다. 올바른 접근법과 니코틴의 점진적 감소를 통해 베이핑은 전통적인 담배 의존도에서 벗어나 건강과 삶의 질을 개선하는 효과적인 도구가 될 수 있습니다.",
      },
    ],

    // 툴팁
    dilutionTooltip:
      "원하는 향료 농도 비율을 달성하기 위한 총 액상량을 계산하세요",
    nicotineTooltip:
      '0mg 액상을 원하거나 이미 니코틴이 포함된 베이스가 있다면 이 필드에 "0"을 입력하세요',
    aromaTooltip:
      "여기에 향료 희석 비율을 입력하고 액상에 넣을 ML을 확인하세요",
    resultTooltip:
      '총량 데이터는 해당 계산기의 "원하는 최종 양"에서 유용합니다',
    mixTooltip:
      "두 액상을 혼합하여 최종 농도와 구성을 계산합니다. 맛의 변화를 피하기 위해 향료가 없는 액상 사용을 권장합니다.",
    compositionTooltip:
      "최종 구성은 원하는 것과 약간 다를 수 있습니다. 이는 정상이며 모든 성분(베이스, 니코틴, 향료)의 구성과 보상을 고려하여 최상의 결과를 보장합니다. 계산은 원하는 구성에 최대한 가깝게 양을 최적화합니다.",
    resultInfo:
      "양은 밀리리터와 그램으로 계산됩니다. 그램 값은 계량컵이 없을 때 대체 측정 옵션을 제공하기 위해 공식 밀도 데이터를 기반으로 합니다",
    nicotineStrengthInfo:
      "증가의 경우에만 이 필드를 사용하고 그렇지 않으면 무시하세요",

    // 버튼과 작업
    saveRecipe: "레시피 저장",
    exportToPDF: "PDF로 내보내기",
    cancel: "취소",
    save: "저장",
    delete: "삭제",
    adjustNicotine: "니코틴 강도 조정",
    mixYourBases: "베이스 혼합",
    strength: "강도 (mg/ml)",
    savedRecipes: "저장된 레시피",
    finalNicotineStrength: "최종 니코틴 강도",

    // 메시지
    recipeSaved: "레시피가 저장되었습니다!",
    noSavedRecipes: "저장된 레시피가 없습니다.",
    nameYourRecipe: "레시피 이름 지정",

    // 측정 단위
    ml: "ml",
    mg: "mg",
    percentage: "%",

    // 기타
    vg: "VG",
    pg: "PG",
    createdOn: "생성일",
    increaseNicotineMessage:
      "액상의 니코틴을 {strength}mg로 증가시키려면 추가:",
    decreaseNicotineMessage:
      "액상의 니코틴을 {strength}mg로 감소시키려면 추가:",
    addNicotineBase:
      "현재 액상에 {strength}mg/ml의 {composition} 니코틴 베이스 {volume}ml ({flacons}개의 10ml 병{extraMl}) ({grams}g) 추가",
    addNeutralBase:
      "현재 액상에 {composition} 중성 베이스 (0mg/ml) {volume}ml ({grams}g) 추가",
    extraMl: " + {amount}ml",
    finalVolumeN: "최종 부피: {volume}ml ({grams}g)",
    finalVolumeL: "최종 부피: {volume}ml ({grams}g)",

    quickGuideTitle: "계산기 사용 가이드",
    modesExplained: "두 가지 계산 모드",
    targetModeTitle: "목표 모드",
    targetModeExplanation:
      "원하는 저항값을 알 때 이 모드를 사용하세요(예: 0.5Ω). 원하는 값을 입력하면 계산기가 알려줍니다:\n- 감아야 할 횟수\n- 필요한 와이어 길이\n- 실제 얻게 될 저항값",
    calculateModeTitle: "계산 모드",
    calculateModeExplanation:
      "감고 싶은 횟수를 알 때 이 모드를 사용하세요. 감기 횟수를 입력하고 얻게 될 저항값을 확인하세요. 공간이 제한적이거나 특정 감기 횟수로 작업하기를 선호할 때 유용합니다.",

    inputFieldsGuide: "입력 필드 가이드",
    innerDiameterTitle: "코일 내경",
    innerDiameterExplanation:
      "와이어를 감을 직경입니다. 일반적으로 감기에 사용할 드라이버의 직경과 일치합니다.",
    legLengthTitle: "다리 길이",
    legLengthExplanation:
      "단자에 삽입할 저항의 '다리'. 권장: 손실을 최소화하기 위해 5-6mm",

    advancedExplained: "고급 모드 설명",
    powerCalcsTitle: "전력 계산",
    powerCalcsExplanation:
      "- 배터리 전압: 완전 충전 시 일반적으로 4.2V\n- 전류 소비: 코일을 통과할 전류량\n- 전력: 코일이 발생시킬 실제 전력",
    thermalFactorsTitle: "열적 요소",
    thermalFactorsExplanation:
      "- 열용량: 코일이 축적할 수 있는 열량\n- 표면적: 액상과의 접촉 면적\n- 온도 계수: 재료가 열에 반응하는 방식",

    resultsExplained: "결과 해석 방법",
    basicResultsTitle: "기본 결과",
    basicResultsList:
      "와이어 길이: 필요한 총 와이어 길이\n계산된 감기 횟수: 정확한 감기 횟수\n제안된 감기 횟수: 실용적인 반올림 횟수\n반 감기 옵션: 미세 조정을 위한 대안\n실제 저항: 측정하게 될 최종값",

    warningsTitle: "중요 경고",
    warningsList:
      "다리 손실 > 30%: 다리가 너무 깁니다, 줄이세요\n다리 손실 > 20%: 최적화를 고려하세요\n실제 저항은 실전에서 약간 다를 수 있습니다",

    practicalTips: "실용적인 팁",
    practicalTipsList:
      "더 나은 안정성을 위해 Kanthal A1 와이어로 시작하세요\n초보자를 위한 목표: 0.5Ω에서 1.5Ω 사이\n항상 옴미터로 저항을 측정하세요\n듀얼 코일에서 총 저항은 단일 코일의 절반이 됩니다",
  },
};

export default translations;